{
    "data": [
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T00:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T00:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T00:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T00:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T00:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T00:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T00:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T00:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T00:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T00:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T00:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T00:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T00:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T00:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T00:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T00:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T00:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T00:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T00:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T00:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T00:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T00:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T00:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T00:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T00:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T00:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T00:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T01:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T01:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T01:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T01:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T01:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T01:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T01:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T01:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T01:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T01:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T01:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T01:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T01:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T01:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T01:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T01:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T01:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T01:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T01:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T01:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T01:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T01:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T01:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T01:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T01:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T01:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T01:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T01:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T01:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T01:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T01:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T01:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T01:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T01:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T01:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T01:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T01:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T01:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T02:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T02:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T02:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T02:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T02:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T02:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T02:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T02:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T02:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T02:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T02:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T02:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T02:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T02:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T02:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T02:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T02:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T02:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T02:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T02:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T02:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T02:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T02:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T02:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T02:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T02:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T02:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T02:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T02:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T02:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T02:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T03:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T03:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T03:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T03:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T03:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T03:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T03:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T03:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T03:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T03:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T03:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T03:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T03:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T03:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T03:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T03:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T03:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T03:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T03:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T03:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T03:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T03:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T03:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T03:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T03:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T03:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T03:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T03:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T03:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T03:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T03:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T03:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T03:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T03:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T03:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T03:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T03:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T03:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T04:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T04:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T04:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T04:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T04:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T04:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T04:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T04:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T04:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T04:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T04:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T04:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T04:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T04:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T04:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T04:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T04:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T04:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T04:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T04:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T04:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T04:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T04:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T04:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T04:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T04:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T04:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T04:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T04:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T04:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T04:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T05:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T05:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T05:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T05:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T05:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T05:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T05:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T05:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T05:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T05:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T05:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T05:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T05:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T05:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T05:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T05:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T05:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T05:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T05:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T05:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T05:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T05:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T05:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T05:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T05:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T05:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T05:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T06:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T06:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T06:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T06:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T06:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T06:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T06:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T06:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T06:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T06:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T06:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T06:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T06:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T06:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T06:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T06:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T06:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T06:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T06:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T06:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T06:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T06:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T06:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T06:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T06:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T06:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T06:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T06:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T06:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T06:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T06:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T06:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T06:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T06:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T06:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T06:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T06:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T07:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T07:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T07:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T07:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T07:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T07:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T07:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T07:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T07:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T07:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T07:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T07:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T07:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T07:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T07:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T07:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T07:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T07:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T07:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T07:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T07:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T07:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T07:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T07:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T07:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T08:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T08:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T08:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T08:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T08:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T08:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T08:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T08:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T08:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T08:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T08:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T08:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T08:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T08:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T08:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T08:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T08:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T08:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T08:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T08:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T08:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T08:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T08:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T08:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T08:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T08:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T08:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T08:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T09:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T09:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T09:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T09:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T09:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T09:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T09:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T09:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T09:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T09:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T09:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T09:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T09:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T09:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T09:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T09:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T09:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T09:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T09:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T09:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T09:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T09:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T09:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T09:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T09:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T09:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T09:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T09:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T09:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T09:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T10:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T10:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T10:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T10:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T10:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T10:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T10:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T10:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T10:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T10:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T10:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T10:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T10:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T10:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T10:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T10:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T10:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T10:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T10:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T10:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T10:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T10:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T10:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T10:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T10:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T10:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T10:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T10:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T10:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T10:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T10:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T11:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T11:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T11:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T11:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T11:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T11:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T11:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T11:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T11:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T11:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T11:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T11:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T11:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T11:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T11:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T11:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T11:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T11:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T11:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T11:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T11:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T11:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T11:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T11:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T11:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T11:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T11:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T12:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T12:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T12:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T12:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T12:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T12:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T12:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T12:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T12:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T12:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T12:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T12:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T12:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T12:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T12:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T12:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T12:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T12:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T12:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T12:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T12:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T12:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T12:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T12:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T12:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T12:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T12:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T12:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T12:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T12:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T12:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T12:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T12:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T12:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T13:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T13:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T13:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T13:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T13:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T13:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T13:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T13:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T13:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T13:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T13:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T13:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T13:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T13:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T13:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T13:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T13:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T13:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T13:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T13:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T13:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T13:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T13:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T13:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T13:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T13:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T13:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T13:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T13:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T13:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T13:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T13:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T14:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T14:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T14:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T14:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T14:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T14:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T14:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T14:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T14:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T14:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T14:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T14:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T14:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T14:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T14:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T14:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T14:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T14:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T14:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T14:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T14:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T14:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T14:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T14:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T14:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T14:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T14:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T14:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T14:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T14:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T14:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T15:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T15:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T15:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T15:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T15:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T15:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T15:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T15:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T15:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T15:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T15:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T15:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T15:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T15:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T15:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T15:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T15:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T15:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T15:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T15:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T15:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T15:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T15:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T15:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T15:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T15:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T15:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T15:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T15:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T15:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T15:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T15:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T15:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T16:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T16:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T16:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T16:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T16:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T16:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T16:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T16:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T16:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T16:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T16:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T16:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T16:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T16:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T16:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T16:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T16:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T16:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T16:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T16:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T16:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T16:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T16:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T16:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T16:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T16:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T16:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T16:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T16:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T16:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T17:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T17:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T17:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T17:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T17:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T17:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T17:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T17:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T17:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T17:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T17:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T17:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T17:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T17:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T17:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T17:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T17:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T17:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T17:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T17:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T17:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T17:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T17:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T17:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T17:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T17:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T17:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T17:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T17:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T17:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T17:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T18:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T18:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T18:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T18:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T18:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T18:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T18:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T18:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T18:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T18:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T18:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T18:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T18:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T18:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T18:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T18:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T18:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T18:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T18:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T18:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T18:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T18:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T18:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T18:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T18:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T18:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T18:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T18:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T18:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T18:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T18:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T18:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T18:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T19:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T19:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T19:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T19:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T19:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T19:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T19:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T19:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T19:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T19:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T19:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T19:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T19:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T19:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T19:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T19:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T19:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T19:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T19:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T19:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T19:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T19:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T19:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T19:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T19:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T19:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T19:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T19:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T19:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T19:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T19:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T19:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T19:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T19:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T19:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T19:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T19:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T19:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T20:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T20:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T20:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T20:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T20:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T20:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T20:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T20:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T20:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T20:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T20:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T20:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T20:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T20:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T20:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T20:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T20:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T20:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T20:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T20:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T20:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T20:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T20:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T21:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T21:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T21:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T21:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T21:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T21:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T21:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T21:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T21:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T21:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T21:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T21:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T21:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T21:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T21:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T21:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T21:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T21:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T21:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T21:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T21:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T21:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T21:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T21:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T21:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T21:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T21:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T21:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T21:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T22:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T22:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T22:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T22:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T22:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T22:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T22:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T22:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T22:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T22:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T22:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T22:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T22:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T22:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T22:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T22:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T22:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T22:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T22:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T22:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T22:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T22:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T22:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T22:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T22:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T22:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T22:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T22:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T22:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T22:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T22:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T22:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T22:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T22:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T22:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T22:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T23:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T23:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T23:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T23:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T23:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T23:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T23:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T23:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T23:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T23:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T23:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T23:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T23:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T23:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T23:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T23:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T23:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T23:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T23:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T23:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T23:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T23:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T23:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T23:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T23:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T23:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T23:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T23:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T23:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-01T23:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-01T23:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-01T23:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T00:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T00:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T00:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T00:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T00:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T00:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T00:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T00:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T00:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T00:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T00:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T00:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T00:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T00:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T00:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T00:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T00:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T00:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T00:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T00:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T00:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T00:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T00:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T00:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T00:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T00:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T00:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T00:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T00:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T00:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T00:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T01:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T01:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T01:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T01:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T01:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T01:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T01:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T01:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T01:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T01:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T01:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T01:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T01:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T01:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T01:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T01:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T01:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T01:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T01:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T01:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T01:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T01:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T01:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T01:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T01:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T01:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T01:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T01:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T01:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T01:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T01:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T02:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T02:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T02:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T02:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T02:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T02:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T02:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T02:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T02:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T02:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T02:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T02:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T02:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T02:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T02:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T02:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T02:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T02:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T02:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T02:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T02:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T02:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T02:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T02:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T02:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T02:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T02:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T02:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T02:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T02:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T02:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T02:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T02:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T02:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T02:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T02:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T02:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T02:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T03:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T03:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T03:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T03:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T03:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T03:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T03:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T03:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T03:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T03:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T03:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T03:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T03:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T03:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T03:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T03:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T03:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T03:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T03:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T03:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T03:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T03:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T03:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T03:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T03:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T03:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T03:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T03:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T03:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T03:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T03:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T03:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T03:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T04:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T04:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T04:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T04:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T04:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T04:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T04:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T04:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T04:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T04:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T04:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T04:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T04:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T04:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T04:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T04:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T04:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T04:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T04:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T04:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T04:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T04:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T04:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T04:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T04:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T04:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T04:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T05:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T05:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T05:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T05:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T05:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T05:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T05:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T05:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T05:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T05:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T05:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T05:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T05:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T05:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T05:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T05:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T05:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T05:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T05:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T05:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T05:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T05:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T05:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T05:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T05:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T05:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T05:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T05:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T05:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T05:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T05:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T05:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T05:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T05:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T05:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T05:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T05:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T05:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T05:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T05:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T05:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T05:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T06:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T06:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T06:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T06:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T06:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T06:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T06:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T06:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T06:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T06:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T06:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T06:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T06:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T06:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T06:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T06:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T06:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T06:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T06:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T06:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T06:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T06:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T06:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T06:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T06:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T06:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T06:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T06:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T06:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T06:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T06:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T07:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T07:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T07:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T07:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T07:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T07:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T07:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T07:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T07:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T07:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T07:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T07:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T07:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T07:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T07:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T07:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T07:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T07:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T07:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T07:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T07:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T07:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T07:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T07:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T07:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T07:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T07:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T07:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T07:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T07:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T07:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T07:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T08:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T08:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T08:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T08:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T08:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T08:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T08:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T08:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T08:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T08:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T08:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T08:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T08:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T08:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T08:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T08:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T08:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T08:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T08:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T08:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T08:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T08:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T08:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T08:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T08:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T08:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T08:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T08:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T08:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T08:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T08:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T08:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T08:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T08:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T08:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T08:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T08:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T08:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T08:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T08:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T09:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T09:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T09:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T09:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T09:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T09:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T09:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T09:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T09:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T09:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T09:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T09:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T09:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T09:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T09:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T09:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T09:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T09:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T09:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T09:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T09:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T09:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T09:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T09:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T09:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T09:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T09:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T09:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T09:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T09:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T09:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T09:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T09:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T10:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T10:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T10:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T10:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T10:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T10:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T10:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T10:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T10:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T10:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T10:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T10:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T10:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T10:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T10:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T10:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T10:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T10:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T10:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T10:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T10:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T10:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T10:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T10:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T10:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T10:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T10:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T10:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T10:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T10:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T10:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T10:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T10:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T10:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T10:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T10:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T10:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T10:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T11:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T11:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T11:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T11:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T11:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T11:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T11:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T11:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T11:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T11:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T11:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T11:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T11:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T11:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T11:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T11:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T11:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T11:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T11:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T11:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T11:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T11:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T11:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T11:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T11:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T11:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T11:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T11:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T11:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T11:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T11:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T11:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T11:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T11:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T11:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T11:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T12:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T12:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T12:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T12:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T12:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T12:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T12:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T12:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T12:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T12:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T12:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T12:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T12:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T12:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T12:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T12:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T12:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T12:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T12:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T12:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T12:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T12:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T12:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T12:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T12:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T12:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T12:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T12:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T12:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T12:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T12:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T12:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T12:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T12:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T12:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T12:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T13:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T13:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T13:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T13:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T13:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T13:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T13:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T13:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T13:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T13:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T13:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T13:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T13:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T13:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T13:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T13:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T13:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T13:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T13:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T13:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T13:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T13:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T13:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T13:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T13:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T13:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T13:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T13:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T13:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T13:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T14:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T14:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T14:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T14:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T14:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T14:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T14:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T14:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T14:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T14:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T14:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T14:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T14:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T14:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T14:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T14:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T14:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T14:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T14:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T14:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T14:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T14:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T14:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T14:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T14:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T14:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T14:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T14:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T14:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T14:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T14:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T14:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T14:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T15:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T15:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T15:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T15:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T15:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T15:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T15:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T15:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T15:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T15:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T15:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T15:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T15:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T15:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T15:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T15:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T15:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T15:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T15:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T15:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T15:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T15:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T15:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T15:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T15:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T15:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T15:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T15:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T15:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T15:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T15:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T15:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T15:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T15:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T15:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T15:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T15:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T15:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T16:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T16:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T16:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T16:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T16:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T16:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T16:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T16:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T16:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T16:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T16:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T16:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T16:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T16:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T16:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T16:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T16:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T16:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T16:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T16:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T16:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T16:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T16:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T16:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T16:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T16:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T16:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T16:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T16:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T16:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T16:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T16:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T17:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T17:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T17:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T17:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T17:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T17:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T17:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T17:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T17:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T17:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T17:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T17:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T17:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T17:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T17:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T17:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T17:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T17:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T17:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T17:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T17:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T17:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T17:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T17:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T17:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T17:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T17:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T17:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T17:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T18:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T18:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T18:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T18:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T18:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T18:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T18:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T18:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T18:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T18:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T18:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T18:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T18:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T18:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T18:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T18:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T18:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T18:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T18:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T18:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T18:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T18:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T18:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T18:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T18:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T18:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T18:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T19:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T19:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T19:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T19:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T19:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T19:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T19:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T19:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T19:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T19:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T19:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T19:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T19:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T19:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T19:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T19:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T19:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T19:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T19:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T19:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T19:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T19:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T19:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T19:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T19:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T20:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T20:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T20:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T20:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T20:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T20:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T20:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T20:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T20:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T20:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T20:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T20:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T20:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T20:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T20:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T20:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T20:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T20:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T20:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T20:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T20:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T20:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T20:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T20:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T20:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T20:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T20:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T20:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T20:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T20:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T20:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T20:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T20:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T20:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T20:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T21:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T21:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T21:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T21:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T21:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T21:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T21:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T21:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T21:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T21:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T21:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T21:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T21:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T21:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T21:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T21:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T21:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T21:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T21:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T21:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T21:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T21:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T21:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T21:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T21:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T21:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T21:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T21:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T21:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T21:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T21:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T21:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T21:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T21:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T21:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T21:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T21:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T21:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T21:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T21:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T21:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T21:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T22:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T22:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T22:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T22:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T22:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T22:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T22:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T22:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T22:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T22:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T22:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T22:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T22:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T22:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T22:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T22:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T22:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T22:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T22:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T22:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T22:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T22:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T22:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T22:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T22:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T22:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T22:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T22:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T22:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T22:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T22:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T22:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T22:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T22:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T23:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T23:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T23:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T23:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T23:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T23:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T23:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T23:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T23:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T23:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T23:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T23:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T23:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T23:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T23:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T23:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T23:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T23:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T23:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T23:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T23:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T23:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T23:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T23:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T23:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T23:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T23:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T23:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T23:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T23:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T23:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T23:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T23:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T23:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T23:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-02T23:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T23:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T23:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-02T23:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-02T23:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T00:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T00:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T00:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T00:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T00:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T00:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T00:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T00:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T00:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T00:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T00:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T00:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T00:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T00:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T00:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T00:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T00:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T00:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T00:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T00:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T00:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T00:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T00:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T00:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T00:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T00:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T00:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T00:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T00:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T00:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T00:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T01:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T01:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T01:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T01:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T01:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T01:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T01:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T01:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T01:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T01:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T01:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T01:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T01:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T01:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T01:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T01:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T01:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T01:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T01:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T01:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T01:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T01:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T01:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T01:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T01:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T01:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T01:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T01:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T01:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T01:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T01:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T01:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T02:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T02:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T02:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T02:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T02:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T02:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T02:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T02:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T02:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T02:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T02:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T02:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T02:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T02:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T02:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T02:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T02:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T02:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T02:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T02:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T02:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T02:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T02:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T02:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T02:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T02:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T02:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T02:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T02:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T02:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T02:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T02:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T02:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T02:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T02:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T02:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T03:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T03:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T03:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T03:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T03:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T03:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T03:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T03:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T03:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T03:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T03:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T03:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T03:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T03:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T03:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T03:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T03:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T03:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T03:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T03:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T03:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T03:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T03:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T03:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T03:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T03:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T03:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T03:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T03:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T03:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T03:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T03:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T03:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T03:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T04:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T04:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T04:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T04:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T04:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T04:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T04:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T04:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T04:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T04:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T04:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T04:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T04:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T04:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T04:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T04:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T04:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T04:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T04:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T04:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T04:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T04:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T04:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T04:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T04:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T04:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T04:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T04:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T04:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T05:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T05:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T05:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T05:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T05:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T05:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T05:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T05:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T05:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T05:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T05:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T05:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T05:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T05:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T05:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T05:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T05:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T05:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T05:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T05:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T05:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T05:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T05:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T05:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T05:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T05:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T05:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T05:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T05:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T05:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T05:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T05:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T05:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T05:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T06:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T06:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T06:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T06:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T06:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T06:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T06:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T06:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T06:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T06:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T06:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T06:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T06:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T06:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T06:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T06:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T06:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T06:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T06:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T06:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T06:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T06:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T06:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T06:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T06:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T06:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T06:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T06:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T06:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T06:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T06:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T06:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T06:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T07:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T07:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T07:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T07:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T07:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T07:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T07:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T07:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T07:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T07:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T07:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T07:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T07:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T07:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T07:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T07:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T07:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T07:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T07:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T07:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T07:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T07:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T07:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T07:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T07:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T07:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T07:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T07:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T07:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T07:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T08:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T08:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T08:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T08:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T08:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T08:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T08:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T08:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T08:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T08:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T08:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T08:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T08:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T08:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T08:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T08:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T08:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T08:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T08:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T08:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T08:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T08:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T08:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T08:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T08:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T08:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T08:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T08:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T08:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T08:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T08:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T08:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T09:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T09:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T09:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T09:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T09:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T09:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T09:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T09:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T09:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T09:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T09:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T09:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T09:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T09:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T09:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T09:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T09:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T09:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T09:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T09:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T09:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T09:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T09:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T09:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T09:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T09:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T09:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T09:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T09:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T09:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T09:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T09:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T09:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T10:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T10:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T10:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T10:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T10:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T10:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T10:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T10:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T10:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T10:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T10:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T10:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T10:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T10:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T10:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T10:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T10:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T10:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T10:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T10:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T10:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T10:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T10:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T10:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T10:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T10:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T10:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T10:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T10:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T10:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T11:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T11:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T11:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T11:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T11:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T11:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T11:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T11:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T11:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T11:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T11:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T11:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T11:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T11:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T11:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T11:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T11:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T11:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T11:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T11:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T11:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T11:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T11:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T11:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T11:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T11:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T11:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T11:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T11:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T11:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T11:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T11:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T11:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T11:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T11:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T11:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T12:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T12:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T12:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T12:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T12:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T12:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T12:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T12:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T12:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T12:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T12:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T12:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T12:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T12:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T12:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T12:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T12:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T12:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T12:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T12:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T12:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T12:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T12:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T13:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T13:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T13:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T13:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T13:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T13:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T13:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T13:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T13:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T13:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T13:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T13:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T13:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T13:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T13:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T13:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T13:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T13:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T13:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T13:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T13:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T13:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T13:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T13:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T13:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T13:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T13:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T13:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T13:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T13:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T13:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T13:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T13:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T14:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T14:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T14:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T14:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T14:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T14:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T14:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T14:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T14:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T14:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T14:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T14:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T14:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T14:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T14:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T14:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T14:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T14:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T14:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T14:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T14:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T14:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T14:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T14:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T14:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T14:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T14:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T14:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T14:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T14:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T14:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T14:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T14:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T14:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T14:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T14:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T15:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T15:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T15:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T15:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T15:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T15:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T15:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T15:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T15:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T15:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T15:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T15:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T15:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T15:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T15:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T15:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T15:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T15:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T15:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T15:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T15:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T15:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T15:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T15:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T15:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T15:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T15:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T15:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T15:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T15:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T15:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T15:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T15:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T15:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T15:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T16:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T16:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T16:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T16:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T16:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T16:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T16:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T16:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T16:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T16:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T16:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T16:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T16:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T16:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T16:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T16:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T16:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T16:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T16:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T16:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T16:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T16:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T16:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T16:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T16:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T16:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T16:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T16:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T16:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T16:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T16:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T16:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T17:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T17:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T17:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T17:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T17:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T17:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T17:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T17:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T17:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T17:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T17:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T17:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T17:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T17:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T17:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T17:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T17:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T17:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T17:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T17:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T17:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T17:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T17:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T17:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T17:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T17:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T17:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T17:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T17:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T17:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T17:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T17:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T18:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T18:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T18:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T18:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T18:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T18:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T18:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T18:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T18:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T18:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T18:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T18:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T18:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T18:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T18:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T18:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T18:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T18:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T18:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T18:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T18:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T18:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T18:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T18:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T18:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T18:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T18:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T18:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T18:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T18:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T19:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T19:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T19:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T19:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T19:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T19:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T19:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T19:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T19:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T19:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T19:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T19:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T19:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T19:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T19:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T19:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T19:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T19:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T19:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T19:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T19:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T19:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T19:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T19:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T19:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T19:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T19:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T19:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T19:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T19:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T19:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T19:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T19:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T19:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T19:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T19:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T19:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T19:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T19:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T19:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T19:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T19:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T19:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T20:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T20:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T20:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T20:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T20:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T20:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T20:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T20:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T20:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T20:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T20:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T20:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T20:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T20:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T20:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T20:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T20:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T20:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T20:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T20:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T20:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T20:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T20:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T20:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T20:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T20:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T20:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T20:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T21:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T21:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T21:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T21:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T21:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T21:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T21:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T21:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T21:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T21:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T21:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T21:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T21:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T21:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T21:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T21:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T21:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T21:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T21:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T21:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T21:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T21:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T21:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T21:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T21:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T21:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T22:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T22:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T22:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T22:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T22:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T22:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T22:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T22:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T22:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T22:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T22:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T22:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T22:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T22:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T22:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T22:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T22:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T22:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T22:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T22:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T22:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T22:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T22:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T22:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T22:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T22:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T22:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T22:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T22:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T22:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T22:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T22:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T23:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T23:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T23:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T23:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T23:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T23:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T23:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T23:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T23:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T23:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T23:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T23:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T23:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T23:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T23:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T23:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T23:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T23:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T23:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T23:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T23:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T23:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T23:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T23:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T23:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T23:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T23:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T23:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T23:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-03T23:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T23:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-03T23:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-03T23:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T00:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T00:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T00:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T00:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T00:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T00:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T00:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T00:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T00:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T00:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T00:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T00:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T00:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T00:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T00:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T00:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T00:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T00:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T00:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T00:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T00:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T00:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T00:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T00:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T00:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T00:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T00:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T00:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T00:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T00:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T00:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T00:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T01:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T01:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T01:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T01:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T01:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T01:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T01:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T01:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T01:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T01:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T01:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T01:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T01:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T01:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T01:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T01:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T01:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T01:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T01:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T01:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T01:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T01:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T01:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T01:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T01:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T01:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T01:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T01:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T01:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T01:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T01:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T01:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T01:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T01:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T01:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T02:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T02:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T02:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T02:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T02:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T02:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T02:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T02:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T02:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T02:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T02:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T02:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T02:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T02:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T02:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T02:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T02:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T02:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T02:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T02:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T02:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T02:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T02:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T02:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T02:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T02:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T02:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T02:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T02:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T02:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T02:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T02:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T02:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T02:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T02:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T02:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T02:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T03:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T03:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T03:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T03:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T03:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T03:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T03:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T03:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T03:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T03:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T03:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T03:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T03:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T03:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T03:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T03:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T03:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T03:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T03:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T03:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T03:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T03:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T03:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T03:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T03:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T03:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T03:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T03:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T03:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T03:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T03:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T03:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T03:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T03:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T03:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T03:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T04:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T04:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T04:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T04:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T04:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T04:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T04:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T04:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T04:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T04:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T04:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T04:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T04:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T04:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T04:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T04:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T04:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T04:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T04:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T04:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T04:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T04:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T04:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T04:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T04:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T04:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T04:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T04:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T04:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T04:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T05:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T05:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T05:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T05:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T05:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T05:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T05:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T05:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T05:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T05:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T05:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T05:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T05:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T05:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T05:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T05:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T05:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T05:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T05:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T05:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T05:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T05:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T05:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T05:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T05:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T05:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T05:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T05:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T05:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T05:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T05:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T05:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T05:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T05:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T05:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T05:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T06:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T06:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T06:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T06:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T06:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T06:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T06:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T06:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T06:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T06:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T06:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T06:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T06:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T06:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T06:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T06:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T06:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T06:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T06:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T06:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T06:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T06:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T06:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T06:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T06:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T06:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T06:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T07:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T07:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T07:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T07:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T07:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T07:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T07:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T07:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T07:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T07:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T07:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T07:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T07:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T07:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T07:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T07:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T07:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T07:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T07:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T07:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T07:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T07:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T07:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T07:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T07:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T07:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T07:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T07:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T07:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T07:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T07:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T08:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T08:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T08:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T08:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T08:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T08:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T08:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T08:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T08:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T08:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T08:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T08:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T08:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T08:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T08:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T08:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T08:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T08:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T08:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T08:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T08:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T08:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T08:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T08:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T08:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T08:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T08:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T08:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T08:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T08:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T08:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T08:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T08:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T09:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T09:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T09:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T09:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T09:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T09:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T09:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T09:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T09:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T09:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T09:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T09:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T09:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T09:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T09:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T09:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T09:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T09:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T09:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T09:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T09:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T09:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T09:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T09:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T09:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T09:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T09:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T09:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T09:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T09:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T09:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T09:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T09:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T09:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T09:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T09:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T10:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T10:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T10:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T10:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T10:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T10:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T10:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T10:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T10:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T10:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T10:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T10:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T10:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T10:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T10:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T10:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T10:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T10:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T10:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T10:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T10:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T10:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T10:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T10:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T10:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T10:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T10:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T11:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T11:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T11:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T11:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T11:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T11:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T11:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T11:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T11:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T11:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T11:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T11:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T11:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T11:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T11:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T11:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T11:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T11:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T11:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T11:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T11:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T11:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T11:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T11:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T11:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T11:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T12:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T12:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T12:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T12:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T12:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T12:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T12:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T12:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T12:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T12:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T12:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T12:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T12:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T12:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T12:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T12:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T12:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T12:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T12:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T12:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T12:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T12:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T12:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T12:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T12:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T12:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T12:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T12:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T12:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T12:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T12:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T12:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T12:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T12:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T12:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T12:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T12:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T12:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T13:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T13:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T13:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T13:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T13:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T13:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T13:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T13:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T13:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T13:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T13:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T13:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T13:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T13:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T13:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T13:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T13:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T13:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T13:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T13:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T13:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T13:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T13:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T13:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T13:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T13:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T13:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T13:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T13:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T13:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T13:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T13:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T13:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T13:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T13:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T14:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T14:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T14:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T14:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T14:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T14:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T14:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T14:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T14:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T14:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T14:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T14:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T14:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T14:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T14:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T14:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T14:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T14:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T14:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T14:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T14:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T14:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T14:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T14:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T14:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T14:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T14:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T14:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T14:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T14:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T14:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T14:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T14:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T14:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T15:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T15:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T15:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T15:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T15:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T15:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T15:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T15:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T15:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T15:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T15:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T15:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T15:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T15:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T15:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T15:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T15:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T15:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T15:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T15:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T15:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T15:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T15:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T15:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T15:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T15:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T15:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T15:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T15:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T15:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T15:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T15:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T15:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T15:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T15:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T15:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T16:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T16:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T16:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T16:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T16:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T16:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T16:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T16:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T16:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T16:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T16:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T16:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T16:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T16:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T16:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T16:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T16:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T16:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T16:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T16:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T16:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T16:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T16:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T16:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T16:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T16:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T16:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T16:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T16:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T16:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T16:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T16:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T16:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T16:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T16:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T17:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T17:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T17:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T17:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T17:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T17:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T17:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T17:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T17:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T17:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T17:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T17:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T17:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T17:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T17:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T17:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T17:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T17:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T17:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T17:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T17:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T17:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T17:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T17:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T17:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T18:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T18:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T18:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T18:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T18:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T18:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T18:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T18:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T18:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T18:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T18:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T18:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T18:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T18:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T18:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T18:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T18:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T18:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T18:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T18:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T18:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T18:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T18:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T18:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T18:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T18:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T18:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T18:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T18:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T18:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T18:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T18:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T18:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T18:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T18:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T18:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T18:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T18:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T19:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T19:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T19:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T19:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T19:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T19:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T19:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T19:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T19:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T19:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T19:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T19:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T19:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T19:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T19:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T19:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T19:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T19:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T19:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T19:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T19:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T19:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T19:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T19:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T19:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T19:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T19:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T19:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T19:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T19:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T19:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T19:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T19:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T19:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T19:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T19:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T19:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T19:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T19:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T19:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T19:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T19:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T19:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T19:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T20:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T20:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T20:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T20:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T20:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T20:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T20:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T20:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T20:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T20:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T20:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T20:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T20:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T20:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T20:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T20:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T20:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T20:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T20:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T20:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T20:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T20:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T20:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T20:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T21:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T21:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T21:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T21:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T21:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T21:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T21:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T21:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T21:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T21:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T21:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T21:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T21:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T21:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T21:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T21:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T21:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T21:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T21:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T21:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T21:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T21:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T21:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T21:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T21:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T21:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T22:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T22:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T22:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T22:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T22:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T22:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T22:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T22:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T22:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T22:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T22:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T22:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T22:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T22:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T22:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T22:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T22:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T22:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T22:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T22:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T22:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T22:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T22:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T22:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T22:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T22:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T22:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T22:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T22:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T22:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T22:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T22:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T22:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T22:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T23:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T23:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T23:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T23:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T23:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T23:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T23:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T23:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T23:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T23:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T23:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T23:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T23:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T23:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T23:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T23:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T23:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T23:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T23:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T23:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T23:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T23:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T23:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T23:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T23:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T23:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T23:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T23:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T23:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T23:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T23:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T23:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-04T23:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-04T23:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-04T23:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T00:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T00:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T00:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T00:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T00:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T00:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T00:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T00:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T00:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T00:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T00:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T00:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T00:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T00:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T00:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T00:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T00:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T00:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T00:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T00:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T00:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T00:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T01:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T01:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T01:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T01:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T01:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T01:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T01:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T01:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T01:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T01:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T01:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T01:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T01:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T01:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T01:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T01:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T01:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T01:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T01:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T01:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T01:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T01:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T01:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T01:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T01:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T01:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T01:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T01:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T01:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T02:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T02:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T02:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T02:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T02:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T02:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T02:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T02:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T02:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T02:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T02:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T02:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T02:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T02:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T02:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T02:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T02:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T02:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T02:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T02:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T02:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T02:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T02:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T02:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T02:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T03:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T03:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T03:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T03:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T03:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T03:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T03:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T03:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T03:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T03:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T03:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T03:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T03:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T03:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T03:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T03:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T03:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T03:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T03:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T03:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T03:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T03:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T03:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T03:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T03:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T03:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T03:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T03:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T03:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T03:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T03:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T03:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T04:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T04:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T04:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T04:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T04:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T04:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T04:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T04:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T04:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T04:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T04:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T04:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T04:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T04:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T04:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T04:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T04:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T04:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T04:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T04:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T04:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T04:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T04:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T04:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T04:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T04:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T04:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T04:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T04:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T04:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T04:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T04:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T04:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T04:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T04:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T04:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T05:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T05:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T05:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T05:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T05:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T05:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T05:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T05:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T05:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T05:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T05:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T05:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T05:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T05:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T05:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T05:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T05:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T05:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T05:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T05:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T05:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T05:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T05:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T05:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T05:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T05:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T05:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T05:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T05:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T05:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T05:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T05:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T05:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T05:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T05:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T06:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T06:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T06:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T06:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T06:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T06:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T06:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T06:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T06:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T06:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T06:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T06:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T06:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T06:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T06:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T06:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T06:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T06:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T06:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T06:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T06:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T06:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T06:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T06:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T06:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T06:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T06:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T06:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T07:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T07:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T07:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T07:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T07:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T07:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T07:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T07:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T07:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T07:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T07:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T07:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T07:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T07:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T07:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T07:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T07:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T07:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T07:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T07:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T07:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T07:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T07:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T07:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T07:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T07:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T07:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T07:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T07:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T08:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T08:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T08:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T08:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T08:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T08:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T08:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T08:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T08:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T08:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T08:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T08:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T08:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T08:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T08:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T08:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T08:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T08:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T08:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T08:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T08:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T08:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T08:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T08:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T08:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T08:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T08:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T08:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T08:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T08:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T08:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T08:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T09:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T09:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T09:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T09:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T09:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T09:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T09:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T09:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T09:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T09:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T09:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T09:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T09:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T09:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T09:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T09:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T09:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T09:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T09:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T09:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T09:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T09:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T09:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T09:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T09:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T09:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T09:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T09:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T09:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T09:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T09:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T09:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T09:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T09:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T09:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T09:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T09:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T09:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T09:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T09:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T10:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T10:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T10:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T10:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T10:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T10:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T10:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T10:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T10:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T10:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T10:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T10:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T10:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T10:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T10:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T10:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T10:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T10:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T10:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T10:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T10:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T10:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T10:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T10:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T10:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T10:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T10:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T11:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T11:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T11:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T11:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T11:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T11:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T11:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T11:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T11:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T11:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T11:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T11:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T11:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T11:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T11:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T11:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T11:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T11:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T11:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T11:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T11:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T11:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T11:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T11:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T11:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T11:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T11:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T11:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T12:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T12:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T12:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T12:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T12:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T12:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T12:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T12:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T12:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T12:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T12:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T12:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T12:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T12:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T12:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T12:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T12:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T12:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T12:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T12:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T12:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T12:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T12:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T12:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T12:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T12:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T12:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T12:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T12:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T12:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T12:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T12:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T12:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T13:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T13:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T13:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T13:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T13:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T13:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T13:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T13:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T13:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T13:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T13:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T13:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T13:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T13:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T13:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T13:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T13:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T13:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T13:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T13:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T13:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T13:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T13:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T13:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T13:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T13:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T13:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T13:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T13:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T13:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T13:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T13:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T13:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T14:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T14:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T14:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T14:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T14:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T14:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T14:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T14:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T14:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T14:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T14:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T14:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T14:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T14:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T14:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T14:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T14:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T14:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T14:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T14:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T14:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T14:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T14:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T14:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T14:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T14:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T14:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T14:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T14:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T15:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T15:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T15:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T15:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T15:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T15:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T15:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T15:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T15:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T15:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T15:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T15:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T15:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T15:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T15:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T15:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T15:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T15:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T15:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T15:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T15:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T15:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T15:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T15:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T15:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T15:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T15:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T15:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T15:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T15:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T15:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T15:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T15:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T15:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T16:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T16:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T16:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T16:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T16:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T16:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T16:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T16:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T16:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T16:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T16:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T16:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T16:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T16:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T16:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T16:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T16:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T16:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T16:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T16:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T16:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T16:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T16:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T16:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T16:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T16:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T16:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T16:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T16:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T16:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T16:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T16:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T16:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T16:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T16:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T17:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T17:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T17:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T17:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T17:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T17:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T17:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T17:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T17:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T17:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T17:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T17:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T17:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T17:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T17:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T17:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T17:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T17:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T17:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T17:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T17:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T17:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T17:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T17:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T17:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T17:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T17:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T17:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T17:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T17:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T17:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T17:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T18:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T18:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T18:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T18:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T18:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T18:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T18:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T18:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T18:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T18:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T18:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T18:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T18:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T18:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T18:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T18:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T18:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T18:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T18:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T18:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T18:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T18:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T18:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T18:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T18:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T18:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T18:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T18:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T18:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T18:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T18:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T18:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T18:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T19:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T19:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T19:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T19:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T19:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T19:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T19:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T19:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T19:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T19:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T19:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T19:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T19:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T19:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T19:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T19:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T19:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T19:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T19:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T19:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T19:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T19:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T19:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T19:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T19:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T19:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T19:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T19:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T19:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T19:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T19:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T20:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T20:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T20:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T20:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T20:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T20:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T20:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T20:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T20:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T20:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T20:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T20:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T20:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T20:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T20:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T20:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T20:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T20:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T20:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T20:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T20:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T20:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T20:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T20:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T20:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T20:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T20:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T20:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T20:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T20:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T20:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T20:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T20:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T20:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T20:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T20:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T20:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T20:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T20:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T21:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T21:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T21:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T21:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T21:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T21:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T21:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T21:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T21:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T21:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T21:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T21:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T21:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T21:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T21:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T21:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T21:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T21:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T21:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T21:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T21:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T21:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T21:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T21:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T21:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T21:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T21:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T21:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T21:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T21:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T21:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T21:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T22:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T22:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T22:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T22:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T22:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T22:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T22:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T22:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T22:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T22:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T22:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T22:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T22:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T22:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T22:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T22:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T22:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T22:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T22:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T22:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T22:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T22:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T22:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T22:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T22:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T22:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T22:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T22:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T22:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T23:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T23:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T23:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T23:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T23:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T23:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T23:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T23:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T23:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T23:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T23:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T23:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T23:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T23:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T23:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T23:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T23:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T23:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T23:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T23:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T23:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T23:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T23:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T23:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T23:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T23:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T23:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-05T23:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T23:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-05T23:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-05T23:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T00:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T00:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T00:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T00:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T00:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T00:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T00:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T00:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T00:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T00:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T00:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T00:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T00:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T00:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T00:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T00:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T00:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T00:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T00:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T00:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T00:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T00:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T00:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T00:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T00:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T00:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T00:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T00:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T00:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T00:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T01:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T01:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T01:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T01:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T01:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T01:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T01:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T01:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T01:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T01:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T01:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T01:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T01:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T01:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T01:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T01:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T01:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T01:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T01:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T01:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T01:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T01:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T01:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T01:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T01:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T01:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T01:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T01:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T01:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T01:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T01:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T01:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T01:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T01:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T01:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T01:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T01:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T01:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T02:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T02:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T02:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T02:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T02:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T02:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T02:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T02:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T02:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T02:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T02:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T02:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T02:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T02:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T02:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T02:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T02:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T02:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T02:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T02:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T02:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T02:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T02:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T02:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T02:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T02:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T02:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T02:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T02:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T02:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T02:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T02:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T02:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T02:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T02:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T02:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T02:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T02:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T02:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T03:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T03:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T03:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T03:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T03:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T03:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T03:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T03:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T03:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T03:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T03:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T03:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T03:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T03:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T03:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T03:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T03:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T03:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T03:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T03:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T03:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T03:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T03:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T03:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T03:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T03:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T03:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T04:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T04:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T04:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T04:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T04:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T04:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T04:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T04:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T04:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T04:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T04:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T04:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T04:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T04:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T04:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T04:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T04:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T04:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T04:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T04:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T04:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T04:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T04:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T04:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T04:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T04:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T04:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T04:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T04:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T04:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T05:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T05:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T05:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T05:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T05:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T05:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T05:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T05:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T05:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T05:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T05:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T05:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T05:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T05:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T05:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T05:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T05:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T05:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T05:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T05:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T05:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T05:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T05:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T05:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T05:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T05:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T05:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T05:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T05:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T05:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T05:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T05:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T05:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T05:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T05:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T05:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T06:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T06:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T06:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T06:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T06:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T06:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T06:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T06:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T06:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T06:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T06:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T06:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T06:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T06:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T06:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T06:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T06:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T06:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T06:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T06:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T06:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T06:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T06:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T06:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T06:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T06:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T06:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T06:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T06:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T06:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T06:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T06:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T06:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T06:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T06:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T06:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T06:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T06:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T06:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T06:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T06:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T06:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T07:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T07:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T07:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T07:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T07:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T07:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T07:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T07:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T07:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T07:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T07:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T07:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T07:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T07:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T07:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T07:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T07:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T07:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T07:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T07:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T07:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T07:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T07:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T07:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T07:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T07:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T07:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T07:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T07:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T07:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T07:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T07:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T08:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T08:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T08:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T08:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T08:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T08:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T08:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T08:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T08:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T08:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T08:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T08:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T08:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T08:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T08:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T08:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T08:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T08:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T08:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T08:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T08:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T08:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T08:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T08:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T08:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T08:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T08:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T08:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T08:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T08:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T08:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T09:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T09:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T09:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T09:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T09:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T09:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T09:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T09:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T09:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T09:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T09:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T09:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T09:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T09:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T09:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T09:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T09:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T09:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T09:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T09:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T09:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T09:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T09:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T09:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T09:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T09:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T09:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T09:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T09:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T09:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T09:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T10:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T10:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T10:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T10:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T10:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T10:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T10:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T10:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T10:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T10:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T10:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T10:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T10:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T10:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T10:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T10:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T10:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T10:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T10:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T10:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T10:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T10:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T10:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T10:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T10:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T10:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T10:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T10:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T10:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T10:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T10:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T10:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T10:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T10:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T10:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T10:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T10:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T10:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T10:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T11:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T11:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T11:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T11:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T11:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T11:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T11:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T11:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T11:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T11:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T11:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T11:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T11:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T11:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T11:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T11:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T11:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T11:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T11:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T11:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T11:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T11:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T11:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T11:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T11:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T11:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T11:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T11:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T11:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T11:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T11:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T11:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T11:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T11:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T11:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T11:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T11:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T12:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T12:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T12:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T12:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T12:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T12:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T12:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T12:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T12:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T12:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T12:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T12:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T12:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T12:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T12:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T12:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T12:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T12:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T12:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T12:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T12:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T12:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T12:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T12:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T12:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T12:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T12:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T12:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T12:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T12:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T12:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T13:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T13:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T13:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T13:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T13:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T13:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T13:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T13:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T13:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T13:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T13:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T13:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T13:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T13:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T13:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T13:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T13:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T13:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T13:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T13:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T13:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T13:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T13:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T13:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T13:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T13:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T13:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T13:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T13:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T13:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T13:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T13:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T13:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T13:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T13:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T13:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T13:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T13:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T13:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T13:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T13:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T14:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T14:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T14:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T14:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T14:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T14:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T14:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T14:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T14:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T14:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T14:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T14:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T14:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T14:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T14:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T14:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T14:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T14:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T14:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T14:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T14:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T14:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T14:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T14:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T14:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T14:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T14:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T14:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T14:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T14:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T14:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T14:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T15:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T15:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T15:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T15:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T15:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T15:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T15:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T15:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T15:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T15:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T15:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T15:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T15:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T15:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T15:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T15:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T15:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T15:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T15:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T15:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T15:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T15:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T15:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T15:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T15:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T15:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T15:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T16:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T16:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T16:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T16:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T16:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T16:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T16:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T16:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T16:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T16:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T16:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T16:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T16:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T16:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T16:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T16:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T16:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T16:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T16:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T16:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T16:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T16:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T16:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T16:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T16:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T16:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T16:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T16:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T16:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T16:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T17:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T17:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T17:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T17:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T17:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T17:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T17:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T17:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T17:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T17:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T17:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T17:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T17:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T17:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T17:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T17:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T17:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T17:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T17:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T17:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T17:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T17:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T17:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T17:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T17:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T17:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T17:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T17:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T17:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T17:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T17:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T17:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T17:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T18:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T18:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T18:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T18:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T18:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T18:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T18:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T18:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T18:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T18:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T18:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T18:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T18:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T18:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T18:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T18:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T18:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T18:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T18:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T18:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T18:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T18:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T18:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T18:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T18:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T18:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T18:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T18:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T18:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T18:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T18:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T19:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T19:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T19:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T19:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T19:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T19:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T19:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T19:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T19:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T19:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T19:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T19:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T19:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T19:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T19:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T19:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T19:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T19:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T19:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T19:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T19:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T19:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T19:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T19:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T19:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T19:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T19:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T19:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T19:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T19:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T19:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T19:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T20:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T20:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T20:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T20:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T20:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T20:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T20:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T20:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T20:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T20:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T20:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T20:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T20:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T20:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T20:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T20:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T20:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T20:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T20:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T20:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T20:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T20:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T20:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T20:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T20:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T20:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T20:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T20:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T20:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T21:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T21:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T21:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T21:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T21:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T21:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T21:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T21:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T21:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T21:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T21:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T21:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T21:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T21:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T21:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T21:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T21:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T21:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T21:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T21:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T21:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T21:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T21:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T21:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T21:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T21:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T21:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T21:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T21:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T22:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T22:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T22:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T22:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T22:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T22:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T22:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T22:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T22:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T22:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T22:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T22:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T22:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T22:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T22:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T22:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T22:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T22:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T22:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T22:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T22:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T22:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T22:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T22:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T22:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T22:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T22:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T22:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T22:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T22:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T22:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T22:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T22:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T22:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T22:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T23:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T23:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T23:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T23:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T23:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T23:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T23:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T23:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T23:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T23:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T23:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T23:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T23:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T23:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T23:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T23:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T23:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T23:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T23:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T23:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T23:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T23:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T23:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T23:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T23:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T23:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T23:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T23:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-06T23:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-06T23:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-06T23:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T00:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T00:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T00:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T00:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T00:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T00:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T00:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T00:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T00:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T00:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T00:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T00:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T00:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T00:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T00:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T00:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T00:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T00:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T00:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T00:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T00:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T00:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T00:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T00:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T00:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T00:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T00:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T00:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T00:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T00:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T00:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T00:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T01:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T01:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T01:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T01:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T01:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T01:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T01:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T01:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T01:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T01:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T01:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T01:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T01:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T01:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T01:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T01:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T01:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T01:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T01:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T01:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T01:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T01:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T01:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T01:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T01:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T01:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T01:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T01:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T01:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T01:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T01:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T01:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T01:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T02:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T02:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T02:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T02:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T02:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T02:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T02:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T02:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T02:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T02:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T02:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T02:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T02:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T02:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T02:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T02:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T02:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T02:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T02:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T02:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T02:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T02:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T02:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T02:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T03:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T03:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T03:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T03:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T03:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T03:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T03:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T03:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T03:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T03:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T03:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T03:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T03:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T03:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T03:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T03:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T03:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T03:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T03:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T03:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T03:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T03:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T03:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T03:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T04:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T04:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T04:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T04:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T04:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T04:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T04:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T04:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T04:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T04:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T04:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T04:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T04:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T04:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T04:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T04:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T04:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T04:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T04:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T04:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T04:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T04:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T04:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T04:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T04:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T04:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T04:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T04:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T04:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T04:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T04:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T04:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T04:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T04:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T04:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T04:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T04:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T04:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T04:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T05:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T05:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T05:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T05:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T05:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T05:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T05:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T05:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T05:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T05:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T05:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T05:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T05:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T05:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T05:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T05:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T05:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T05:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T05:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T05:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T05:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T05:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T05:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T05:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T05:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T05:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T05:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T05:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T05:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T05:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T05:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T05:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T05:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T05:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T05:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T05:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T05:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T06:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T06:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T06:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T06:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T06:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T06:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T06:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T06:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T06:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T06:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T06:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T06:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T06:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T06:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T06:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T06:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T06:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T06:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T06:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T06:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T06:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T06:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T06:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T06:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T06:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T06:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T06:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T06:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T06:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T07:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T07:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T07:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T07:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T07:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T07:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T07:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T07:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T07:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T07:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T07:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T07:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T07:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T07:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T07:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T07:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T07:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T07:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T07:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T07:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T07:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T07:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T07:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T07:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T07:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T07:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T07:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T07:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T07:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T07:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T07:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T07:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T07:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T07:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T07:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T07:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T08:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T08:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T08:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T08:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T08:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T08:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T08:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T08:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T08:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T08:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T08:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T08:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T08:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T08:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T08:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T08:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T08:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T08:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T08:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T08:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T08:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T08:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T08:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T08:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T08:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T08:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T08:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T08:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T08:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T08:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T09:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T09:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T09:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T09:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T09:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T09:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T09:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T09:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T09:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T09:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T09:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T09:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T09:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T09:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T09:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T09:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T09:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T09:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T09:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T09:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T09:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T09:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T09:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T09:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T09:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T09:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T09:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T09:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T09:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T09:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T09:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T09:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T09:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T09:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T09:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T09:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T09:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T09:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T09:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T09:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T09:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T09:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T09:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T10:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T10:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T10:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T10:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T10:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T10:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T10:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T10:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T10:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T10:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T10:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T10:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T10:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T10:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T10:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T10:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T10:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T10:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T10:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T10:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T10:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T10:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T10:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T10:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T10:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T10:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T10:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T10:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T10:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T10:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T10:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T10:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T10:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T10:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T10:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T10:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T10:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T11:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T11:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T11:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T11:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T11:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T11:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T11:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T11:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T11:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T11:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T11:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T11:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T11:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T11:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T11:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T11:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T11:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T11:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T11:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T11:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T11:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T11:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T11:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T11:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T11:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T11:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T12:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T12:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T12:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T12:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T12:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T12:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T12:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T12:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T12:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T12:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T12:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T12:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T12:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T12:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T12:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T12:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T12:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T12:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T12:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T12:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T12:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T12:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T12:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T12:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T12:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T12:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T12:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T12:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T12:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T12:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T12:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T12:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T12:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T12:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T12:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T12:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T12:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T12:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T12:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T12:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T12:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T12:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T12:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T12:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T12:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T13:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T13:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T13:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T13:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T13:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T13:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T13:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T13:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T13:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T13:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T13:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T13:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T13:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T13:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T13:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T13:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T13:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T13:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T13:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T13:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T13:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T13:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T13:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T13:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T13:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T13:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T13:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T13:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T13:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T13:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T13:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T13:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T13:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T14:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T14:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T14:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T14:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T14:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T14:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T14:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T14:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T14:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T14:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T14:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T14:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T14:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T14:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T14:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T14:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T14:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T14:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T14:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T14:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T14:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T14:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T14:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T14:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T14:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T14:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T14:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T14:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T14:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T14:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T14:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T15:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T15:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T15:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T15:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T15:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T15:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T15:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T15:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T15:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T15:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T15:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T15:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T15:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T15:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T15:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T15:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T15:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T15:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T15:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T15:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T15:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T15:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T16:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T16:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T16:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T16:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T16:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T16:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T16:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T16:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T16:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T16:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T16:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T16:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T16:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T16:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T16:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T16:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T16:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T16:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T16:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T16:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T16:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T16:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T16:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T16:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T16:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T16:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T16:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T16:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T16:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T16:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T17:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T17:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T17:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T17:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T17:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T17:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T17:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T17:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T17:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T17:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T17:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T17:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T17:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T17:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T17:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T17:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T17:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T17:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T17:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T17:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T17:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T17:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T17:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T17:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T17:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T17:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T17:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T17:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T17:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T17:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T17:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T17:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T17:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T17:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T17:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T17:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T17:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T17:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T17:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T18:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T18:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T18:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T18:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T18:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T18:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T18:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T18:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T18:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T18:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T18:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T18:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T18:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T18:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T18:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T18:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T18:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T18:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T18:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T18:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T18:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T18:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T18:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T18:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T18:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T18:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T18:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T18:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T18:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T18:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T18:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T18:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T18:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T19:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T19:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T19:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T19:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T19:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T19:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T19:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T19:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T19:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T19:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T19:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T19:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T19:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T19:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T19:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T19:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T19:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T19:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T19:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T19:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T19:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T19:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T19:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T19:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T19:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T19:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T20:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T20:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T20:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T20:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T20:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T20:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T20:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T20:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T20:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T20:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T20:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T20:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T20:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T20:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T20:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T20:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T20:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T20:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T20:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T20:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T20:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T20:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T20:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T20:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T20:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T20:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T20:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T20:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T20:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T20:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T20:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T20:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T20:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T20:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T20:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T21:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T21:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T21:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T21:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T21:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T21:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T21:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T21:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T21:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T21:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T21:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T21:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T21:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T21:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T21:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T21:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T21:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T21:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T21:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T21:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T21:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T21:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T21:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T21:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T21:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T21:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T21:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T21:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T21:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T21:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T21:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T21:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T21:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T21:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T21:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T22:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T22:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T22:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T22:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T22:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T22:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T22:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T22:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T22:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T22:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T22:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T22:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T22:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T22:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T22:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T22:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T22:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T22:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T22:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T22:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T22:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T22:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T22:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T22:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T22:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T22:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T22:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T22:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T22:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T22:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T22:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T22:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T22:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T22:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T22:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T22:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T22:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T22:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T23:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T23:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T23:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T23:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T23:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T23:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T23:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T23:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T23:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T23:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T23:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T23:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T23:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T23:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T23:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T23:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T23:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T23:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T23:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T23:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T23:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T23:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T23:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T23:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T23:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T23:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T23:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T23:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T23:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T23:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-07T23:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-07T23:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-07T23:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T00:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T00:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T00:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T00:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T00:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T00:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T00:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T00:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T00:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T00:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T00:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T00:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T00:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T00:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T00:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T00:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T00:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T00:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T00:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T00:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T00:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T00:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T00:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T00:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T00:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T00:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T00:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T00:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T00:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T00:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T00:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T00:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T01:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T01:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T01:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T01:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T01:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T01:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T01:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T01:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T01:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T01:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T01:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T01:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T01:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T01:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T01:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T01:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T01:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T01:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T01:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T01:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T01:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T01:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T01:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T01:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T01:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T01:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T01:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T01:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T01:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T01:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T01:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T01:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T01:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T01:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T01:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T01:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T01:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T01:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T01:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T01:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T01:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T01:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T01:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T02:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T02:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T02:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T02:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T02:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T02:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T02:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T02:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T02:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T02:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T02:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T02:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T02:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T02:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T02:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T02:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T02:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T02:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T02:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T02:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T02:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T02:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T02:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T02:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T02:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T02:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T03:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T03:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T03:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T03:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T03:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T03:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T03:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T03:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T03:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T03:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T03:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T03:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T03:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T03:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T03:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T03:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T03:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T03:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T03:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T03:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T03:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T03:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T03:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T03:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T03:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T03:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T03:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T03:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T03:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T03:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T03:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T03:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T03:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T03:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T03:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T03:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T03:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T03:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T04:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T04:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T04:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T04:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T04:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T04:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T04:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T04:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T04:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T04:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T04:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T04:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T04:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T04:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T04:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T04:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T04:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T04:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T04:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T04:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T04:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T04:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T04:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T04:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T04:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T04:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T04:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T04:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T04:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T04:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T04:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T04:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T04:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T04:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T04:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T05:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T05:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T05:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T05:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T05:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T05:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T05:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T05:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T05:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T05:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T05:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T05:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T05:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T05:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T05:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T05:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T05:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T05:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T05:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T05:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T05:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T05:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T05:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T05:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T05:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T05:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T05:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T05:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T05:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T05:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T05:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T05:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T05:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T05:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T05:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T05:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T05:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T06:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T06:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T06:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T06:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T06:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T06:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T06:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T06:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T06:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T06:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T06:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T06:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T06:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T06:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T06:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T06:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T06:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T06:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T06:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T06:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T06:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T06:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T06:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T06:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T06:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T06:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T06:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T06:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T06:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T06:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T06:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T06:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T06:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T06:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T07:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T07:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T07:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T07:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T07:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T07:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T07:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T07:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T07:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T07:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T07:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T07:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T07:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T07:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T07:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T07:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T07:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T07:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T07:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T07:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T07:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T07:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T07:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T07:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T07:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T07:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T07:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T07:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T07:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T07:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T07:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T07:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T07:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T07:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T07:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T07:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T07:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T07:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T07:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T07:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T08:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T08:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T08:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T08:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T08:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T08:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T08:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T08:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T08:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T08:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T08:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T08:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T08:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T08:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T08:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T08:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T08:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T08:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T08:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T08:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T08:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T08:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T08:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T08:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T08:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T08:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T08:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T08:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T08:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T08:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T08:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T08:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T08:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T09:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T09:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T09:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T09:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T09:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T09:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T09:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T09:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T09:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T09:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T09:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T09:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T09:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T09:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T09:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T09:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T09:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T09:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T09:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T09:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T09:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T09:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T09:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T09:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T09:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T09:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T09:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T09:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T09:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T09:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T10:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T10:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T10:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T10:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T10:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T10:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T10:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T10:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T10:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T10:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T10:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T10:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T10:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T10:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T10:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T10:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T10:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T10:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T10:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T10:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T10:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T10:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T10:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T10:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T10:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T10:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T10:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T10:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T10:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T10:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T10:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T10:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T10:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T10:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T10:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T10:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T11:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T11:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T11:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T11:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T11:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T11:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T11:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T11:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T11:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T11:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T11:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T11:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T11:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T11:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T11:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T11:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T11:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T11:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T11:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T11:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T11:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T11:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T11:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T11:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T11:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T11:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T12:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T12:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T12:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T12:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T12:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T12:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T12:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T12:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T12:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T12:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T12:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T12:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T12:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T12:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T12:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T12:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T12:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T12:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T12:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T12:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T12:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T12:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T12:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T12:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T12:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T12:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T12:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T12:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T12:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T12:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T12:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T12:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T12:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T13:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T13:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T13:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T13:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T13:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T13:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T13:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T13:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T13:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T13:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T13:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T13:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T13:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T13:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T13:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T13:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T13:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T13:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T13:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T13:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T13:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T13:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T13:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T13:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T13:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T13:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T13:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T14:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T14:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T14:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T14:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T14:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T14:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T14:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T14:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T14:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T14:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T14:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T14:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T14:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T14:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T14:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T14:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T14:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T14:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T14:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T14:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T14:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T14:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T14:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T14:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T14:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T14:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T14:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T14:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T14:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T14:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T14:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T14:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T14:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T14:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T14:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T14:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T14:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T14:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T15:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T15:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T15:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T15:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T15:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T15:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T15:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T15:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T15:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T15:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T15:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T15:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T15:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T15:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T15:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T15:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T15:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T15:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T15:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T15:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T15:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T15:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T15:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T15:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T15:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T15:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T15:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T15:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T15:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T15:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T15:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T15:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T15:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T15:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T15:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T15:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T15:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T15:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T15:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T15:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T16:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T16:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T16:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T16:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T16:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T16:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T16:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T16:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T16:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T16:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T16:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T16:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T16:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T16:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T16:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T16:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T16:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T16:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T16:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T16:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T16:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T16:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T16:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T16:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T16:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T17:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T17:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T17:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T17:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T17:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T17:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T17:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T17:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T17:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T17:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T17:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T17:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T17:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T17:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T17:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T17:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T17:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T17:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T17:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T17:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T17:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T17:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T17:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T17:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T17:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T17:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T17:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T17:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T17:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T17:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T17:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T17:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T17:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T17:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T17:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T17:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T17:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T17:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T17:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T17:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T18:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T18:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T18:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T18:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T18:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T18:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T18:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T18:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T18:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T18:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T18:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T18:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T18:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T18:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T18:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T18:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T18:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T18:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T18:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T18:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T18:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T18:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T18:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T18:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T18:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T18:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T18:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T18:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T18:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T19:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T19:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T19:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T19:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T19:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T19:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T19:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T19:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T19:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T19:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T19:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T19:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T19:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T19:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T19:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T19:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T19:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T19:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T19:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T19:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T19:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T19:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T19:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T19:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T19:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T19:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T19:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T20:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T20:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T20:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T20:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T20:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T20:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T20:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T20:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T20:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T20:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T20:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T20:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T20:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T20:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T20:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T20:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T20:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T20:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T20:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T20:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T20:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T20:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T20:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T20:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T20:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T20:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T20:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T21:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T21:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T21:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T21:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T21:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T21:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T21:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T21:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T21:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T21:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T21:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T21:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T21:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T21:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T21:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T21:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T21:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T21:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T21:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T21:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T21:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T21:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T21:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T21:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T21:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T21:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T21:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T21:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T21:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T21:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T21:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T21:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T21:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T21:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T21:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T22:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T22:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T22:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T22:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T22:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T22:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T22:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T22:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T22:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T22:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T22:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T22:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T22:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T22:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T22:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T22:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T22:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T22:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T22:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T22:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T23:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T23:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T23:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T23:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T23:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T23:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T23:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T23:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T23:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T23:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T23:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T23:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T23:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T23:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T23:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T23:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T23:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T23:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T23:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T23:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T23:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T23:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T23:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T23:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T23:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T23:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T23:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T23:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T23:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-08T23:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T23:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-08T23:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-08T23:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T00:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T00:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T00:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T00:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T00:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T00:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T00:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T00:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T00:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T00:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T00:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T00:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T00:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T00:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T00:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T00:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T00:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T00:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T00:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T00:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T00:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T00:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T00:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T00:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T00:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T00:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T00:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T00:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T00:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T00:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T00:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T00:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T00:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T00:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T00:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T00:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T00:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T00:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T00:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T01:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T01:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T01:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T01:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T01:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T01:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T01:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T01:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T01:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T01:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T01:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T01:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T01:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T01:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T01:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T01:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T01:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T01:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T01:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T01:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T01:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T01:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T01:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T01:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T01:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T01:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T01:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T01:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T01:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T02:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T02:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T02:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T02:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T02:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T02:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T02:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T02:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T02:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T02:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T02:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T02:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T02:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T02:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T02:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T02:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T02:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T02:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T02:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T02:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T02:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T02:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T02:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T02:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T02:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T02:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T02:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T02:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T02:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T03:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T03:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T03:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T03:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T03:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T03:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T03:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T03:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T03:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T03:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T03:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T03:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T03:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T03:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T03:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T03:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T03:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T03:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T03:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T03:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T03:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T03:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T03:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T03:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T03:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T03:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T03:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T03:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T03:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T03:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T03:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T03:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T03:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T03:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T03:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T03:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T03:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T03:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T04:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T04:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T04:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T04:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T04:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T04:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T04:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T04:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T04:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T04:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T04:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T04:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T04:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T04:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T04:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T04:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T04:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T04:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T04:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T04:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T04:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T04:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T04:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T04:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T04:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T04:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T04:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T04:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T04:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T04:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T04:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T05:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T05:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T05:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T05:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T05:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T05:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T05:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T05:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T05:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T05:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T05:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T05:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T05:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T05:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T05:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T05:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T05:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T05:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T05:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T05:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T05:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T05:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T05:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T06:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T06:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T06:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T06:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T06:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T06:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T06:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T06:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T06:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T06:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T06:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T06:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T06:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T06:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T06:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T06:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T06:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T06:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T06:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T06:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T06:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T06:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T06:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T06:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T06:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T06:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T06:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T06:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T06:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T06:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T06:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T07:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T07:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T07:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T07:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T07:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T07:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T07:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T07:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T07:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T07:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T07:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T07:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T07:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T07:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T07:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T07:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T07:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T07:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T07:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T07:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T07:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T07:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T07:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T07:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T07:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T07:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T07:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T07:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T07:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T07:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T07:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T07:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T07:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T07:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T07:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T08:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T08:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T08:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T08:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T08:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T08:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T08:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T08:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T08:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T08:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T08:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T08:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T08:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T08:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T08:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T08:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T08:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T08:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T08:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T08:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T08:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T08:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T08:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T08:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T08:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T08:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T08:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T08:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T08:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T08:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T08:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T09:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T09:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T09:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T09:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T09:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T09:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T09:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T09:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T09:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T09:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T09:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T09:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T09:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T09:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T09:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T09:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T09:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T09:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T09:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T09:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T09:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T09:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T09:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T09:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T09:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T09:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T09:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T09:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T09:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T09:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T09:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T09:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T09:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T09:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T09:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T09:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T09:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T09:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T09:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T09:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T10:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T10:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T10:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T10:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T10:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T10:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T10:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T10:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T10:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T10:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T10:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T10:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T10:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T10:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T10:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T10:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T10:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T10:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T10:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T10:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T10:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T10:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T10:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T10:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T11:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T11:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T11:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T11:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T11:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T11:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T11:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T11:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T11:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T11:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T11:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T11:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T11:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T11:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T11:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T11:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T11:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T11:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T11:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T11:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T11:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T11:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T11:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T11:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T11:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T11:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T11:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T11:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T11:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T11:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T11:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T11:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T11:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T11:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T12:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T12:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T12:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T12:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T12:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T12:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T12:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T12:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T12:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T12:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T12:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T12:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T12:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T12:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T12:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T12:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T12:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T12:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T12:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T12:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T12:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T12:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T12:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T12:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T12:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T12:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T12:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T12:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T12:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T12:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T12:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T12:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T12:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T12:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T12:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T13:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T13:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T13:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T13:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T13:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T13:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T13:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T13:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T13:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T13:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T13:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T13:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T13:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T13:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T13:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T13:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T13:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T13:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T13:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T13:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T13:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T13:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T13:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T13:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T13:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T13:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T13:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T13:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T13:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T13:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T13:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T13:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T13:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T13:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T13:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T13:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T13:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T14:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T14:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T14:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T14:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T14:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T14:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T14:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T14:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T14:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T14:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T14:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T14:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T14:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T14:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T14:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T14:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T14:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T14:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T14:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T14:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T14:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T14:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T14:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T14:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T14:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T14:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T14:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T14:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T14:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T14:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T15:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T15:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T15:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T15:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T15:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T15:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T15:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T15:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T15:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T15:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T15:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T15:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T15:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T15:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T15:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T15:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T15:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T15:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T15:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T15:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T15:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T15:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T15:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T15:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T15:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T16:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T16:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T16:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T16:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T16:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T16:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T16:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T16:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T16:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T16:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T16:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T16:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T16:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T16:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T16:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T16:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T16:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T16:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T16:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T16:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T16:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T16:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T16:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T16:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T16:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T16:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T16:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T16:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T16:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T16:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T17:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T17:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T17:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T17:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T17:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T17:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T17:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T17:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T17:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T17:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T17:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T17:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T17:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T17:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T17:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T17:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T17:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T17:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T17:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T17:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T17:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T17:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T17:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T17:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T17:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T17:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T17:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T17:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T17:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T17:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T17:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T17:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T17:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T17:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T17:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T17:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T17:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T17:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T17:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T18:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T18:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T18:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T18:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T18:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T18:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T18:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T18:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T18:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T18:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T18:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T18:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T18:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T18:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T18:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T18:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T18:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T18:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T18:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T18:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T18:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T18:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T18:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T18:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T18:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T18:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T18:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T18:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T18:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T18:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T18:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T18:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T18:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T18:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T18:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T19:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T19:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T19:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T19:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T19:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T19:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T19:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T19:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T19:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T19:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T19:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T19:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T19:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T19:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T19:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T19:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T19:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T19:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T19:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T19:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T19:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T19:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T19:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T19:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T19:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T19:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T19:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T19:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T19:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T19:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T20:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T20:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T20:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T20:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T20:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T20:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T20:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T20:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T20:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T20:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T20:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T20:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T20:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T20:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T20:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T20:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T20:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T20:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T20:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T20:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T20:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T20:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T20:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T20:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T20:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T20:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T20:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T20:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T20:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T20:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T20:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T20:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T20:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T20:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T20:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T20:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T21:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T21:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T21:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T21:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T21:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T21:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T21:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T21:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T21:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T21:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T21:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T21:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T21:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T21:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T21:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T21:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T21:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T21:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T21:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T21:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T21:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T21:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T21:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T21:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T21:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T21:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T21:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T21:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T21:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T21:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T21:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T21:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T22:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T22:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T22:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T22:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T22:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T22:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T22:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T22:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T22:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T22:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T22:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T22:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T22:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T22:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T22:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T22:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T22:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T22:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T22:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T22:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T22:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T22:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T22:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T22:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T22:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T22:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T22:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T22:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T22:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T22:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T22:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T22:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T22:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T22:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T22:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T23:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T23:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T23:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T23:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T23:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T23:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T23:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T23:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T23:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T23:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T23:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T23:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T23:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T23:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T23:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T23:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T23:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T23:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T23:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T23:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T23:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T23:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T23:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T23:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T23:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T23:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-09T23:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T23:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T23:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-09T23:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T23:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-09T23:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T00:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T00:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T00:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T00:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T00:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T00:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T00:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T00:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T00:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T00:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T00:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T00:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T00:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T00:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T00:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T00:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T00:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T00:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T00:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T00:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T00:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T00:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T00:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T00:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T00:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T00:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T00:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T01:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T01:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T01:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T01:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T01:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T01:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T01:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T01:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T01:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T01:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T01:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T01:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T01:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T01:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T01:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T01:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T01:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T01:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T01:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T01:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T01:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T01:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T01:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T01:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T02:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T02:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T02:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T02:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T02:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T02:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T02:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T02:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T02:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T02:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T02:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T02:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T02:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T02:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T02:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T02:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T02:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T02:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T02:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T02:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T02:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T02:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T02:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T02:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T03:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T03:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T03:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T03:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T03:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T03:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T03:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T03:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T03:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T03:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T03:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T03:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T03:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T03:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T03:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T03:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T03:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T03:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T03:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T03:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T03:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T03:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T03:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T04:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T04:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T04:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T04:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T04:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T04:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T04:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T04:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T04:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T04:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T04:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T04:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T04:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T04:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T04:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T04:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T04:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T04:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T04:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T04:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T04:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T04:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T04:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T04:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T05:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T05:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T05:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T05:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T05:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T05:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T05:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T05:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T05:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T05:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T05:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T05:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T05:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T05:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T05:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T05:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T05:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T05:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T05:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T05:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T05:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T05:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T05:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T05:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T05:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T05:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T05:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T05:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T05:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T05:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T05:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T05:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T05:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T05:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T05:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T05:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T05:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T05:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T06:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T06:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T06:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T06:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T06:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T06:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T06:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T06:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T06:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T06:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T06:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T06:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T06:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T06:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T06:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T06:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T06:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T06:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T06:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T06:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T06:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T06:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T06:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T06:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T06:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T07:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T07:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T07:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T07:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T07:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T07:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T07:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T07:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T07:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T07:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T07:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T07:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T07:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T07:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T07:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T07:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T07:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T07:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T07:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T07:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T07:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T07:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T07:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T07:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T07:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T07:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T07:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T07:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T07:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T08:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T08:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T08:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T08:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T08:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T08:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T08:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T08:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T08:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T08:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T08:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T08:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T08:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T08:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T08:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T08:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T08:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T08:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T08:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T08:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T08:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T08:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T08:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T08:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T08:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T08:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T08:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T08:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T08:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T08:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T08:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T08:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T08:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T08:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T08:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T08:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T09:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T09:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T09:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T09:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T09:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T09:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T09:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T09:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T09:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T09:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T09:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T09:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T09:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T09:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T09:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T09:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T09:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T09:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T09:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T09:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T09:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T09:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T09:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T10:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T10:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T10:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T10:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T10:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T10:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T10:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T10:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T10:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T10:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T10:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T10:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T10:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T10:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T10:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T10:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T10:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T10:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T10:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T10:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T10:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T10:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T10:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T11:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T11:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T11:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T11:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T11:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T11:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T11:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T11:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T11:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T11:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T11:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T11:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T11:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T11:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T11:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T11:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T11:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T11:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T11:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T11:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T11:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T11:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T11:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T11:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T11:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T11:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T11:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T12:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T12:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T12:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T12:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T12:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T12:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T12:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T12:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T12:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T12:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T12:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T12:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T12:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T12:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T12:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T12:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T12:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T12:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T12:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T12:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T12:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T12:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T12:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T12:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T12:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T12:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T12:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T12:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T12:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T12:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T12:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T12:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T12:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T12:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T12:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T12:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T13:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T13:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T13:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T13:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T13:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T13:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T13:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T13:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T13:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T13:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T13:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T13:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T13:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T13:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T13:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T13:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T13:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T13:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T13:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T13:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T13:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T13:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T13:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T13:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T13:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T13:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T13:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T13:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T13:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T13:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T13:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T13:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T13:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T13:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T13:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T13:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T13:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T13:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T13:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T13:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T14:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T14:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T14:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T14:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T14:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T14:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T14:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T14:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T14:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T14:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T14:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T14:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T14:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T14:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T14:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T14:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T14:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T14:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T14:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T14:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T14:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T14:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T14:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T14:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T14:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T14:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T14:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T14:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T14:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T14:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T14:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T14:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T14:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T14:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T15:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T15:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T15:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T15:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T15:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T15:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T15:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T15:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T15:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T15:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T15:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T15:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T15:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T15:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T15:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T15:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T15:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T15:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T15:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T15:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T15:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T15:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T15:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T15:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T15:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T15:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T15:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T15:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T15:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T15:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T15:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T15:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T15:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T15:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T16:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T16:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T16:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T16:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T16:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T16:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T16:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T16:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T16:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T16:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T16:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T16:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T16:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T16:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T16:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T16:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T16:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T16:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T16:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T16:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T16:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T16:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T16:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T16:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T16:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T16:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T16:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T16:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T16:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T16:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T16:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T16:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T16:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T17:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T17:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T17:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T17:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T17:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T17:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T17:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T17:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T17:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T17:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T17:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T17:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T17:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T17:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T17:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T17:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T17:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T17:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T17:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T17:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T17:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T17:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T17:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T17:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T17:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T17:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T17:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T17:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T17:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T17:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T17:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T18:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T18:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T18:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T18:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T18:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T18:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T18:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T18:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T18:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T18:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T18:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T18:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T18:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T18:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T18:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T18:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T18:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T18:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T18:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T18:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T18:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T18:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T18:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T18:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T18:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T18:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T18:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T18:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T18:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T18:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T18:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T18:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T18:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T19:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T19:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T19:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T19:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T19:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T19:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T19:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T19:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T19:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T19:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T19:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T19:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T19:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T19:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T19:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T19:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T19:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T19:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T19:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T19:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T19:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T19:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T19:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T19:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T19:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T19:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T19:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T19:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T19:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T19:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T19:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T20:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T20:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T20:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T20:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T20:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T20:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T20:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T20:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T20:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T20:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T20:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T20:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T20:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T20:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T20:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T20:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T20:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T20:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T20:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T20:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T20:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T20:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T20:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T20:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T20:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T20:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T20:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T20:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T20:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T20:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T20:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T20:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T20:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T20:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T21:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T21:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T21:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T21:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T21:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T21:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T21:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T21:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T21:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T21:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T21:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T21:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T21:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T21:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T21:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T21:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T21:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T21:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T21:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T21:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T21:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T21:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T21:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T21:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T21:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T21:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T21:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T22:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T22:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T22:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T22:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T22:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T22:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T22:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T22:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T22:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T22:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T22:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T22:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T22:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T22:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T22:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T22:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T22:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T22:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T22:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T22:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T22:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T22:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T22:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T22:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T22:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T22:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T22:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T22:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T22:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T22:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T23:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T23:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T23:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T23:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T23:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T23:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T23:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T23:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T23:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T23:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T23:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T23:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T23:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T23:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T23:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T23:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T23:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T23:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T23:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T23:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T23:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T23:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T23:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T23:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T23:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T23:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-10T23:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-10T23:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-10T23:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T00:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T00:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T00:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T00:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T00:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T00:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T00:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T00:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T00:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T00:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T00:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T00:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T00:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T00:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T00:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T00:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T00:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T00:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T00:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T00:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T00:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T00:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T00:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T00:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T00:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T00:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T00:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T00:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T00:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T00:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T01:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T01:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T01:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T01:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T01:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T01:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T01:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T01:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T01:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T01:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T01:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T01:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T01:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T01:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T01:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T01:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T01:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T01:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T01:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T01:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T01:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T01:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T01:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T01:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T01:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T01:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T01:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T01:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T01:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T01:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T01:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T01:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T01:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T01:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T01:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T01:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T02:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T02:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T02:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T02:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T02:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T02:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T02:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T02:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T02:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T02:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T02:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T02:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T02:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T02:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T02:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T02:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T02:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T02:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T02:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T02:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T02:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T02:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T02:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T02:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T02:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T02:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T02:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T02:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T02:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T02:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T02:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T02:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T03:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T03:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T03:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T03:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T03:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T03:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T03:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T03:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T03:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T03:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T03:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T03:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T03:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T03:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T03:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T03:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T03:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T03:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T03:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T03:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T03:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T03:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T03:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T03:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T03:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T03:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T03:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T03:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T03:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T03:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T04:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T04:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T04:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T04:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T04:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T04:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T04:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T04:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T04:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T04:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T04:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T04:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T04:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T04:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T04:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T04:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T04:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T04:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T04:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T04:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T04:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T04:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T04:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T04:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T04:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T04:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T04:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T04:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T04:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T04:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T04:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T04:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T04:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T04:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T04:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T04:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T04:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T04:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T04:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T04:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T04:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T04:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T04:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T05:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T05:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T05:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T05:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T05:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T05:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T05:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T05:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T05:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T05:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T05:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T05:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T05:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T05:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T05:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T05:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T05:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T05:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T05:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T05:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T05:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T05:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T05:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T05:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T05:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T05:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T05:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T05:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T05:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T05:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T05:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T05:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T05:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T05:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T05:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T05:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T05:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T05:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T05:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T05:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T06:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T06:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T06:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T06:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T06:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T06:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T06:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T06:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T06:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T06:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T06:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T06:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T06:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T06:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T06:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T06:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T06:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T06:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T06:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T06:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T06:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T06:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T06:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T06:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T06:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T06:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T06:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T06:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T06:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T06:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T06:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T07:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T07:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T07:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T07:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T07:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T07:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T07:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T07:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T07:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T07:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T07:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T07:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T07:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T07:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T07:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T07:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T07:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T07:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T07:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T07:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T07:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T07:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T07:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T07:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T07:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T07:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T07:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T07:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T07:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T07:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T07:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T07:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T08:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T08:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T08:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T08:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T08:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T08:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T08:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T08:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T08:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T08:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T08:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T08:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T08:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T08:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T08:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T08:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T08:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T08:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T08:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T08:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T08:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T08:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T08:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T08:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T08:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T08:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T08:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T08:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T08:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T08:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T08:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T08:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T09:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T09:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T09:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T09:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T09:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T09:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T09:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T09:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T09:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T09:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T09:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T09:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T09:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T09:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T09:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T09:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T09:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T09:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T09:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T09:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T09:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T09:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T09:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T09:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T09:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T09:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T09:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T09:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T09:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T09:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T09:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T09:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T09:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T10:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T10:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T10:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T10:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T10:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T10:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T10:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T10:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T10:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T10:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T10:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T10:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T10:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T10:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T10:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T10:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T10:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T10:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T10:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T10:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T10:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T10:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T10:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T10:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T10:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T10:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T10:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T10:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T10:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T10:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T10:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T10:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T10:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T10:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T10:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T10:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T10:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T11:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T11:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T11:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T11:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T11:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T11:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T11:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T11:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T11:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T11:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T11:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T11:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T11:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T11:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T11:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T11:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T11:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T11:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T11:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T11:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T11:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T11:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T11:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T11:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T11:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T11:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T11:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T11:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T11:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T11:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T11:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T11:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T11:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T11:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T11:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T11:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T11:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T12:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T12:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T12:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T12:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T12:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T12:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T12:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T12:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T12:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T12:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T12:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T12:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T12:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T12:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T12:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T12:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T12:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T12:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T12:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T12:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T12:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T12:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T12:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T12:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T12:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T12:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T12:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T12:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T12:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T12:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T12:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T12:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T12:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T13:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T13:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T13:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T13:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T13:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T13:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T13:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T13:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T13:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T13:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T13:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T13:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T13:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T13:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T13:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T13:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T13:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T13:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T13:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T13:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T13:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T13:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T13:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T13:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T13:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T13:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T13:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T13:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T13:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T13:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T13:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T13:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T14:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T14:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T14:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T14:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T14:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T14:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T14:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T14:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T14:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T14:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T14:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T14:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T14:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T14:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T14:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T14:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T14:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T14:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T14:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T14:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T14:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T14:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T14:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T14:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T14:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T14:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T14:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T14:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T14:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T14:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T14:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T14:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T14:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T14:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T15:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T15:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T15:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T15:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T15:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T15:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T15:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T15:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T15:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T15:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T15:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T15:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T15:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T15:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T15:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T15:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T15:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T15:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T15:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T15:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T15:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T15:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T15:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T15:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T15:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T15:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T15:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T15:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T16:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T16:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T16:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T16:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T16:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T16:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T16:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T16:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T16:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T16:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T16:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T16:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T16:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T16:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T16:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T16:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T16:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T16:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T16:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T16:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T16:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T16:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T16:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T16:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T16:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T16:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T16:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T16:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T16:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T16:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T16:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T16:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T16:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T16:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T16:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T16:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T17:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T17:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T17:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T17:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T17:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T17:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T17:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T17:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T17:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T17:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T17:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T17:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T17:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T17:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T17:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T17:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T17:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T17:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T17:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T17:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T17:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T17:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T17:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T17:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T17:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T17:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T17:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T17:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T17:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T17:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T18:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T18:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T18:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T18:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T18:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T18:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T18:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T18:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T18:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T18:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T18:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T18:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T18:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T18:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T18:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T18:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T18:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T18:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T18:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T18:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T18:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T18:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T18:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T18:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T18:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T19:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T19:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T19:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T19:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T19:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T19:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T19:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T19:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T19:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T19:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T19:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T19:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T19:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T19:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T19:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T19:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T19:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T19:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T19:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T19:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T19:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T19:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T19:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T19:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T19:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T19:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T19:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T19:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T19:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T19:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T19:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T19:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T19:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T19:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T19:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T19:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T20:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T20:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T20:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T20:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T20:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T20:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T20:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T20:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T20:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T20:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T20:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T20:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T20:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T20:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T20:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T20:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T20:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T20:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T20:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T20:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T20:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T20:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T20:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T20:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T20:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T20:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T20:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T20:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T20:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T20:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T20:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T20:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T20:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T20:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T20:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T21:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T21:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T21:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T21:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T21:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T21:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T21:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T21:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T21:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T21:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T21:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T21:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T21:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T21:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T21:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T21:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T21:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T21:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T21:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T21:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T21:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T21:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T21:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T21:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T21:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T21:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T21:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T21:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T21:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T22:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T22:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T22:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T22:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T22:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T22:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T22:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T22:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T22:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T22:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T22:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T22:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T22:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T22:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T22:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T22:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T22:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T22:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T22:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T22:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T22:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T22:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T22:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T22:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T22:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T22:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T22:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T22:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T22:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T22:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T23:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T23:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T23:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T23:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T23:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T23:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T23:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T23:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T23:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T23:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T23:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T23:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T23:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T23:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T23:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T23:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T23:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T23:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T23:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T23:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T23:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T23:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T23:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T23:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T23:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T23:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T23:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T23:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T23:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T23:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-11T23:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T23:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-11T23:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-11T23:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T00:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T00:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T00:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T00:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T00:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T00:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T00:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T00:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T00:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T00:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T00:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T00:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T00:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T00:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T00:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T00:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T00:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T00:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T00:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T00:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T00:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T00:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T00:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T00:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T00:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T00:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T00:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T01:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T01:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T01:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T01:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T01:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T01:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T01:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T01:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T01:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T01:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T01:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T01:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T01:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T01:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T01:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T01:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T01:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T01:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T01:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T01:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T01:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T01:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T01:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T01:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T01:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T01:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T01:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T01:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T01:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T01:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T01:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T01:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T01:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T01:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T01:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T01:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T01:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T01:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T01:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T02:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T02:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T02:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T02:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T02:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T02:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T02:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T02:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T02:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T02:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T02:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T02:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T02:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T02:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T02:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T02:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T02:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T02:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T02:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T02:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T02:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T02:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T02:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T02:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T02:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T02:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T02:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T02:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T02:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T02:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T02:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T02:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T03:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T03:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T03:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T03:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T03:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T03:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T03:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T03:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T03:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T03:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T03:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T03:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T03:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T03:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T03:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T03:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T03:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T03:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T03:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T03:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T03:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T03:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T03:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T03:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T03:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T03:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T03:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T03:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T03:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T03:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T03:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T03:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T03:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T03:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T04:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T04:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T04:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T04:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T04:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T04:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T04:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T04:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T04:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T04:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T04:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T04:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T04:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T04:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T04:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T04:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T04:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T04:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T04:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T04:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T04:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T04:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T04:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T04:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T04:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T04:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T04:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T04:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T04:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T04:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T04:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T04:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T04:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T05:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T05:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T05:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T05:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T05:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T05:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T05:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T05:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T05:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T05:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T05:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T05:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T05:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T05:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T05:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T05:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T05:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T05:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T05:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T05:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T05:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T05:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T05:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T05:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T05:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T05:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T05:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T05:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T05:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T05:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T05:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T05:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T05:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T05:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T06:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T06:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T06:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T06:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T06:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T06:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T06:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T06:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T06:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T06:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T06:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T06:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T06:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T06:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T06:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T06:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T06:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T06:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T06:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T06:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T06:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T06:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T06:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T06:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T06:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T06:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T06:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T06:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T06:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T06:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T06:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T06:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T06:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T06:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T06:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T06:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T06:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T06:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T06:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T07:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T07:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T07:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T07:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T07:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T07:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T07:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T07:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T07:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T07:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T07:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T07:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T07:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T07:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T07:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T07:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T07:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T07:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T07:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T07:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T07:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T07:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T07:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T07:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T07:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T07:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T07:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T07:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T07:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T07:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T08:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T08:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T08:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T08:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T08:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T08:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T08:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T08:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T08:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T08:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T08:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T08:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T08:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T08:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T08:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T08:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T08:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T08:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T08:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T08:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T08:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T08:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T08:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T08:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T08:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T08:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T08:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T08:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T08:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T08:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T08:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T08:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T08:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T08:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T09:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T09:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T09:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T09:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T09:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T09:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T09:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T09:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T09:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T09:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T09:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T09:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T09:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T09:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T09:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T09:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T09:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T09:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T09:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T09:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T09:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T09:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T09:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T09:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T09:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T09:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T09:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T09:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T09:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T09:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T09:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T09:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T09:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T10:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T10:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T10:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T10:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T10:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T10:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T10:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T10:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T10:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T10:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T10:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T10:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T10:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T10:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T10:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T10:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T10:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T10:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T10:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T10:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T10:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T10:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T10:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T10:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T10:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T10:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T10:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T10:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T10:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T10:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T10:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T10:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T10:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T10:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T10:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T10:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T10:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T10:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T11:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T11:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T11:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T11:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T11:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T11:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T11:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T11:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T11:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T11:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T11:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T11:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T11:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T11:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T11:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T11:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T11:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T11:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T11:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T11:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T11:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T11:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T11:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T11:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T11:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T11:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T11:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T11:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T11:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T11:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T11:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T11:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T11:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T11:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T11:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T12:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T12:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T12:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T12:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T12:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T12:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T12:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T12:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T12:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T12:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T12:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T12:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T12:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T12:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T12:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T12:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T12:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T12:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T12:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T12:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T12:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T12:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T12:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T12:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T12:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T12:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T12:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T12:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T12:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T12:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T12:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T12:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T12:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T12:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T13:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T13:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T13:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T13:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T13:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T13:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T13:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T13:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T13:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T13:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T13:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T13:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T13:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T13:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T13:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T13:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T13:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T13:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T13:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T13:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T13:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T13:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T13:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T13:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T13:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T13:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T13:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T13:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T13:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T13:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T13:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T13:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T13:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T13:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T14:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T14:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T14:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T14:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T14:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T14:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T14:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T14:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T14:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T14:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T14:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T14:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T14:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T14:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T14:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T14:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T14:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T14:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T14:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T14:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T14:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T14:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T14:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T14:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T14:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T14:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T14:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T14:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T14:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T14:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T14:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T14:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T14:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T14:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T14:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T14:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T14:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T15:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T15:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T15:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T15:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T15:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T15:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T15:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T15:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T15:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T15:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T15:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T15:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T15:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T15:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T15:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T15:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T15:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T15:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T15:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T15:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T15:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T15:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T15:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T15:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T15:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T15:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T15:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T15:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T16:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T16:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T16:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T16:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T16:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T16:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T16:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T16:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T16:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T16:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T16:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T16:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T16:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T16:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T16:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T16:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T16:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T16:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T16:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T16:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T16:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T16:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T16:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T16:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T16:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T16:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T16:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T16:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T16:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T16:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T16:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T17:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T17:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T17:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T17:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T17:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T17:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T17:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T17:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T17:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T17:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T17:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T17:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T17:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T17:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T17:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T17:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T17:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T17:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T17:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T17:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T17:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T17:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T17:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T17:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T17:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T17:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T17:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T17:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T17:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T17:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T17:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T17:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T17:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T17:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T17:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T17:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T18:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T18:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T18:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T18:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T18:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T18:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T18:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T18:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T18:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T18:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T18:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T18:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T18:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T18:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T18:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T18:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T18:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T18:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T18:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T18:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T18:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T18:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T18:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T18:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T18:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T18:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T18:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T18:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T18:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T18:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T18:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T18:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T19:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T19:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T19:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T19:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T19:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T19:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T19:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T19:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T19:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T19:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T19:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T19:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T19:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T19:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T19:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T19:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T19:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T19:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T19:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T19:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T19:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T19:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T19:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T19:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T19:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T19:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T19:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T19:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T19:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T19:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T19:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T20:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T20:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T20:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T20:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T20:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T20:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T20:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T20:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T20:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T20:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T20:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T20:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T20:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T20:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T20:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T20:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T20:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T20:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T20:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T20:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T20:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T20:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T20:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T20:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T20:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T20:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T20:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T20:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T20:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T20:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T21:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T21:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T21:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T21:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T21:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T21:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T21:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T21:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T21:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T21:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T21:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T21:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T21:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T21:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T21:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T21:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T21:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T21:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T21:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T21:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T21:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T21:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T21:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T21:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T21:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T21:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T21:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T22:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T22:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T22:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T22:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T22:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T22:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T22:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T22:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T22:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T22:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T22:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T22:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T22:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T22:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T22:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T22:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T22:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T22:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T22:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T22:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T22:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T22:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T22:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T22:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T22:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T22:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T22:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T22:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T22:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T22:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T23:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T23:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T23:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T23:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T23:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T23:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T23:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T23:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T23:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T23:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T23:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T23:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T23:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T23:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T23:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T23:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T23:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T23:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T23:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T23:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T23:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T23:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T23:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T23:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T23:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T23:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T23:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T23:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T23:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-12T23:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T23:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-12T23:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-12T23:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T00:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T00:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T00:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T00:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T00:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T00:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T00:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T00:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T00:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T00:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T00:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T00:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T00:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T00:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T00:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T00:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T00:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T00:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T00:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T00:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T00:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T00:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T00:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T00:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T00:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T00:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T00:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T00:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T00:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T00:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T00:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T00:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T00:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T00:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T00:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T00:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T00:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T01:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T01:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T01:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T01:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T01:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T01:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T01:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T01:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T01:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T01:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T01:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T01:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T01:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T01:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T01:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T01:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T01:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T01:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T01:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T01:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T01:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T01:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T01:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T01:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T01:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T01:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T01:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T01:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T01:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T01:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T01:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T01:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T02:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T02:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T02:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T02:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T02:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T02:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T02:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T02:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T02:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T02:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T02:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T02:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T02:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T02:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T02:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T02:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T02:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T02:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T02:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T02:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T02:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T02:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T02:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T02:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T02:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T02:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T02:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T03:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T03:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T03:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T03:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T03:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T03:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T03:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T03:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T03:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T03:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T03:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T03:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T03:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T03:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T03:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T03:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T03:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T03:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T03:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T03:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T03:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T03:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T03:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T03:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T03:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T03:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T03:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T03:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T03:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T03:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T03:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T03:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T03:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T04:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T04:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T04:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T04:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T04:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T04:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T04:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T04:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T04:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T04:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T04:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T04:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T04:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T04:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T04:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T04:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T04:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T04:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T04:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T04:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T04:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T04:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T04:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T04:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T04:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T04:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T04:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T04:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T05:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T05:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T05:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T05:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T05:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T05:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T05:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T05:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T05:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T05:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T05:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T05:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T05:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T05:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T05:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T05:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T05:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T05:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T05:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T05:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T05:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T05:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T05:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T05:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T05:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T05:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T05:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T05:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T05:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T05:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T05:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T05:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T05:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T05:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T05:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T06:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T06:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T06:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T06:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T06:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T06:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T06:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T06:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T06:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T06:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T06:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T06:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T06:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T06:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T06:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T06:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T06:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T06:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T06:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T06:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T06:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T06:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T06:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T06:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T06:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T06:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T06:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T06:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T06:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T06:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T06:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T06:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T06:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T06:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T06:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T07:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T07:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T07:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T07:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T07:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T07:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T07:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T07:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T07:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T07:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T07:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T07:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T07:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T07:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T07:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T07:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T07:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T07:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T07:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T07:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T07:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T07:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T07:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T07:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T07:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T07:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T07:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T07:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T07:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T07:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T07:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T07:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T08:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T08:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T08:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T08:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T08:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T08:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T08:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T08:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T08:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T08:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T08:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T08:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T08:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T08:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T08:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T08:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T08:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T08:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T08:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T08:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T08:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T08:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T08:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T08:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T08:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T08:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T08:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T08:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T08:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T08:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T08:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T08:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T09:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T09:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T09:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T09:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T09:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T09:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T09:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T09:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T09:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T09:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T09:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T09:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T09:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T09:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T09:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T09:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T09:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T09:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T09:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T09:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T09:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T09:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T09:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T09:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T09:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T09:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T09:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T09:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T09:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T09:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T09:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T09:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T09:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T09:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T10:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T10:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T10:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T10:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T10:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T10:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T10:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T10:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T10:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T10:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T10:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T10:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T10:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T10:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T10:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T10:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T10:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T10:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T10:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T10:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T10:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T10:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T10:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T10:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T10:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T10:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T10:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T10:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T10:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T10:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T10:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T10:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T10:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T10:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T10:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T10:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T11:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T11:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T11:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T11:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T11:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T11:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T11:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T11:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T11:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T11:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T11:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T11:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T11:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T11:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T11:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T11:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T11:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T11:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T11:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T11:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T11:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T11:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T11:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T11:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T11:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T11:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T11:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T11:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T11:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T11:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T11:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T11:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T11:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T11:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T11:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T11:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T11:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T11:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T11:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T12:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T12:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T12:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T12:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T12:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T12:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T12:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T12:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T12:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T12:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T12:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T12:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T12:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T12:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T12:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T12:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T12:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T12:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T12:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T12:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T12:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T12:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T12:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T12:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T12:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T12:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T12:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T12:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T12:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T12:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T12:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T12:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T12:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T13:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T13:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T13:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T13:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T13:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T13:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T13:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T13:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T13:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T13:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T13:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T13:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T13:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T13:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T13:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T13:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T13:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T13:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T13:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T13:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T13:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T13:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T13:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T13:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T13:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T13:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T13:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T13:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T13:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T13:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T13:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T13:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T13:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T13:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T13:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T13:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T13:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T14:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T14:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T14:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T14:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T14:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T14:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T14:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T14:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T14:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T14:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T14:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T14:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T14:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T14:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T14:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T14:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T14:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T14:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T14:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T14:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T14:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T14:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T14:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T14:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T14:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T14:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T14:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T14:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T14:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T15:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T15:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T15:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T15:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T15:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T15:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T15:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T15:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T15:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T15:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T15:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T15:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T15:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T15:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T15:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T15:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T15:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T15:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T15:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T15:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T15:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T15:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T15:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T15:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T15:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T15:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T15:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T15:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T15:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T15:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T15:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T15:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T15:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T15:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T15:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T15:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T15:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T16:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T16:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T16:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T16:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T16:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T16:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T16:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T16:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T16:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T16:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T16:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T16:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T16:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T16:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T16:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T16:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T16:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T16:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T16:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T16:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T16:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T16:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T16:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T16:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T16:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T16:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T16:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T16:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T16:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T16:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T16:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T16:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T16:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T16:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T16:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T16:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T16:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T16:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T16:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T16:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T16:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T16:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T16:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T16:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T16:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T16:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T16:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T16:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T16:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T16:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T16:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T16:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T16:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T17:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T17:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T17:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T17:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T17:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T17:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T17:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T17:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T17:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T17:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T17:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T17:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T17:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T17:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T17:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T17:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T17:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T17:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T17:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T17:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T17:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T17:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T17:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T17:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T17:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T17:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T17:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T17:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T17:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T18:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T18:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T18:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T18:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T18:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T18:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T18:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T18:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T18:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T18:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T18:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T18:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T18:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T18:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T18:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T18:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T18:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T18:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T18:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T18:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T18:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T18:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T18:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T18:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T18:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T18:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T18:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T18:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T18:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T18:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T19:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T19:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T19:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T19:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T19:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T19:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T19:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T19:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T19:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T19:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T19:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T19:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T19:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T19:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T19:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T19:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T19:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T19:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T19:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T19:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T19:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T19:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T19:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T19:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T19:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T19:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T19:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T19:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T19:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T19:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T19:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T19:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T19:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T19:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T19:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T19:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T19:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T19:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T19:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T19:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T19:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T19:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T19:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T20:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T20:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T20:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T20:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T20:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T20:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T20:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T20:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T20:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T20:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T20:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T20:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T20:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T20:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T20:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T20:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T20:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T20:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T20:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T20:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T20:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T20:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T20:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T20:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T20:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T20:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T20:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T20:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T20:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T20:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T20:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T20:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T20:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T20:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T20:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T21:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T21:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T21:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T21:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T21:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T21:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T21:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T21:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T21:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T21:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T21:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T21:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T21:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T21:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T21:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T21:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T21:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T21:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T21:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T21:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T21:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T21:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T21:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T21:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T21:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T21:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T21:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T21:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T21:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T21:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T21:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T21:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T22:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T22:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T22:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T22:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T22:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T22:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T22:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T22:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T22:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T22:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T22:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T22:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T22:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T22:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T22:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T22:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T22:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T22:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T22:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T22:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T22:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T22:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T22:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T22:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T22:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T22:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T22:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T22:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T22:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T22:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T22:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T22:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T22:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T22:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T22:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T23:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T23:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T23:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T23:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T23:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T23:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T23:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T23:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T23:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T23:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T23:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T23:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T23:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T23:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T23:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T23:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T23:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T23:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T23:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T23:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T23:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T23:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T23:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T23:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T23:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T23:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T23:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T23:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-13T23:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-13T23:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-13T23:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T00:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T00:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T00:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T00:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T00:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T00:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T00:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T00:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T00:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T00:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T00:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T00:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T00:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T00:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T00:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T00:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T00:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T00:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T00:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T00:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T00:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T00:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T00:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T00:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T00:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T00:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T00:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T00:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T00:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T00:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T00:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T00:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T00:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T01:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T01:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T01:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T01:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T01:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T01:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T01:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T01:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T01:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T01:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T01:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T01:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T01:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T01:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T01:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T01:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T01:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T01:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T01:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T01:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T01:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T01:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T01:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T01:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T01:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T01:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T01:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T01:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T01:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T01:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T01:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T01:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T02:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T02:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T02:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T02:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T02:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T02:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T02:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T02:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T02:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T02:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T02:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T02:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T02:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T02:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T02:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T02:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T02:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T02:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T02:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T02:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T02:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T02:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T02:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T02:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T02:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T02:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T02:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T02:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T02:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T02:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T02:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T02:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T03:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T03:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T03:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T03:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T03:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T03:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T03:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T03:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T03:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T03:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T03:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T03:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T03:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T03:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T03:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T03:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T03:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T03:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T03:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T03:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T03:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T03:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T03:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T03:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T03:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T03:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T03:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T04:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T04:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T04:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T04:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T04:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T04:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T04:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T04:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T04:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T04:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T04:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T04:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T04:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T04:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T04:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T04:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T04:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T04:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T04:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T04:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T04:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T04:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T04:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T04:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T04:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T04:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T04:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T04:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T04:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T04:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T04:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T04:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T05:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T05:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T05:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T05:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T05:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T05:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T05:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T05:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T05:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T05:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T05:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T05:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T05:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T05:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T05:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T05:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T05:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T05:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T05:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T05:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T05:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T05:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T05:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T05:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T05:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T05:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T05:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T05:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T05:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T05:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T05:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T05:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T05:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T05:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T05:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T05:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T06:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T06:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T06:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T06:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T06:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T06:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T06:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T06:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T06:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T06:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T06:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T06:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T06:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T06:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T06:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T06:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T06:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T06:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T06:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T06:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T06:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T06:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T06:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T06:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T06:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T06:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T06:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T06:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T06:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T06:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T06:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T06:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T06:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T06:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T06:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T07:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T07:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T07:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T07:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T07:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T07:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T07:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T07:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T07:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T07:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T07:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T07:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T07:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T07:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T07:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T07:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T07:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T07:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T07:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T07:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T07:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T07:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T07:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T07:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T07:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T07:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T07:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T07:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T07:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T07:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T07:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T07:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T07:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T08:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T08:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T08:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T08:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T08:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T08:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T08:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T08:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T08:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T08:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T08:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T08:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T08:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T08:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T08:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T08:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T08:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T08:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T08:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T08:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T08:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T08:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T08:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T08:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T08:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T08:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T09:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T09:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T09:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T09:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T09:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T09:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T09:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T09:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T09:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T09:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T09:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T09:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T09:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T09:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T09:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T09:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T09:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T09:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T09:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T09:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T09:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T09:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T09:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T09:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T09:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T09:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T09:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T09:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T09:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T09:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T09:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T10:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T10:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T10:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T10:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T10:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T10:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T10:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T10:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T10:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T10:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T10:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T10:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T10:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T10:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T10:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T10:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T10:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T10:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T10:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T10:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T10:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T10:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T10:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T10:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T10:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T10:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T10:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T10:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T10:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T11:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T11:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T11:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T11:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T11:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T11:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T11:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T11:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T11:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T11:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T11:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T11:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T11:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T11:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T11:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T11:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T11:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T11:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T11:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T11:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T11:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T11:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T11:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T11:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T11:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T11:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T11:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T11:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T11:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T11:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T11:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T11:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T11:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T11:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T11:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T11:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T11:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T11:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T11:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T12:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T12:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T12:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T12:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T12:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T12:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T12:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T12:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T12:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T12:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T12:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T12:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T12:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T12:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T12:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T12:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T12:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T12:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T12:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T12:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T12:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T12:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T12:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T12:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T12:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T12:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T12:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T12:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T12:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T12:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T12:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T12:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T12:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T13:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T13:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T13:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T13:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T13:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T13:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T13:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T13:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T13:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T13:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T13:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T13:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T13:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T13:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T13:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T13:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T13:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T13:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T13:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T13:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T13:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T13:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T13:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T13:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T13:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T13:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T13:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T13:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T13:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T13:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T14:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T14:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T14:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T14:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T14:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T14:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T14:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T14:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T14:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T14:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T14:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T14:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T14:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T14:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T14:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T14:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T14:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T14:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T14:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T14:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T14:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T14:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T14:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T14:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T14:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T14:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T14:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T14:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T14:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T14:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T14:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T14:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T14:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T14:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T14:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T14:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T14:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T15:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T15:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T15:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T15:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T15:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T15:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T15:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T15:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T15:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T15:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T15:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T15:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T15:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T15:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T15:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T15:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T15:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T15:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T15:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T15:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T15:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T15:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T15:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T15:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T15:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T15:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T15:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T15:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T15:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T15:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T15:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T15:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T15:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T15:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T15:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T15:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T15:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T16:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T16:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T16:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T16:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T16:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T16:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T16:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T16:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T16:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T16:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T16:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T16:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T16:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T16:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T16:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T16:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T16:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T16:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T16:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T16:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T16:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T16:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T16:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T17:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T17:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T17:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T17:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T17:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T17:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T17:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T17:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T17:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T17:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T17:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T17:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T17:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T17:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T17:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T17:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T17:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T17:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T17:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T17:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T17:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T17:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T17:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T17:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T17:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T17:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T17:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T17:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T17:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T17:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T18:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T18:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T18:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T18:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T18:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T18:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T18:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T18:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T18:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T18:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T18:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T18:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T18:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T18:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T18:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T18:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T18:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T18:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T18:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T18:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T18:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T18:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T19:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T19:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T19:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T19:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T19:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T19:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T19:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T19:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T19:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T19:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T19:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T19:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T19:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T19:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T19:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T19:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T19:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T19:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T19:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T19:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T19:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T19:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T19:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T19:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T19:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T19:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T19:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T19:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T19:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T19:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T19:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T19:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T19:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T19:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T20:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T20:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T20:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T20:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T20:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T20:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T20:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T20:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T20:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T20:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T20:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T20:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T20:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T20:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T20:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T20:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T20:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T20:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T20:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T20:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T20:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T20:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T20:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T20:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T20:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T21:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T21:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T21:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T21:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T21:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T21:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T21:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T21:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T21:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T21:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T21:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T21:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T21:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T21:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T21:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T21:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T21:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T21:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T21:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T21:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T21:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T21:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T21:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T21:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T21:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T21:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T21:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T21:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T21:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T21:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T21:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T22:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T22:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T22:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T22:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T22:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T22:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T22:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T22:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T22:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T22:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T22:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T22:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T22:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T22:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T22:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T22:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T22:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T22:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T22:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T22:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T22:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T22:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T22:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T22:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T22:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T22:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T22:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T22:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T22:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T23:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T23:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T23:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T23:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T23:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T23:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T23:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T23:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T23:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T23:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T23:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T23:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T23:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T23:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T23:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T23:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T23:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T23:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T23:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T23:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T23:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T23:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T23:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T23:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T23:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-14T23:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T23:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T23:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-14T23:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-14T23:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T00:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T00:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T00:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T00:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T00:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T00:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T00:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T00:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T00:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T00:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T00:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T00:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T00:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T00:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T00:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T00:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T00:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T00:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T00:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T00:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T00:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T00:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T00:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T00:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T00:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T00:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T00:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T00:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T00:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T00:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T00:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T00:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T00:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T01:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T01:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T01:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T01:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T01:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T01:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T01:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T01:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T01:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T01:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T01:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T01:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T01:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T01:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T01:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T01:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T01:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T01:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T01:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T01:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T01:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T01:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T01:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T01:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T01:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T01:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T02:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T02:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T02:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T02:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T02:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T02:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T02:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T02:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T02:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T02:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T02:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T02:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T02:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T02:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T02:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T02:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T02:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T02:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T02:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T02:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T02:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T02:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T02:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T02:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T02:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T02:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T02:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T02:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T02:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T02:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T02:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T02:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T02:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T02:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T02:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T02:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T02:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T03:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T03:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T03:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T03:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T03:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T03:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T03:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T03:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T03:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T03:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T03:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T03:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T03:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T03:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T03:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T03:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T03:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T03:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T03:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T03:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T03:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T03:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T03:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T03:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T03:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T03:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T03:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T04:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T04:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T04:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T04:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T04:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T04:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T04:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T04:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T04:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T04:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T04:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T04:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T04:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T04:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T04:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T04:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T04:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T04:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T04:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T04:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T04:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T04:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T04:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T04:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T04:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T04:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T04:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T04:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T04:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T04:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T04:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T04:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T04:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T04:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T04:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T04:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T04:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T04:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T04:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T04:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T05:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T05:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T05:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T05:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T05:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T05:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T05:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T05:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T05:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T05:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T05:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T05:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T05:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T05:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T05:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T05:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T05:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T05:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T05:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T05:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T05:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T05:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T05:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T05:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T05:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T05:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T05:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T05:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T05:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T05:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T05:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T06:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T06:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T06:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T06:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T06:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T06:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T06:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T06:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T06:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T06:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T06:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T06:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T06:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T06:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T06:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T06:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T06:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T06:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T06:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T06:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T06:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T06:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T06:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T06:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T06:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T06:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T06:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T06:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T07:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T07:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T07:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T07:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T07:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T07:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T07:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T07:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T07:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T07:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T07:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T07:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T07:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T07:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T07:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T07:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T07:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T07:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T07:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T07:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T07:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T07:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T07:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T07:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T07:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T07:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T07:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T07:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T07:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T07:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T07:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T07:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T07:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T07:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T07:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T07:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T07:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T07:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T08:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T08:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T08:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T08:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T08:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T08:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T08:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T08:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T08:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T08:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T08:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T08:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T08:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T08:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T08:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T08:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T08:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T08:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T08:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T08:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T08:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T08:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T08:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T08:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T08:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T08:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T08:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T09:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T09:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T09:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T09:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T09:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T09:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T09:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T09:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T09:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T09:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T09:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T09:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T09:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T09:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T09:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T09:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T09:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T09:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T09:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T09:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T09:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T09:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T09:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T09:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T09:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T09:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T09:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T09:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T09:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T09:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T09:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T09:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T09:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T09:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T09:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T10:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T10:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T10:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T10:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T10:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T10:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T10:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T10:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T10:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T10:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T10:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T10:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T10:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T10:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T10:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T10:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T10:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T10:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T10:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T10:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T10:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T10:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T10:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T10:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T10:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T10:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T10:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T10:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T10:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T10:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T10:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T11:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T11:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T11:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T11:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T11:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T11:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T11:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T11:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T11:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T11:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T11:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T11:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T11:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T11:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T11:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T11:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T11:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T11:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T11:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T11:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T11:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T11:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T11:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T11:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T11:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T11:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T11:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T11:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T11:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T11:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T11:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T11:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T11:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T11:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T11:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T11:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T11:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T11:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T11:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T11:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T12:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T12:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T12:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T12:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T12:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T12:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T12:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T12:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T12:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T12:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T12:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T12:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T12:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T12:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T12:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T12:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T12:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T12:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T12:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T12:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T12:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T12:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T12:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T12:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T12:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T12:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T12:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T12:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T12:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T13:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T13:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T13:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T13:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T13:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T13:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T13:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T13:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T13:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T13:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T13:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T13:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T13:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T13:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T13:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T13:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T13:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T13:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T13:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T13:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T13:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T13:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T13:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T13:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T13:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T13:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T13:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T13:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T13:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T13:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T13:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T13:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T14:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T14:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T14:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T14:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T14:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T14:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T14:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T14:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T14:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T14:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T14:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T14:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T14:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T14:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T14:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T14:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T14:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T14:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T14:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T14:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T14:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T14:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T14:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T14:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T14:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T14:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T14:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T14:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T14:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T15:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T15:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T15:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T15:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T15:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T15:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T15:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T15:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T15:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T15:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T15:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T15:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T15:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T15:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T15:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T15:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T15:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T15:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T15:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T15:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T15:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T15:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T15:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T15:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T15:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T15:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T15:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T15:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T15:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T15:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T15:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T15:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T15:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T15:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T16:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T16:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T16:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T16:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T16:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T16:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T16:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T16:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T16:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T16:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T16:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T16:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T16:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T16:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T16:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T16:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T16:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T16:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T16:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T16:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T16:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T16:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T16:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T16:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T16:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T16:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T16:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T16:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T16:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T17:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T17:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T17:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T17:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T17:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T17:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T17:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T17:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T17:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T17:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T17:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T17:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T17:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T17:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T17:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T17:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T17:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T17:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T17:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T17:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T17:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T17:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T17:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T17:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T17:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T17:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T17:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T17:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T17:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T17:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T17:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T17:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T17:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T17:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T17:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T17:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T18:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T18:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T18:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T18:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T18:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T18:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T18:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T18:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T18:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T18:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T18:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T18:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T18:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T18:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T18:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T18:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T18:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T18:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T18:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T18:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T18:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T18:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T18:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T18:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T18:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T18:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T18:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T18:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T18:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T18:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T18:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T18:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T18:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T19:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T19:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T19:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T19:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T19:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T19:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T19:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T19:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T19:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T19:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T19:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T19:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T19:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T19:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T19:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T19:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T19:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T19:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T19:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T19:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T19:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T19:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T19:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T19:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T19:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T19:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T19:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T19:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T19:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T19:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T19:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T19:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T19:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T19:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T19:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T19:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T20:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T20:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T20:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T20:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T20:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T20:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T20:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T20:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T20:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T20:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T20:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T20:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T20:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T20:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T20:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T20:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T20:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T20:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T20:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T20:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T20:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T20:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T20:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T20:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T20:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T20:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T20:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T20:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T20:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T20:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T20:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T20:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T20:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T20:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T20:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T20:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T21:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T21:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T21:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T21:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T21:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T21:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T21:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T21:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T21:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T21:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T21:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T21:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T21:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T21:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T21:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T21:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T21:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T21:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T21:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T21:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T21:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T21:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T21:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T21:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T21:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T21:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T21:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T21:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T22:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T22:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T22:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T22:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T22:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T22:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T22:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T22:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T22:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T22:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T22:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T22:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T22:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T22:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T22:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T22:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T22:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T22:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T22:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T22:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T22:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T22:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T22:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T22:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T22:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T22:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T22:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T22:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T22:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T22:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T22:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T22:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T22:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T22:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T22:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T22:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T22:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T22:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T22:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T22:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T22:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T22:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T22:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T22:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T23:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T23:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T23:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T23:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T23:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T23:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T23:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T23:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T23:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T23:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T23:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T23:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T23:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T23:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T23:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T23:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T23:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T23:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T23:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T23:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T23:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T23:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T23:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T23:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T23:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T23:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T23:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T23:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T23:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-15T23:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T23:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T23:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-15T23:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-15T23:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T00:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T00:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T00:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T00:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T00:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T00:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T00:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T00:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T00:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T00:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T00:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T00:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T00:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T00:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T00:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T00:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T00:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T00:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T00:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T00:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T00:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T00:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T00:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T00:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T00:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T00:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T00:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T00:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T00:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T00:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T00:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T00:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T01:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T01:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T01:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T01:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T01:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T01:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T01:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T01:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T01:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T01:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T01:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T01:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T01:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T01:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T01:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T01:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T01:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T01:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T01:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T01:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T01:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T01:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T01:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T01:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T01:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T01:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T01:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T02:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T02:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T02:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T02:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T02:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T02:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T02:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T02:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T02:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T02:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T02:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T02:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T02:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T02:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T02:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T02:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T02:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T02:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T02:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T02:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T02:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T02:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T02:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T02:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T02:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T02:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T02:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T02:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T02:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T02:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T02:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T02:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T02:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T02:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T02:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T02:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T02:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T02:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T02:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T02:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T02:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T03:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T03:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T03:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T03:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T03:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T03:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T03:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T03:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T03:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T03:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T03:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T03:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T03:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T03:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T03:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T03:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T03:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T03:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T03:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T03:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T03:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T03:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T03:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T03:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T03:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T03:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T03:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T03:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T03:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T03:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T03:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T03:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T03:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T03:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T03:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T03:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T04:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T04:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T04:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T04:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T04:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T04:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T04:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T04:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T04:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T04:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T04:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T04:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T04:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T04:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T04:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T04:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T04:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T04:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T04:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T04:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T04:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T04:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T04:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T04:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T04:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T04:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T04:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T04:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T04:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T04:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T05:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T05:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T05:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T05:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T05:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T05:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T05:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T05:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T05:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T05:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T05:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T05:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T05:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T05:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T05:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T05:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T05:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T05:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T05:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T05:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T05:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T05:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T05:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T05:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T05:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T05:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T06:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T06:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T06:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T06:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T06:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T06:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T06:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T06:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T06:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T06:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T06:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T06:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T06:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T06:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T06:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T06:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T06:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T06:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T06:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T06:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T06:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T06:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T06:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T06:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T06:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T06:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T06:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T06:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T06:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T07:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T07:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T07:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T07:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T07:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T07:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T07:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T07:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T07:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T07:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T07:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T07:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T07:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T07:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T07:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T07:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T07:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T07:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T07:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T07:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T07:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T07:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T07:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T07:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T07:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T07:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T07:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T07:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T07:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T07:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T08:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T08:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T08:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T08:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T08:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T08:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T08:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T08:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T08:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T08:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T08:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T08:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T08:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T08:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T08:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T08:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T08:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T08:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T08:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T08:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T08:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T08:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T08:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T08:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T08:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T08:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T08:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T08:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T08:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T08:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T08:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T08:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T08:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T08:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T08:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T08:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T08:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T09:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T09:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T09:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T09:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T09:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T09:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T09:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T09:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T09:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T09:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T09:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T09:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T09:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T09:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T09:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T09:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T09:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T09:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T09:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T09:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T09:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T09:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T09:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T09:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T09:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T09:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T09:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T10:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T10:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T10:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T10:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T10:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T10:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T10:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T10:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T10:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T10:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T10:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T10:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T10:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T10:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T10:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T10:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T10:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T10:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T10:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T10:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T10:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T10:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T10:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T10:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T10:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T10:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T10:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T10:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T11:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T11:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T11:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T11:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T11:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T11:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T11:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T11:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T11:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T11:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T11:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T11:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T11:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T11:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T11:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T11:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T11:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T11:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T11:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T11:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T11:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T11:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T11:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T11:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T11:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T11:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T11:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T11:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T11:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T11:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T11:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T11:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T11:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T11:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T12:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T12:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T12:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T12:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T12:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T12:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T12:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T12:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T12:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T12:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T12:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T12:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T12:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T12:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T12:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T12:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T12:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T12:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T12:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T12:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T12:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T12:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T12:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T12:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T12:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T12:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T12:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T12:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T12:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T12:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T12:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T12:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T12:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T12:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T12:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T13:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T13:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T13:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T13:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T13:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T13:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T13:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T13:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T13:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T13:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T13:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T13:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T13:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T13:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T13:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T13:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T13:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T13:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T13:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T13:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T13:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T13:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T13:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T13:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T13:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T13:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T13:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T13:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T13:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T13:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T13:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T13:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T14:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T14:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T14:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T14:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T14:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T14:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T14:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T14:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T14:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T14:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T14:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T14:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T14:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T14:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T14:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T14:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T14:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T14:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T14:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T14:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T14:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T14:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T14:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T14:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T14:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T14:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T14:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T14:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T14:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T14:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T14:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T14:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T14:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T14:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T14:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T14:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T14:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T14:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T14:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T14:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T14:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T14:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T14:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T14:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T15:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T15:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T15:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T15:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T15:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T15:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T15:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T15:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T15:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T15:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T15:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T15:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T15:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T15:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T15:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T15:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T15:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T15:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T15:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T15:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T15:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T15:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T15:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T15:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T15:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T15:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T15:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T15:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T15:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T15:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T15:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T15:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T15:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T15:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T15:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T15:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T15:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T15:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T15:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T15:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T16:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T16:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T16:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T16:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T16:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T16:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T16:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T16:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T16:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T16:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T16:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T16:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T16:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T16:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T16:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T16:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T16:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T16:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T16:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T16:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T16:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T16:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T16:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T16:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T16:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T16:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T16:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T16:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T16:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T16:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T16:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T16:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T16:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T16:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T16:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T16:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T16:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T16:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T16:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T16:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T16:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T16:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T16:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T17:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T17:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T17:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T17:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T17:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T17:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T17:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T17:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T17:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T17:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T17:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T17:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T17:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T17:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T17:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T17:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T17:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T17:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T17:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T17:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T17:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T17:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T17:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T17:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T17:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T17:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T17:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T17:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T17:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T17:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T17:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T17:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T17:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T17:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T17:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T17:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T17:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T17:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T17:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T17:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T18:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T18:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T18:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T18:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T18:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T18:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T18:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T18:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T18:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T18:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T18:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T18:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T18:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T18:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T18:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T18:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T18:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T18:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T18:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T18:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T18:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T18:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T18:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T18:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T18:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T18:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T18:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T18:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T18:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T18:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T18:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T18:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T18:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T18:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T18:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T18:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T18:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T18:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T19:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T19:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T19:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T19:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T19:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T19:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T19:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T19:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T19:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T19:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T19:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T19:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T19:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T19:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T19:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T19:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T19:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T19:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T19:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T19:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T19:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T19:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T19:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T19:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T19:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T19:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T19:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T19:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T19:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T19:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T19:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T19:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T19:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T19:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T19:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T20:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T20:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T20:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T20:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T20:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T20:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T20:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T20:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T20:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T20:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T20:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T20:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T20:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T20:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T20:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T20:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T20:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T20:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T20:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T20:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T20:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T20:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T20:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T20:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T20:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T20:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T20:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T20:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T20:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T20:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T21:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T21:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T21:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T21:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T21:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T21:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T21:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T21:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T21:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T21:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T21:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T21:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T21:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T21:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T21:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T21:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T21:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T21:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T21:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T21:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T21:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T21:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T21:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T21:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T21:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T21:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T21:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T22:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T22:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T22:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T22:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T22:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T22:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T22:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T22:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T22:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T22:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T22:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T22:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T22:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T22:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T22:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T22:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T22:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T22:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T22:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T22:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T22:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T22:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T22:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T22:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T22:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T22:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T22:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T22:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T22:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T22:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T22:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T22:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T23:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T23:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T23:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T23:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T23:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T23:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T23:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T23:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T23:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T23:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T23:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T23:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T23:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T23:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T23:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T23:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T23:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T23:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T23:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T23:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T23:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T23:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T23:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-16T23:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T23:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T23:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T23:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T23:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T23:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T23:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-16T23:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T23:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-16T23:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T00:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T00:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T00:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T00:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T00:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T00:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T00:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T00:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T00:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T00:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T00:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T00:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T00:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T00:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T00:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T00:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T00:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T00:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T00:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T00:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T00:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T00:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T00:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T00:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T00:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T00:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T00:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T00:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T00:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T00:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T00:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T00:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T00:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T00:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T01:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T01:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T01:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T01:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T01:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T01:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T01:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T01:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T01:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T01:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T01:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T01:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T01:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T01:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T01:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T01:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T01:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T01:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T01:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T01:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T01:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T01:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T01:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T01:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T01:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T01:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T01:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T01:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T01:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T01:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T01:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T01:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T01:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T01:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T01:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T01:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T01:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T01:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T01:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T01:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T02:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T02:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T02:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T02:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T02:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T02:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T02:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T02:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T02:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T02:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T02:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T02:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T02:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T02:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T02:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T02:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T02:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T02:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T02:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T02:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T02:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T02:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T02:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T02:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T02:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T02:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T02:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T02:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T02:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T02:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T02:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T02:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T02:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T02:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T03:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T03:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T03:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T03:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T03:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T03:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T03:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T03:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T03:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T03:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T03:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T03:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T03:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T03:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T03:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T03:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T03:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T03:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T03:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T03:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T03:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T03:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T03:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T03:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T03:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T03:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T03:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T03:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T03:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T03:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T03:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T03:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T03:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T03:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T04:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T04:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T04:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T04:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T04:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T04:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T04:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T04:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T04:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T04:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T04:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T04:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T04:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T04:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T04:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T04:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T04:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T04:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T04:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T04:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T04:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T04:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T04:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T04:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T04:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T04:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T04:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T04:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T05:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T05:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T05:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T05:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T05:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T05:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T05:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T05:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T05:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T05:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T05:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T05:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T05:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T05:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T05:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T05:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T05:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T05:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T05:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T05:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T05:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T05:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T05:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T05:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T05:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T05:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T05:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T05:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T05:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T05:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T05:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T05:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T05:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T06:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T06:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T06:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T06:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T06:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T06:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T06:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T06:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T06:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T06:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T06:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T06:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T06:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T06:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T06:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T06:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T06:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T06:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T06:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T06:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T06:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T06:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T06:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T06:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T06:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T06:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T06:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T06:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T06:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T06:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T07:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T07:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T07:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T07:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T07:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T07:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T07:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T07:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T07:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T07:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T07:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T07:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T07:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T07:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T07:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T07:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T07:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T07:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T07:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T07:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T07:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T07:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T07:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T07:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T07:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T07:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T07:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T07:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T07:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T07:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T07:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T08:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T08:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T08:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T08:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T08:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T08:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T08:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T08:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T08:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T08:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T08:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T08:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T08:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T08:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T08:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T08:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T08:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T08:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T08:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T08:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T08:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T08:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T08:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T08:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T08:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T08:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T08:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T08:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T08:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T08:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T08:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T08:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T08:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T09:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T09:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T09:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T09:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T09:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T09:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T09:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T09:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T09:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T09:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T09:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T09:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T09:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T09:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T09:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T09:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T09:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T09:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T09:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T09:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T09:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T09:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T09:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T09:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T09:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T09:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T09:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T09:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T09:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T09:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T09:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T09:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T09:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T09:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T09:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T09:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T09:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T09:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T10:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T10:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T10:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T10:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T10:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T10:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T10:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T10:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T10:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T10:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T10:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T10:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T10:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T10:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T10:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T10:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T10:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T10:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T10:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T10:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T10:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T10:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T10:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T10:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T10:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T10:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T10:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T10:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T10:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T10:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T10:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T10:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T10:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T10:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T10:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T11:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T11:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T11:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T11:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T11:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T11:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T11:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T11:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T11:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T11:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T11:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T11:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T11:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T11:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T11:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T11:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T11:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T11:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T11:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T11:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T11:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T11:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T11:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T11:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T11:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T11:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T12:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T12:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T12:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T12:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T12:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T12:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T12:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T12:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T12:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T12:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T12:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T12:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T12:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T12:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T12:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T12:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T12:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T12:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T12:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T12:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T12:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T12:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T12:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T12:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T12:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T12:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T12:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T12:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T12:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T13:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T13:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T13:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T13:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T13:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T13:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T13:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T13:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T13:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T13:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T13:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T13:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T13:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T13:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T13:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T13:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T13:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T13:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T13:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T13:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T13:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T13:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T13:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T13:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T13:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T13:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T13:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T13:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T13:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T13:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T13:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T13:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T14:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T14:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T14:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T14:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T14:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T14:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T14:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T14:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T14:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T14:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T14:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T14:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T14:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T14:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T14:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T14:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T14:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T14:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T14:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T14:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T14:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T14:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T14:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T14:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T14:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T15:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T15:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T15:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T15:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T15:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T15:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T15:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T15:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T15:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T15:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T15:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T15:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T15:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T15:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T15:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T15:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T15:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T15:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T15:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T15:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T15:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T15:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T15:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T15:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T15:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T15:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T15:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T15:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T15:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T15:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T15:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T15:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T16:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T16:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T16:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T16:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T16:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T16:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T16:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T16:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T16:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T16:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T16:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T16:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T16:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T16:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T16:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T16:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T16:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T16:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T16:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T16:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T16:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T16:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T16:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T16:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T16:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T16:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T16:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T16:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T16:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T16:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T16:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T16:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T16:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T17:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T17:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T17:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T17:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T17:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T17:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T17:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T17:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T17:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T17:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T17:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T17:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T17:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T17:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T17:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T17:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T17:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T17:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T17:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T17:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T17:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T17:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T17:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T17:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T17:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T17:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T17:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T17:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T17:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T17:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T17:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T17:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T17:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T17:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T18:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T18:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T18:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T18:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T18:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T18:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T18:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T18:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T18:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T18:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T18:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T18:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T18:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T18:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T18:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T18:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T18:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T18:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T18:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T18:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T18:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T18:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T18:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T18:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T18:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T18:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T18:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T18:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T18:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T18:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T18:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T18:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T18:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T18:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T18:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T18:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T18:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T18:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T18:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T18:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T18:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T19:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T19:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T19:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T19:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T19:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T19:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T19:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T19:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T19:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T19:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T19:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T19:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T19:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T19:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T19:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T19:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T19:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T19:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T19:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T19:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T19:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T19:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T19:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T19:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T19:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T19:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T19:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T19:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T19:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T19:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T19:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T19:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T19:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T20:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T20:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T20:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T20:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T20:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T20:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T20:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T20:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T20:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T20:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T20:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T20:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T20:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T20:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T20:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T20:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T20:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T20:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T20:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T20:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T20:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T20:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T20:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T20:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T20:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T20:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T20:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T20:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T20:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T20:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T20:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T20:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T20:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T20:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T20:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T21:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T21:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T21:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T21:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T21:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T21:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T21:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T21:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T21:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T21:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T21:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T21:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T21:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T21:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T21:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T21:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T21:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T21:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T21:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T21:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T21:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T21:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T21:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T21:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T21:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T21:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T21:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T21:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T21:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T21:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T22:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T22:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T22:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T22:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T22:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T22:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T22:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T22:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T22:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T22:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T22:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T22:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T22:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T22:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T22:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T22:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T22:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T22:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T22:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T22:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T22:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T22:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T22:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T22:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T22:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T23:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T23:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T23:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T23:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T23:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T23:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T23:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T23:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T23:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T23:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T23:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T23:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T23:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T23:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T23:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T23:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T23:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T23:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T23:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T23:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T23:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T23:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T23:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T23:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T23:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T23:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T23:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T23:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T23:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-17T23:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-17T23:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-17T23:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T00:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T00:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T00:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T00:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T00:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T00:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T00:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T00:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T00:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T00:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T00:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T00:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T00:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T00:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T00:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T00:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T00:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T00:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T00:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T00:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T00:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T00:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T00:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T00:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T00:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T00:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T00:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T01:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T01:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T01:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T01:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T01:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T01:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T01:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T01:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T01:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T01:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T01:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T01:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T01:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T01:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T01:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T01:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T01:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T01:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T01:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T01:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T01:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T01:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T01:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T01:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T01:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T01:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T01:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T02:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T02:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T02:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T02:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T02:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T02:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T02:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T02:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T02:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T02:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T02:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T02:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T02:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T02:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T02:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T02:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T02:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T02:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T02:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T02:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T02:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T02:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T02:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T02:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T02:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T02:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T02:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T02:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T02:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T02:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T02:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T02:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T02:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T02:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T03:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T03:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T03:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T03:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T03:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T03:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T03:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T03:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T03:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T03:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T03:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T03:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T03:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T03:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T03:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T03:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T03:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T03:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T03:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T03:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T03:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T03:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T03:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T04:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T04:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T04:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T04:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T04:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T04:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T04:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T04:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T04:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T04:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T04:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T04:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T04:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T04:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T04:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T04:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T04:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T04:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T04:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T04:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T04:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T04:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T04:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T04:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T04:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T04:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T05:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T05:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T05:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T05:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T05:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T05:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T05:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T05:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T05:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T05:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T05:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T05:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T05:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T05:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T05:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T05:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T05:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T05:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T05:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T05:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T05:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T05:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T05:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T05:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T05:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T05:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T05:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T05:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T05:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T05:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T05:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T05:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T05:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T05:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T05:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T05:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T06:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T06:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T06:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T06:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T06:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T06:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T06:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T06:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T06:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T06:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T06:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T06:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T06:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T06:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T06:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T06:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T06:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T06:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T06:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T06:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T06:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T06:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T06:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T06:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T06:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T06:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T06:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T06:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T06:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T06:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T06:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T06:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T06:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T06:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T07:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T07:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T07:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T07:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T07:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T07:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T07:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T07:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T07:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T07:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T07:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T07:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T07:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T07:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T07:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T07:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T07:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T07:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T07:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T07:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T07:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T07:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T07:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T07:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T07:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T07:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T07:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T07:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T07:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T07:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T07:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T07:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T07:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T08:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T08:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T08:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T08:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T08:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T08:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T08:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T08:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T08:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T08:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T08:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T08:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T08:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T08:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T08:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T08:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T08:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T08:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T08:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T08:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T08:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T08:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T08:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T08:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T08:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T08:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T08:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T08:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T08:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T08:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T08:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T08:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T08:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T09:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T09:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T09:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T09:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T09:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T09:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T09:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T09:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T09:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T09:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T09:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T09:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T09:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T09:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T09:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T09:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T09:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T09:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T09:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T09:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T09:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T09:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T09:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T09:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T09:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T09:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T09:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T09:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T09:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T09:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T09:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T10:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T10:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T10:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T10:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T10:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T10:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T10:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T10:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T10:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T10:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T10:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T10:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T10:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T10:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T10:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T10:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T10:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T10:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T10:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T10:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T10:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T10:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T10:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T10:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T10:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T10:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T10:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T10:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T10:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T10:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T10:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T11:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T11:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T11:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T11:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T11:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T11:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T11:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T11:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T11:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T11:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T11:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T11:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T11:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T11:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T11:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T11:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T11:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T11:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T11:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T11:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T11:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T11:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T11:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T12:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T12:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T12:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T12:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T12:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T12:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T12:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T12:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T12:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T12:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T12:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T12:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T12:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T12:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T12:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T12:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T12:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T12:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T12:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T12:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T12:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T12:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T12:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T12:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T12:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T12:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T12:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T12:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T12:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T12:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T12:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T12:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T12:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T12:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T12:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T12:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T12:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T12:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T12:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T12:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T12:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T12:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T12:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T12:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T13:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T13:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T13:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T13:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T13:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T13:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T13:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T13:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T13:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T13:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T13:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T13:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T13:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T13:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T13:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T13:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T13:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T13:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T13:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T13:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T13:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T13:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T13:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T13:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T13:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T13:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T13:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T13:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T13:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T13:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T14:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T14:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T14:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T14:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T14:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T14:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T14:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T14:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T14:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T14:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T14:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T14:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T14:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T14:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T14:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T14:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T14:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T14:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T14:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T14:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T14:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T14:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T14:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T14:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T14:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T14:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T14:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T14:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T15:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T15:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T15:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T15:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T15:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T15:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T15:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T15:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T15:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T15:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T15:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T15:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T15:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T15:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T15:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T15:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T15:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T15:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T15:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T15:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T15:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T15:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T15:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T15:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T15:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T15:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T15:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T15:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T15:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T15:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T15:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T16:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T16:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T16:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T16:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T16:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T16:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T16:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T16:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T16:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T16:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T16:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T16:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T16:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T16:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T16:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T16:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T16:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T16:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T16:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T16:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T16:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T16:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T16:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T16:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T16:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T16:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T16:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T16:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T16:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T16:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T17:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T17:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T17:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T17:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T17:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T17:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T17:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T17:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T17:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T17:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T17:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T17:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T17:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T17:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T17:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T17:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T17:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T17:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T17:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T17:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T17:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T17:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T17:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T17:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T17:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T17:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T17:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T17:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T17:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T18:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T18:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T18:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T18:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T18:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T18:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T18:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T18:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T18:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T18:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T18:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T18:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T18:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T18:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T18:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T18:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T18:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T18:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T18:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T18:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T18:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T18:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T18:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T18:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T18:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T18:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T18:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T18:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T18:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T18:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T18:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T18:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T18:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T18:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T18:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T18:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T18:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T18:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T18:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T18:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T18:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T19:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T19:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T19:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T19:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T19:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T19:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T19:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T19:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T19:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T19:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T19:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T19:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T19:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T19:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T19:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T19:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T19:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T19:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T19:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T19:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T19:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T19:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T19:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T19:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T19:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T19:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T19:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T19:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T19:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T19:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T19:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T19:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T19:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T19:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T19:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T20:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T20:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T20:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T20:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T20:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T20:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T20:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T20:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T20:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T20:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T20:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T20:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T20:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T20:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T20:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T20:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T20:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T20:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T20:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T20:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T20:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T20:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T20:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T20:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T20:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T20:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T20:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T20:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T20:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T20:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T20:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T21:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T21:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T21:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T21:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T21:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T21:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T21:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T21:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T21:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T21:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T21:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T21:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T21:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T21:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T21:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T21:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T21:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T21:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T21:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T21:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T21:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T21:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T21:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T21:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T21:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T21:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T21:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T21:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T21:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T21:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T21:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T21:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T21:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T21:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T21:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T21:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T21:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T21:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T21:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T21:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T21:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T21:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T21:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T22:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T22:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T22:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T22:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T22:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T22:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T22:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T22:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T22:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T22:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T22:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T22:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T22:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T22:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T22:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T22:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T22:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T22:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T22:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T22:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T22:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T22:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T22:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T22:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T23:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T23:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T23:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T23:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T23:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T23:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T23:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T23:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T23:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T23:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T23:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T23:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T23:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T23:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T23:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T23:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T23:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T23:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T23:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T23:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T23:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T23:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T23:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T23:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T23:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T23:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T23:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-18T23:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-18T23:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T23:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-18T23:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T00:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T00:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T00:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T00:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T00:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T00:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T00:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T00:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T00:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T00:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T00:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T00:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T00:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T00:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T00:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T00:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T00:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T00:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T00:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T00:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T00:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T00:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T00:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T01:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T01:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T01:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T01:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T01:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T01:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T01:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T01:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T01:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T01:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T01:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T01:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T01:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T01:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T01:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T01:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T01:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T01:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T01:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T01:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T01:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T01:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T01:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T01:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T01:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T01:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T01:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T01:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T01:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T01:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T02:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T02:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T02:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T02:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T02:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T02:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T02:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T02:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T02:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T02:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T02:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T02:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T02:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T02:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T02:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T02:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T02:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T02:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T02:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T02:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T02:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T02:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T02:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T02:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T02:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T02:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T03:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T03:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T03:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T03:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T03:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T03:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T03:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T03:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T03:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T03:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T03:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T03:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T03:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T03:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T03:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T03:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T03:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T03:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T03:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T03:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T03:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T03:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T03:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T03:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T03:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T03:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T03:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T03:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T03:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T03:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T03:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T03:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T03:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T03:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T03:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T04:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T04:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T04:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T04:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T04:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T04:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T04:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T04:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T04:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T04:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T04:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T04:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T04:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T04:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T04:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T04:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T04:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T04:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T04:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T04:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T04:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T04:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T04:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T04:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T04:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T04:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T04:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T04:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T04:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T04:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T04:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T05:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T05:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T05:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T05:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T05:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T05:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T05:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T05:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T05:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T05:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T05:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T05:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T05:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T05:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T05:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T05:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T05:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T05:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T05:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T05:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T05:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T05:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T05:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T05:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T05:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T05:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T05:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T05:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T05:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T05:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T05:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T06:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T06:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T06:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T06:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T06:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T06:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T06:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T06:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T06:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T06:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T06:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T06:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T06:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T06:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T06:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T06:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T06:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T06:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T06:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T06:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T06:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T06:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T06:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T06:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T06:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T06:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T06:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T06:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T06:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T06:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T07:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T07:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T07:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T07:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T07:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T07:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T07:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T07:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T07:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T07:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T07:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T07:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T07:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T07:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T07:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T07:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T07:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T07:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T07:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T07:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T07:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T07:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T07:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T07:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T07:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T07:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T07:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T07:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T07:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T07:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T07:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T07:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T07:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T07:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T07:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T07:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T08:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T08:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T08:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T08:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T08:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T08:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T08:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T08:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T08:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T08:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T08:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T08:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T08:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T08:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T08:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T08:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T08:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T08:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T08:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T08:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T08:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T08:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T09:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T09:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T09:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T09:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T09:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T09:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T09:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T09:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T09:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T09:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T09:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T09:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T09:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T09:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T09:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T09:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T09:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T09:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T09:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T09:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T09:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T09:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T09:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T09:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T09:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T09:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T09:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T09:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T09:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T09:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T09:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T09:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T09:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T09:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T09:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T09:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T09:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T09:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T09:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T10:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T10:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T10:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T10:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T10:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T10:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T10:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T10:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T10:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T10:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T10:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T10:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T10:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T10:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T10:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T10:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T10:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T10:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T10:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T10:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T10:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T10:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T10:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T10:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T10:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T10:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T10:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T10:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T10:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T10:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T10:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T10:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T10:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T10:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T10:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T11:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T11:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T11:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T11:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T11:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T11:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T11:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T11:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T11:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T11:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T11:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T11:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T11:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T11:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T11:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T11:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T11:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T11:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T11:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T11:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T11:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T11:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T11:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T11:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T11:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T11:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T11:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T11:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T11:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T11:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T12:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T12:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T12:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T12:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T12:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T12:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T12:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T12:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T12:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T12:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T12:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T12:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T12:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T12:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T12:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T12:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T12:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T12:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T12:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T12:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T12:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T12:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T12:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T12:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T12:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T12:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T12:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T12:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T12:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T12:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T12:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T12:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T13:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T13:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T13:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T13:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T13:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T13:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T13:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T13:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T13:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T13:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T13:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T13:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T13:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T13:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T13:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T13:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T13:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T13:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T13:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T13:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T13:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T13:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T13:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T13:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T13:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T13:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T13:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T13:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T13:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T13:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T13:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T13:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T13:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T13:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T13:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T13:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T13:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T13:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T14:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T14:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T14:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T14:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T14:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T14:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T14:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T14:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T14:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T14:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T14:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T14:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T14:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T14:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T14:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T14:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T14:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T14:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T14:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T14:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T14:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T14:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T14:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T14:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T14:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T14:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T14:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T14:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T14:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T14:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T14:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T14:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T14:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T14:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T14:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T14:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T14:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T14:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T14:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T15:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T15:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T15:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T15:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T15:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T15:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T15:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T15:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T15:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T15:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T15:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T15:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T15:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T15:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T15:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T15:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T15:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T15:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T15:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T15:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T15:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T15:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T15:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T15:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T15:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T15:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T16:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T16:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T16:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T16:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T16:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T16:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T16:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T16:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T16:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T16:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T16:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T16:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T16:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T16:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T16:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T16:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T16:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T16:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T16:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T16:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T16:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T16:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T16:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T16:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T16:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T16:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T16:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T17:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T17:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T17:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T17:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T17:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T17:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T17:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T17:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T17:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T17:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T17:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T17:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T17:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T17:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T17:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T17:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T17:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T17:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T17:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T17:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T17:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T17:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T17:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T17:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T17:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T17:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T17:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T17:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T17:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T17:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T17:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T17:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T17:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T17:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T17:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T17:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T17:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T18:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T18:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T18:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T18:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T18:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T18:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T18:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T18:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T18:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T18:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T18:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T18:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T18:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T18:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T18:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T18:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T18:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T18:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T18:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T18:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T18:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T18:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T18:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T18:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T18:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T18:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T18:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T18:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T18:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T18:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T18:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T18:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T18:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T18:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T18:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T19:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T19:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T19:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T19:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T19:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T19:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T19:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T19:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T19:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T19:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T19:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T19:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T19:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T19:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T19:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T19:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T19:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T19:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T19:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T19:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T19:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T19:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T19:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T19:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T19:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T19:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T19:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T19:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T20:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T20:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T20:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T20:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T20:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T20:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T20:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T20:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T20:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T20:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T20:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T20:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T20:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T20:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T20:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T20:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T20:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T20:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T20:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T20:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T20:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T20:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T20:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T20:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T20:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T20:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T20:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T20:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T20:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T20:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T20:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T20:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T20:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T20:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T21:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T21:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T21:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T21:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T21:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T21:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T21:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T21:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T21:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T21:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T21:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T21:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T21:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T21:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T21:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T21:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T21:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T21:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T21:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T21:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T21:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T21:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T21:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T21:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T21:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T21:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T21:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T21:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T21:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T21:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T21:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T21:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T21:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T21:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T22:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T22:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T22:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T22:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T22:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T22:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T22:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T22:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T22:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T22:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T22:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T22:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T22:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T22:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T22:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T22:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T22:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T22:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T22:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T22:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T22:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T22:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T22:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T22:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T22:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T22:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T22:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T22:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T22:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T22:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T22:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T22:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T22:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T22:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T22:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T23:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T23:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T23:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T23:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T23:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T23:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T23:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T23:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T23:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T23:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T23:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T23:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T23:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T23:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T23:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T23:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T23:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T23:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T23:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T23:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T23:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-19T23:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-19T23:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-19T23:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T00:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T00:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T00:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T00:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T00:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T00:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T00:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T00:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T00:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T00:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T00:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T00:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T00:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T00:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T00:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T00:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T00:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T00:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T00:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T00:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T00:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T00:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T00:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T00:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T00:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T00:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T00:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T00:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T00:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T00:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T00:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T00:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T00:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T00:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T01:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T01:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T01:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T01:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T01:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T01:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T01:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T01:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T01:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T01:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T01:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T01:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T01:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T01:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T01:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T01:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T01:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T01:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T01:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T01:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T01:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T01:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T01:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T01:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T01:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T01:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T01:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T01:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T01:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T01:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T01:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T01:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T01:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T01:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T02:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T02:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T02:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T02:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T02:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T02:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T02:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T02:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T02:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T02:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T02:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T02:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T02:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T02:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T02:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T02:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T02:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T02:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T02:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T02:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T02:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T02:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T02:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T02:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T02:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T02:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T03:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T03:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T03:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T03:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T03:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T03:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T03:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T03:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T03:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T03:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T03:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T03:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T03:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T03:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T03:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T03:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T03:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T03:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T03:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T03:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T03:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T03:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T03:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T03:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T03:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T03:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T03:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T03:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T03:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T03:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T03:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T04:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T04:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T04:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T04:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T04:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T04:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T04:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T04:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T04:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T04:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T04:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T04:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T04:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T04:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T04:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T04:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T04:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T04:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T04:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T04:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T04:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T04:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T04:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T04:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T04:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T04:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T04:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T04:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T04:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T04:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T04:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T04:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T04:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T04:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T04:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T04:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T04:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T04:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T05:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T05:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T05:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T05:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T05:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T05:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T05:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T05:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T05:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T05:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T05:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T05:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T05:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T05:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T05:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T05:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T05:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T05:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T05:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T05:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T05:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T05:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T05:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T05:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T05:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T05:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T05:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T05:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T05:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T05:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T05:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T05:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T05:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T05:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T05:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T05:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T05:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T05:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T05:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T05:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T06:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T06:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T06:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T06:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T06:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T06:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T06:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T06:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T06:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T06:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T06:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T06:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T06:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T06:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T06:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T06:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T06:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T06:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T06:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T06:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T06:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T06:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T06:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T06:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T06:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T06:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T06:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T06:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T06:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T06:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T06:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T07:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T07:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T07:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T07:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T07:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T07:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T07:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T07:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T07:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T07:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T07:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T07:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T07:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T07:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T07:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T07:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T07:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T07:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T07:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T07:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T07:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T07:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T07:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T07:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T07:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T07:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T07:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T07:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T08:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T08:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T08:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T08:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T08:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T08:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T08:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T08:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T08:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T08:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T08:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T08:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T08:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T08:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T08:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T08:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T08:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T08:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T08:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T08:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T08:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T08:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T08:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T08:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T08:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T08:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T08:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T08:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T08:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T08:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T08:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T08:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T08:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T08:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T08:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T08:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T09:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T09:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T09:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T09:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T09:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T09:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T09:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T09:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T09:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T09:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T09:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T09:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T09:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T09:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T09:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T09:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T09:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T09:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T09:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T09:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T09:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T09:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T09:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T09:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T09:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T09:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T09:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T09:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T09:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T09:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T09:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T09:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T09:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T09:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T09:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T09:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T09:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T09:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T10:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T10:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T10:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T10:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T10:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T10:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T10:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T10:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T10:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T10:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T10:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T10:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T10:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T10:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T10:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T10:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T10:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T10:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T10:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T10:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T10:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T10:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T10:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T10:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T10:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T10:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T10:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T10:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T10:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T10:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T10:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T10:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T10:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T10:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T10:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T11:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T11:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T11:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T11:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T11:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T11:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T11:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T11:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T11:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T11:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T11:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T11:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T11:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T11:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T11:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T11:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T11:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T11:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T11:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T11:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T11:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T11:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T11:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T11:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T11:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T11:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T11:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T11:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T11:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T11:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T11:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T11:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T11:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T12:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T12:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T12:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T12:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T12:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T12:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T12:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T12:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T12:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T12:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T12:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T12:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T12:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T12:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T12:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T12:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T12:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T12:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T12:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T12:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T12:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T12:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T12:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T12:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T12:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T12:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T13:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T13:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T13:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T13:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T13:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T13:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T13:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T13:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T13:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T13:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T13:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T13:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T13:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T13:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T13:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T13:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T13:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T13:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T13:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T13:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T13:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T13:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T13:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T13:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T13:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T13:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T13:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T13:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T13:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T13:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T13:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T13:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T13:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T13:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T13:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T13:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T13:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T13:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T13:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T13:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T14:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T14:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T14:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T14:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T14:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T14:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T14:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T14:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T14:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T14:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T14:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T14:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T14:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T14:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T14:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T14:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T14:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T14:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T14:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T14:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T14:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T14:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T15:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T15:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T15:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T15:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T15:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T15:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T15:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T15:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T15:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T15:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T15:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T15:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T15:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T15:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T15:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T15:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T15:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T15:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T15:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T15:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T15:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T15:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T15:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T15:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T15:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T15:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T15:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T15:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T15:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T15:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T15:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T15:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T16:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T16:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T16:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T16:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T16:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T16:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T16:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T16:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T16:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T16:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T16:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T16:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T16:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T16:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T16:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T16:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T16:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T16:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T16:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T16:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T16:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T16:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T16:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T16:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T16:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T16:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T16:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T16:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T16:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T16:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T16:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T16:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T16:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T17:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T17:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T17:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T17:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T17:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T17:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T17:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T17:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T17:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T17:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T17:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T17:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T17:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T17:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T17:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T17:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T17:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T17:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T17:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T17:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T17:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T17:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T18:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T18:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T18:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T18:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T18:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T18:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T18:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T18:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T18:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T18:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T18:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T18:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T18:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T18:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T18:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T18:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T18:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T18:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T18:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T18:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T18:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T18:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T18:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T18:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T18:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T18:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T18:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T18:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T18:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T18:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T18:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T18:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T18:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T19:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T19:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T19:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T19:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T19:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T19:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T19:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T19:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T19:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T19:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T19:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T19:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T19:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T19:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T19:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T19:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T19:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T19:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T19:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T19:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T19:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T19:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T19:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T19:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T19:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T19:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T19:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T19:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T19:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T19:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T19:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T19:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T19:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T20:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T20:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T20:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T20:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T20:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T20:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T20:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T20:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T20:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T20:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T20:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T20:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T20:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T20:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T20:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T20:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T20:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T20:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T20:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T20:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T20:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T20:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T20:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T20:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T20:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T20:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T20:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T20:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T20:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T20:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T20:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T20:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T20:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T20:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T20:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T20:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T21:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T21:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T21:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T21:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T21:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T21:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T21:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T21:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T21:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T21:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T21:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T21:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T21:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T21:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T21:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T21:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T21:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T21:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T21:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T21:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T21:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T21:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T21:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T21:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T21:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T21:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T21:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T22:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T22:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T22:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T22:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T22:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T22:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T22:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T22:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T22:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T22:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T22:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T22:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T22:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T22:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T22:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T22:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T22:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T22:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T22:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T22:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T22:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T22:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T22:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T22:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T22:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T22:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T22:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T22:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T22:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T22:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T22:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T22:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T23:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T23:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T23:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T23:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T23:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T23:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T23:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T23:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T23:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T23:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T23:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T23:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T23:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T23:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T23:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T23:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T23:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T23:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T23:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T23:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T23:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T23:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T23:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T23:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T23:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T23:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T23:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T23:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T23:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T23:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T23:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T23:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-20T23:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-20T23:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-20T23:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T00:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T00:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T00:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T00:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T00:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T00:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T00:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T00:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T00:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T00:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T00:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T00:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T00:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T00:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T00:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T00:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T00:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T00:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T00:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T00:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T00:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T00:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T00:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T00:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T00:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T00:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T00:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T00:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T00:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T00:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T00:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T01:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T01:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T01:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T01:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T01:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T01:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T01:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T01:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T01:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T01:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T01:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T01:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T01:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T01:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T01:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T01:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T01:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T01:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T01:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T01:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T01:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T01:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T01:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T01:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T01:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T01:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T01:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T01:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T01:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T01:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T01:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T01:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T01:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T01:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T01:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T01:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T01:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T01:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T01:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T01:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T01:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T02:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T02:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T02:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T02:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T02:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T02:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T02:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T02:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T02:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T02:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T02:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T02:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T02:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T02:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T02:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T02:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T02:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T02:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T02:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T02:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T02:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T02:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T02:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T02:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T02:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T02:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T02:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T02:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T02:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T02:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T02:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T02:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T02:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T02:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T02:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T03:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T03:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T03:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T03:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T03:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T03:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T03:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T03:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T03:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T03:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T03:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T03:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T03:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T03:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T03:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T03:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T03:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T03:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T03:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T03:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T03:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T03:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T03:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T03:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T03:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T03:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T03:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T03:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T03:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T03:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T03:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T03:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T03:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T03:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T04:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T04:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T04:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T04:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T04:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T04:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T04:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T04:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T04:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T04:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T04:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T04:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T04:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T04:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T04:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T04:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T04:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T04:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T04:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T04:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T04:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T04:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T04:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T04:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T04:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T04:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T04:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T04:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T04:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T04:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T04:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T04:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T04:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T04:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T04:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T04:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T05:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T05:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T05:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T05:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T05:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T05:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T05:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T05:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T05:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T05:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T05:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T05:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T05:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T05:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T05:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T05:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T05:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T05:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T05:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T05:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T05:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T05:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T05:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T05:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T05:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T05:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T05:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T05:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T05:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T05:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T05:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T05:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T05:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T05:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T05:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T06:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T06:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T06:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T06:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T06:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T06:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T06:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T06:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T06:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T06:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T06:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T06:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T06:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T06:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T06:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T06:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T06:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T06:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T06:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T06:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T06:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T06:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T06:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T06:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T07:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T07:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T07:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T07:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T07:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T07:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T07:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T07:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T07:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T07:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T07:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T07:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T07:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T07:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T07:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T07:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T07:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T07:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T07:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T07:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T07:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T07:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T07:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T07:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T08:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T08:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T08:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T08:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T08:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T08:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T08:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T08:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T08:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T08:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T08:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T08:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T08:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T08:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T08:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T08:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T08:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T08:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T08:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T08:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T08:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T08:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T09:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T09:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T09:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T09:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T09:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T09:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T09:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T09:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T09:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T09:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T09:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T09:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T09:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T09:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T09:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T09:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T09:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T09:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T09:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T09:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T09:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T09:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T09:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T09:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T09:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T09:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T09:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T09:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T09:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T09:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T09:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T09:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T09:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T09:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T09:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T09:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T09:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T09:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T10:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T10:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T10:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T10:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T10:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T10:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T10:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T10:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T10:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T10:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T10:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T10:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T10:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T10:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T10:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T10:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T10:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T10:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T10:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T10:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T10:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T10:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T10:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T10:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T10:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T10:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T10:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T10:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T10:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T10:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T10:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T10:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T10:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T11:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T11:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T11:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T11:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T11:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T11:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T11:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T11:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T11:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T11:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T11:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T11:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T11:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T11:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T11:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T11:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T11:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T11:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T11:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T11:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T11:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T11:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T11:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T11:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T11:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T11:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T11:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T11:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T11:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T11:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T11:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T11:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T11:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T11:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T11:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T11:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T11:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T11:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T12:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T12:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T12:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T12:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T12:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T12:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T12:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T12:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T12:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T12:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T12:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T12:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T12:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T12:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T12:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T12:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T12:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T12:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T12:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T12:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T12:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T12:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T12:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T12:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T12:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T12:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T12:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T12:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T12:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T12:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T12:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T12:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T12:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T13:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T13:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T13:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T13:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T13:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T13:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T13:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T13:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T13:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T13:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T13:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T13:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T13:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T13:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T13:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T13:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T13:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T13:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T13:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T13:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T13:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T13:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T13:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T13:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T13:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T13:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T13:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T13:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T13:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T13:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T13:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T13:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T13:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T13:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T13:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T13:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T13:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T13:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T14:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T14:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T14:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T14:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T14:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T14:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T14:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T14:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T14:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T14:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T14:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T14:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T14:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T14:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T14:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T14:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T14:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T14:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T14:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T14:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T14:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T14:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T14:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T14:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T14:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T14:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T14:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T14:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T14:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T14:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T14:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T14:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T14:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T14:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T14:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T14:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T14:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T15:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T15:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T15:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T15:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T15:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T15:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T15:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T15:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T15:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T15:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T15:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T15:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T15:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T15:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T15:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T15:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T15:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T15:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T15:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T15:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T15:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T15:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T15:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T15:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T15:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T15:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T15:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T15:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T15:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T15:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T15:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T15:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T15:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T15:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T15:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T15:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T15:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T15:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T15:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T15:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T15:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T16:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T16:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T16:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T16:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T16:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T16:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T16:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T16:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T16:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T16:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T16:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T16:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T16:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T16:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T16:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T16:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T16:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T16:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T16:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T16:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T16:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T16:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T16:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T16:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T16:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T16:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T16:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T16:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T16:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T17:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T17:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T17:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T17:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T17:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T17:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T17:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T17:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T17:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T17:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T17:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T17:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T17:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T17:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T17:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T17:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T17:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T17:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T17:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T17:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T17:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T17:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T17:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T17:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T17:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T17:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T17:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T17:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T18:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T18:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T18:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T18:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T18:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T18:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T18:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T18:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T18:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T18:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T18:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T18:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T18:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T18:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T18:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T18:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T18:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T18:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T18:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T18:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T18:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T18:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T18:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T18:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T18:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T19:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T19:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T19:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T19:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T19:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T19:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T19:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T19:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T19:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T19:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T19:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T19:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T19:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T19:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T19:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T19:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T19:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T19:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T19:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T19:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T19:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T19:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T19:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T19:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T19:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T19:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T19:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T19:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T19:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T19:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T19:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T19:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T19:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T20:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T20:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T20:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T20:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T20:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T20:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T20:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T20:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T20:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T20:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T20:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T20:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T20:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T20:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T20:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T20:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T20:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T20:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T20:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T20:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T20:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T20:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T20:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T20:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T20:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T20:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T20:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T20:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T20:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T20:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T20:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T21:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T21:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T21:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T21:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T21:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T21:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T21:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T21:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T21:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T21:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T21:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T21:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T21:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T21:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T21:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T21:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T21:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T21:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T21:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T21:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T21:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T21:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T21:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T21:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T21:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T21:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T21:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T21:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T21:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T21:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T21:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T21:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T21:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T21:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T21:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T21:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T22:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T22:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T22:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T22:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T22:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T22:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T22:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T22:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T22:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T22:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T22:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T22:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T22:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T22:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T22:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T22:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T22:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T22:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T22:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T22:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T22:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T22:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T22:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T22:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T22:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T22:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T22:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T22:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T22:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T22:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T22:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T22:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T22:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T22:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T22:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T22:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T23:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T23:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T23:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T23:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T23:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T23:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T23:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T23:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T23:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T23:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T23:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T23:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T23:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T23:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T23:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T23:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T23:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T23:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T23:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T23:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T23:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T23:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T23:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-21T23:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-21T23:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-21T23:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T00:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T00:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T00:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T00:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T00:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T00:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T00:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T00:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T00:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T00:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T00:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T00:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T00:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T00:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T00:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T00:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T00:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T00:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T00:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T00:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T00:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T00:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T00:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T00:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T00:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T00:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T00:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T00:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T00:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T00:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T00:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T00:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T00:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T00:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T00:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T00:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T01:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T01:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T01:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T01:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T01:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T01:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T01:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T01:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T01:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T01:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T01:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T01:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T01:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T01:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T01:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T01:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T01:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T01:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T01:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T01:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T01:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T01:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T01:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T01:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T01:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T01:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T01:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T01:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T01:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T02:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T02:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T02:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T02:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T02:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T02:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T02:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T02:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T02:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T02:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T02:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T02:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T02:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T02:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T02:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T02:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T02:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T02:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T02:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T02:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T02:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T02:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T02:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T02:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T02:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T02:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T02:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T02:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T02:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T02:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T02:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T02:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T02:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T03:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T03:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T03:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T03:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T03:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T03:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T03:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T03:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T03:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T03:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T03:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T03:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T03:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T03:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T03:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T03:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T03:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T03:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T03:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T03:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T03:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T03:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T03:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T03:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T03:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T03:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T03:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T03:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T03:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T03:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T03:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T04:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T04:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T04:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T04:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T04:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T04:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T04:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T04:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T04:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T04:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T04:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T04:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T04:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T04:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T04:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T04:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T04:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T04:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T04:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T04:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T04:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T04:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T04:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T04:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T04:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T04:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T04:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T04:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T04:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T05:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T05:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T05:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T05:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T05:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T05:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T05:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T05:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T05:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T05:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T05:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T05:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T05:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T05:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T05:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T05:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T05:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T05:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T05:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T05:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T05:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T05:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T05:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T05:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T05:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T05:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T05:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T05:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T05:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T05:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T05:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T05:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T05:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T05:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T05:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T05:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T05:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T05:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T05:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T05:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T06:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T06:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T06:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T06:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T06:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T06:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T06:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T06:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T06:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T06:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T06:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T06:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T06:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T06:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T06:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T06:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T06:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T06:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T06:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T06:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T06:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T06:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T06:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T06:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T06:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T06:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T06:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T06:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T06:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T07:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T07:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T07:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T07:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T07:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T07:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T07:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T07:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T07:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T07:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T07:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T07:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T07:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T07:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T07:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T07:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T07:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T07:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T07:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T07:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T07:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T07:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T07:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T07:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T07:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T07:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T07:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T07:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T07:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T07:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T07:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T07:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T07:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T07:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T07:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T07:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T07:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T07:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T07:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T07:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T08:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T08:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T08:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T08:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T08:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T08:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T08:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T08:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T08:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T08:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T08:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T08:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T08:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T08:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T08:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T08:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T08:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T08:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T08:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T08:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T08:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T08:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T08:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T08:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T08:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T08:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T08:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T08:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T08:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T08:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T08:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T08:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T09:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T09:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T09:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T09:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T09:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T09:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T09:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T09:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T09:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T09:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T09:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T09:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T09:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T09:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T09:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T09:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T09:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T09:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T09:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T09:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T09:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T09:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T09:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T09:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T09:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T09:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T10:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T10:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T10:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T10:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T10:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T10:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T10:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T10:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T10:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T10:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T10:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T10:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T10:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T10:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T10:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T10:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T10:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T10:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T10:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T10:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T10:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T10:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T10:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T10:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T10:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T10:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T10:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T10:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T10:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T10:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T10:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T10:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T10:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T10:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T10:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T10:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T10:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T10:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T10:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T10:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T10:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T11:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T11:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T11:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T11:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T11:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T11:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T11:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T11:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T11:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T11:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T11:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T11:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T11:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T11:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T11:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T11:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T11:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T11:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T11:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T11:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T11:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T11:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T11:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T11:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T11:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T11:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T11:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T11:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T11:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T11:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T12:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T12:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T12:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T12:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T12:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T12:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T12:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T12:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T12:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T12:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T12:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T12:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T12:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T12:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T12:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T12:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T12:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T12:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T12:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T12:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T12:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T12:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T12:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T12:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T12:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T12:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T12:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T12:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T12:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T12:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T12:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T13:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T13:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T13:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T13:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T13:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T13:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T13:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T13:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T13:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T13:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T13:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T13:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T13:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T13:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T13:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T13:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T13:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T13:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T13:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T13:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T13:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T13:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T13:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T13:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T13:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T13:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T13:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T13:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T13:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T14:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T14:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T14:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T14:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T14:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T14:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T14:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T14:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T14:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T14:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T14:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T14:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T14:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T14:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T14:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T14:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T14:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T14:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T14:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T14:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T14:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T14:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T14:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T14:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T14:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T14:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T14:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T14:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T14:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T14:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T15:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T15:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T15:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T15:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T15:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T15:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T15:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T15:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T15:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T15:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T15:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T15:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T15:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T15:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T15:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T15:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T15:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T15:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T15:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T15:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T15:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T15:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T15:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T15:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T15:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T15:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T15:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T15:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T15:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T15:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T15:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T15:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T15:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T15:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T15:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T15:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T15:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T16:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T16:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T16:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T16:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T16:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T16:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T16:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T16:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T16:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T16:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T16:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T16:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T16:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T16:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T16:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T16:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T16:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T16:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T16:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T16:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T16:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T16:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T16:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T16:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T16:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T16:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T16:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T16:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T16:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T16:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T16:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T16:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T16:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T17:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T17:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T17:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T17:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T17:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T17:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T17:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T17:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T17:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T17:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T17:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T17:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T17:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T17:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T17:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T17:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T17:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T17:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T17:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T17:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T17:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T17:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T17:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T17:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T17:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T17:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T17:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T17:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T17:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T17:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T18:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T18:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T18:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T18:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T18:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T18:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T18:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T18:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T18:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T18:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T18:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T18:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T18:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T18:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T18:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T18:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T18:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T18:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T18:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T18:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T18:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T18:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T18:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T18:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T18:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T18:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T18:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T18:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T18:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T18:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T19:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T19:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T19:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T19:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T19:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T19:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T19:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T19:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T19:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T19:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T19:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T19:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T19:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T19:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T19:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T19:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T19:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T19:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T19:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T19:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T19:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T19:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T19:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T19:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T19:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T19:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T19:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T19:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T19:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T19:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T19:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T19:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T19:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T19:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T19:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T19:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T20:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T20:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T20:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T20:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T20:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T20:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T20:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T20:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T20:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T20:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T20:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T20:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T20:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T20:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T20:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T20:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T20:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T20:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T20:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T20:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T20:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T20:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T20:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T20:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T20:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T20:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T20:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T20:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T20:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T20:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T20:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T20:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T20:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T21:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T21:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T21:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T21:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T21:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T21:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T21:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T21:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T21:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T21:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T21:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T21:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T21:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T21:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T21:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T21:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T21:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T21:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T21:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T21:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T21:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T21:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T21:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T21:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T21:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T21:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T21:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T21:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T21:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T21:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T21:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T21:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T22:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T22:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T22:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T22:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T22:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T22:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T22:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T22:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T22:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T22:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T22:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T22:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T22:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T22:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T22:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T22:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T22:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T22:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T22:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T22:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T22:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T22:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T22:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T22:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T22:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T22:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T22:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T22:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T22:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T22:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T22:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T22:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T22:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T22:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T22:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T22:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T23:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T23:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T23:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T23:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T23:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T23:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T23:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T23:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T23:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T23:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T23:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T23:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T23:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T23:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T23:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T23:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T23:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T23:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T23:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T23:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T23:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T23:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T23:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T23:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T23:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T23:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-22T23:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T23:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-22T23:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-22T23:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T00:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T00:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T00:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T00:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T00:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T00:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T00:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T00:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T00:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T00:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T00:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T00:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T00:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T00:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T00:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T00:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T00:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T00:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T00:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T00:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T00:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T00:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T00:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T00:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T00:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T00:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T00:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T00:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T00:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T00:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T00:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T00:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T00:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T01:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T01:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T01:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T01:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T01:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T01:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T01:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T01:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T01:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T01:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T01:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T01:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T01:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T01:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T01:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T01:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T01:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T01:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T01:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T01:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T01:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T01:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T01:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T01:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T01:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T01:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T01:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T01:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T01:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T01:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T01:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T01:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T01:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T01:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T01:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T01:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T01:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T01:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T01:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T02:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T02:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T02:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T02:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T02:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T02:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T02:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T02:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T02:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T02:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T02:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T02:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T02:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T02:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T02:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T02:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T02:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T02:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T02:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T02:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T02:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T02:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T02:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T02:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T02:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T02:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T02:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T02:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T02:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T02:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T02:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T02:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T02:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T02:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T02:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T02:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T02:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T02:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T03:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T03:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T03:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T03:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T03:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T03:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T03:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T03:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T03:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T03:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T03:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T03:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T03:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T03:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T03:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T03:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T03:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T03:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T03:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T03:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T03:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T03:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T03:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T03:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T03:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T03:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T03:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T03:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T03:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T03:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T03:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T03:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T03:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T04:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T04:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T04:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T04:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T04:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T04:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T04:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T04:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T04:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T04:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T04:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T04:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T04:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T04:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T04:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T04:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T04:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T04:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T04:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T04:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T04:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T04:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T04:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T04:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T04:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T04:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T04:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T04:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T05:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T05:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T05:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T05:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T05:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T05:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T05:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T05:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T05:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T05:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T05:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T05:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T05:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T05:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T05:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T05:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T05:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T05:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T05:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T05:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T05:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T05:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T05:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T05:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T05:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T05:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T05:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T05:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T05:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T05:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T05:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T05:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T05:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T05:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T05:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T05:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T05:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T06:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T06:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T06:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T06:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T06:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T06:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T06:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T06:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T06:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T06:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T06:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T06:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T06:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T06:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T06:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T06:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T06:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T06:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T06:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T06:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T06:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T06:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T06:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T06:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T06:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T06:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T06:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T06:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T06:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T06:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T06:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T06:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T07:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T07:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T07:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T07:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T07:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T07:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T07:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T07:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T07:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T07:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T07:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T07:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T07:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T07:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T07:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T07:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T07:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T07:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T07:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T07:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T07:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T07:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T07:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T07:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T07:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T07:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T07:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T08:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T08:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T08:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T08:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T08:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T08:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T08:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T08:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T08:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T08:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T08:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T08:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T08:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T08:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T08:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T08:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T08:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T08:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T08:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T08:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T08:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T08:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T08:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T08:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T08:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T08:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T08:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T08:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T08:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T08:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T08:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T08:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T08:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T08:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T08:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T08:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T08:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T09:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T09:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T09:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T09:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T09:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T09:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T09:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T09:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T09:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T09:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T09:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T09:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T09:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T09:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T09:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T09:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T09:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T09:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T09:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T09:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T09:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T09:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T09:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T09:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T09:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T09:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T09:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T09:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T09:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T10:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T10:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T10:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T10:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T10:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T10:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T10:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T10:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T10:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T10:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T10:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T10:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T10:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T10:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T10:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T10:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T10:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T10:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T10:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T10:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T10:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T10:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T10:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T10:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T10:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T10:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T11:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T11:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T11:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T11:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T11:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T11:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T11:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T11:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T11:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T11:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T11:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T11:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T11:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T11:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T11:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T11:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T11:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T11:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T11:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T11:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T11:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T11:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T11:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T11:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T11:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T11:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T11:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T12:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T12:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T12:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T12:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T12:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T12:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T12:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T12:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T12:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T12:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T12:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T12:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T12:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T12:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T12:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T12:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T12:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T12:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T12:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T12:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T12:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T12:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T12:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T12:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T12:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T12:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T12:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T12:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T12:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T12:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T12:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T12:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T12:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T12:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T12:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T12:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T12:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T12:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T12:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T12:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T13:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T13:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T13:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T13:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T13:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T13:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T13:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T13:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T13:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T13:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T13:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T13:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T13:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T13:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T13:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T13:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T13:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T13:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T13:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T13:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T13:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T13:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T13:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T13:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T13:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T13:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T13:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T13:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T13:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T13:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T13:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T13:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T13:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T13:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T13:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T13:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T13:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T13:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T13:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T13:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T13:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T14:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T14:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T14:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T14:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T14:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T14:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T14:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T14:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T14:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T14:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T14:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T14:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T14:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T14:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T14:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T14:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T14:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T14:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T14:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T14:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T14:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T14:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T14:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T14:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T14:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T14:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T14:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T14:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T15:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T15:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T15:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T15:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T15:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T15:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T15:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T15:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T15:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T15:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T15:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T15:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T15:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T15:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T15:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T15:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T15:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T15:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T15:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T15:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T15:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T15:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T15:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T15:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T15:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T15:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T15:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T15:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T15:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T15:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T15:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T16:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T16:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T16:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T16:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T16:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T16:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T16:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T16:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T16:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T16:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T16:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T16:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T16:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T16:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T16:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T16:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T16:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T16:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T16:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T16:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T16:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T16:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T16:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T16:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T16:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T16:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T16:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T16:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T16:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T16:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T16:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T16:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T16:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T16:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T16:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T16:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T16:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T17:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T17:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T17:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T17:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T17:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T17:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T17:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T17:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T17:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T17:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T17:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T17:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T17:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T17:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T17:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T17:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T17:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T17:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T17:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T17:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T17:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T17:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T17:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T17:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T17:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T17:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T17:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T17:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T17:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T17:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T17:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T17:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T18:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T18:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T18:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T18:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T18:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T18:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T18:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T18:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T18:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T18:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T18:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T18:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T18:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T18:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T18:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T18:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T18:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T18:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T18:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T18:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T18:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T18:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T18:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T18:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T18:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T18:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T18:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T18:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T18:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T18:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T18:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T19:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T19:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T19:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T19:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T19:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T19:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T19:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T19:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T19:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T19:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T19:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T19:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T19:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T19:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T19:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T19:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T19:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T19:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T19:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T19:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T19:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T19:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T19:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T19:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T19:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T20:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T20:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T20:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T20:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T20:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T20:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T20:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T20:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T20:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T20:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T20:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T20:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T20:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T20:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T20:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T20:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T20:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T20:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T20:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T20:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T20:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T20:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T20:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T20:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T20:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T20:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T20:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T20:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T21:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T21:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T21:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T21:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T21:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T21:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T21:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T21:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T21:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T21:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T21:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T21:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T21:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T21:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T21:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T21:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T21:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T21:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T21:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T21:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T21:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T21:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T21:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T21:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T21:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T21:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T21:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T21:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T21:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T21:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T21:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T21:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T21:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T21:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T21:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T21:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T21:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T21:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T21:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T21:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T21:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T22:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T22:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T22:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T22:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T22:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T22:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T22:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T22:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T22:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T22:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T22:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T22:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T22:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T22:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T22:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T22:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T22:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T22:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T22:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T22:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T22:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T22:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T22:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T22:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T22:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T22:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T22:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T22:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T22:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T23:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T23:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T23:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T23:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T23:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T23:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T23:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T23:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T23:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T23:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T23:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T23:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T23:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T23:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T23:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T23:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T23:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T23:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T23:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T23:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T23:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-23T23:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T23:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T23:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-23T23:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-23T23:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T00:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T00:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T00:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T00:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T00:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T00:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T00:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T00:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T00:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T00:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T00:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T00:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T00:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T00:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T00:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T00:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T00:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T00:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T00:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T00:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T00:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T00:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T00:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T00:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T00:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T00:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T00:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T00:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T00:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T00:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T00:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T00:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T00:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T00:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T00:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T00:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T00:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T00:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T00:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T00:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T00:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T01:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T01:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T01:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T01:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T01:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T01:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T01:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T01:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T01:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T01:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T01:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T01:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T01:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T01:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T01:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T01:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T01:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T01:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T01:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T01:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T01:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T01:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T01:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T01:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T01:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T01:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T01:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T01:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T01:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T01:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T01:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T02:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T02:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T02:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T02:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T02:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T02:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T02:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T02:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T02:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T02:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T02:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T02:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T02:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T02:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T02:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T02:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T02:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T02:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T02:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T02:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T02:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T02:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T02:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T02:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T02:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T02:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T02:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T02:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T02:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T02:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T03:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T03:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T03:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T03:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T03:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T03:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T03:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T03:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T03:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T03:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T03:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T03:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T03:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T03:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T03:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T03:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T03:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T03:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T03:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T03:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T03:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T03:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T03:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T03:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T03:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T03:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T03:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T03:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T03:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T03:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T03:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T04:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T04:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T04:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T04:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T04:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T04:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T04:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T04:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T04:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T04:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T04:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T04:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T04:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T04:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T04:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T04:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T04:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T04:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T04:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T04:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T04:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T04:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T04:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T04:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T04:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T04:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T04:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T04:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T04:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T04:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T04:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T04:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T04:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T05:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T05:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T05:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T05:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T05:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T05:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T05:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T05:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T05:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T05:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T05:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T05:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T05:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T05:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T05:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T05:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T05:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T05:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T05:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T05:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T05:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T05:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T05:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T05:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T05:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T05:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T05:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T05:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T05:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T05:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T06:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T06:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T06:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T06:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T06:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T06:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T06:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T06:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T06:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T06:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T06:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T06:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T06:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T06:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T06:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T06:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T06:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T06:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T06:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T06:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T06:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T06:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T06:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T06:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T06:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T06:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T06:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T06:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T06:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T06:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T06:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T06:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T06:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T06:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T06:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T06:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T07:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T07:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T07:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T07:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T07:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T07:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T07:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T07:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T07:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T07:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T07:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T07:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T07:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T07:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T07:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T07:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T07:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T07:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T07:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T07:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T07:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T07:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T07:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T07:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T07:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T07:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T07:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T07:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T07:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T08:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T08:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T08:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T08:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T08:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T08:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T08:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T08:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T08:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T08:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T08:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T08:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T08:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T08:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T08:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T08:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T08:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T08:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T08:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T08:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T08:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T08:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T08:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T08:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T08:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T08:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T08:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T08:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T09:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T09:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T09:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T09:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T09:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T09:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T09:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T09:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T09:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T09:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T09:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T09:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T09:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T09:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T09:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T09:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T09:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T09:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T09:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T09:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T09:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T09:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T09:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T09:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T09:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T09:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T09:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T10:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T10:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T10:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T10:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T10:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T10:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T10:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T10:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T10:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T10:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T10:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T10:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T10:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T10:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T10:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T10:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T10:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T10:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T10:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T10:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T10:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T10:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T10:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T10:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T10:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T10:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T10:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T10:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T11:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T11:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T11:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T11:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T11:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T11:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T11:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T11:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T11:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T11:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T11:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T11:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T11:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T11:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T11:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T11:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T11:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T11:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T11:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T11:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T11:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T11:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T11:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T11:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T11:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T11:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T11:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T11:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T11:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T11:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T11:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T11:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T11:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T11:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T11:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T11:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T11:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T11:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T12:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T12:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T12:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T12:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T12:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T12:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T12:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T12:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T12:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T12:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T12:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T12:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T12:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T12:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T12:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T12:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T12:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T12:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T12:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T12:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T12:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T12:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T12:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T12:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T12:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T12:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T12:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T13:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T13:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T13:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T13:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T13:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T13:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T13:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T13:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T13:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T13:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T13:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T13:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T13:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T13:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T13:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T13:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T13:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T13:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T13:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T13:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T13:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T13:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T13:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T13:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T13:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T13:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T13:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T13:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T13:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T13:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T13:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T13:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T13:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T13:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T14:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T14:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T14:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T14:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T14:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T14:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T14:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T14:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T14:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T14:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T14:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T14:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T14:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T14:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T14:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T14:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T14:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T14:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T14:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T14:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T14:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T14:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T14:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T14:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T14:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T14:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T14:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T14:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T14:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T14:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T14:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T14:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T14:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T15:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T15:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T15:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T15:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T15:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T15:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T15:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T15:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T15:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T15:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T15:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T15:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T15:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T15:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T15:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T15:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T15:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T15:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T15:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T15:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T15:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T15:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T15:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T15:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T15:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T15:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T15:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T15:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T15:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T15:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T15:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T15:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T15:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T15:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T15:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T15:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T15:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T15:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T15:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T16:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T16:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T16:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T16:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T16:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T16:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T16:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T16:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T16:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T16:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T16:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T16:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T16:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T16:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T16:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T16:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T16:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T16:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T16:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T16:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T16:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T16:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T16:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T16:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T16:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T16:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T16:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T16:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T16:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T16:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T17:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T17:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T17:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T17:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T17:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T17:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T17:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T17:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T17:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T17:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T17:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T17:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T17:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T17:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T17:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T17:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T17:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T17:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T17:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T17:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T17:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T17:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T17:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T17:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T17:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T17:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T17:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T17:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T17:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T17:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T18:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T18:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T18:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T18:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T18:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T18:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T18:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T18:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T18:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T18:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T18:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T18:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T18:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T18:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T18:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T18:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T18:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T18:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T18:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T18:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T18:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T18:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T18:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T18:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T18:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T19:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T19:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T19:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T19:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T19:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T19:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T19:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T19:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T19:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T19:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T19:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T19:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T19:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T19:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T19:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T19:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T19:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T19:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T19:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T19:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T19:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T19:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T19:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T19:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T19:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T19:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T19:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T19:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T19:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T19:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T20:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T20:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T20:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T20:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T20:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T20:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T20:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T20:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T20:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T20:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T20:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T20:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T20:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T20:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T20:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T20:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T20:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T20:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T20:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T20:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T20:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T20:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T20:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T20:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T20:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T20:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T20:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T20:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T20:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T20:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T21:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T21:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T21:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T21:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T21:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T21:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T21:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T21:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T21:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T21:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T21:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T21:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T21:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T21:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T21:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T21:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T21:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T21:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T21:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T21:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T21:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T21:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T21:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T21:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T21:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T21:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T21:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T21:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T21:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T21:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T21:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T21:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T21:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T21:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T21:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T21:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T21:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T21:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T21:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T21:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T21:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T21:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T21:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T21:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T21:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T22:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T22:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T22:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T22:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T22:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T22:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T22:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T22:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T22:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T22:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T22:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T22:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T22:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T22:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T22:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T22:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T22:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T22:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T22:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T22:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T22:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T22:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T22:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T22:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T22:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T22:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T22:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T22:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T22:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T22:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T22:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T22:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T22:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T22:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T22:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T22:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T23:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T23:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T23:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T23:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T23:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T23:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T23:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T23:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T23:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T23:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T23:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T23:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T23:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T23:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T23:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T23:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T23:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T23:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T23:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T23:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T23:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T23:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T23:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T23:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T23:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T23:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T23:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T23:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-24T23:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-24T23:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-24T23:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T00:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T00:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T00:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T00:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T00:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T00:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T00:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T00:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T00:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T00:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T00:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T00:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T00:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T00:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T00:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T00:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T00:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T00:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T00:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T00:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T00:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T00:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T00:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T00:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T00:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T00:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T00:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T00:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T00:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T00:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T00:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T00:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T00:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T00:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T01:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T01:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T01:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T01:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T01:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T01:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T01:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T01:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T01:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T01:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T01:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T01:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T01:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T01:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T01:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T01:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T01:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T01:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T01:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T01:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T01:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T01:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T01:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T01:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T01:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T02:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T02:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T02:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T02:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T02:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T02:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T02:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T02:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T02:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T02:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T02:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T02:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T02:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T02:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T02:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T02:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T02:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T02:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T02:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T02:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T02:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T02:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T02:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T02:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T02:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T02:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T02:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T02:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T02:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T02:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T02:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T02:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T02:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T02:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T03:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T03:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T03:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T03:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T03:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T03:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T03:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T03:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T03:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T03:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T03:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T03:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T03:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T03:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T03:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T03:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T03:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T03:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T03:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T03:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T03:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T03:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T03:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T03:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T03:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T03:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T03:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T03:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T03:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T03:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T03:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T03:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T04:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T04:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T04:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T04:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T04:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T04:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T04:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T04:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T04:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T04:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T04:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T04:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T04:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T04:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T04:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T04:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T04:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T04:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T04:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T04:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T04:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T04:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T04:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T04:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T04:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T05:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T05:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T05:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T05:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T05:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T05:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T05:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T05:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T05:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T05:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T05:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T05:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T05:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T05:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T05:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T05:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T05:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T05:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T05:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T05:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T05:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T05:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T05:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T05:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T05:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T05:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T05:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T05:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T05:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T05:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T05:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T05:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T05:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T05:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T05:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T05:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T05:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T05:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T05:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T05:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T05:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T06:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T06:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T06:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T06:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T06:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T06:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T06:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T06:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T06:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T06:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T06:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T06:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T06:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T06:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T06:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T06:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T06:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T06:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T06:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T06:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T06:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T06:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T06:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T06:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T06:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T06:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T06:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T06:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T06:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T07:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T07:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T07:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T07:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T07:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T07:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T07:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T07:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T07:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T07:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T07:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T07:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T07:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T07:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T07:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T07:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T07:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T07:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T07:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T07:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T07:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T07:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T07:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T07:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T07:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T07:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T07:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T08:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T08:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T08:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T08:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T08:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T08:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T08:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T08:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T08:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T08:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T08:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T08:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T08:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T08:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T08:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T08:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T08:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T08:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T08:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T08:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T08:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T08:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T08:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T08:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T08:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T08:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T08:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T08:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T08:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T08:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T08:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T08:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T08:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T08:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T08:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T09:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T09:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T09:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T09:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T09:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T09:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T09:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T09:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T09:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T09:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T09:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T09:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T09:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T09:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T09:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T09:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T09:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T09:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T09:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T09:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T09:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T09:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T09:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T09:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T09:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T09:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T09:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T09:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T09:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T09:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T09:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T09:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T09:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T09:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T09:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T09:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T09:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T09:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T09:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T09:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T09:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T09:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T09:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T09:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T09:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T09:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T10:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T10:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T10:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T10:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T10:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T10:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T10:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T10:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T10:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T10:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T10:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T10:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T10:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T10:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T10:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T10:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T10:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T10:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T10:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T10:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T10:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T10:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T10:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T11:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T11:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T11:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T11:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T11:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T11:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T11:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T11:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T11:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T11:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T11:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T11:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T11:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T11:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T11:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T11:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T11:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T11:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T11:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T11:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T11:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T11:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T11:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T11:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T12:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T12:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T12:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T12:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T12:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T12:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T12:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T12:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T12:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T12:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T12:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T12:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T12:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T12:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T12:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T12:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T12:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T12:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T12:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T12:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T12:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T12:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T12:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T12:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T12:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T12:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T13:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T13:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T13:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T13:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T13:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T13:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T13:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T13:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T13:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T13:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T13:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T13:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T13:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T13:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T13:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T13:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T13:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T13:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T13:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T13:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T13:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T13:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T13:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T13:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T13:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T13:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T13:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T13:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T13:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T13:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T13:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T13:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T13:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T14:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T14:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T14:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T14:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T14:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T14:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T14:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T14:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T14:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T14:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T14:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T14:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T14:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T14:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T14:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T14:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T14:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T14:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T14:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T14:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T14:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T14:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T14:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T14:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T14:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T14:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T14:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T14:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T14:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T14:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T14:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T14:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T14:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T14:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T15:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T15:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T15:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T15:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T15:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T15:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T15:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T15:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T15:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T15:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T15:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T15:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T15:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T15:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T15:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T15:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T15:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T15:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T15:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T15:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T15:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T15:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T15:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T15:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T15:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T15:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T15:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T15:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T15:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T15:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T15:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T15:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T15:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T15:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T15:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T16:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T16:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T16:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T16:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T16:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T16:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T16:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T16:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T16:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T16:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T16:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T16:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T16:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T16:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T16:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T16:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T16:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T16:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T16:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T16:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T16:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T16:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T16:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T16:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T16:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T16:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T16:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T16:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T16:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T16:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T17:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T17:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T17:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T17:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T17:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T17:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T17:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T17:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T17:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T17:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T17:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T17:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T17:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T17:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T17:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T17:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T17:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T17:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T17:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T17:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T17:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T17:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T17:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T17:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T17:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T17:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T17:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T17:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T17:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T17:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T17:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T17:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T17:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T17:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T17:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T17:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T18:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T18:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T18:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T18:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T18:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T18:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T18:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T18:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T18:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T18:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T18:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T18:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T18:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T18:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T18:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T18:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T18:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T18:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T18:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T18:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T18:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T18:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T18:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T18:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T18:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T18:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T18:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T18:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T18:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T18:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T18:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T19:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T19:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T19:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T19:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T19:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T19:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T19:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T19:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T19:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T19:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T19:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T19:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T19:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T19:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T19:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T19:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T19:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T19:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T19:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T19:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T19:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T19:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T19:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T19:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T19:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T19:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T19:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T19:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T19:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T19:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T20:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T20:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T20:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T20:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T20:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T20:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T20:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T20:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T20:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T20:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T20:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T20:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T20:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T20:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T20:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T20:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T20:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T20:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T20:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T20:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T20:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T20:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T20:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T20:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T21:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T21:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T21:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T21:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T21:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T21:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T21:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T21:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T21:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T21:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T21:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T21:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T21:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T21:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T21:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T21:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T21:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T21:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T21:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T21:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T21:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T21:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T21:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T21:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T21:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T21:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T21:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T21:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T21:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T21:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T21:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T21:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T21:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T22:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T22:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T22:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T22:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T22:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T22:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T22:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T22:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T22:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T22:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T22:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T22:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T22:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T22:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T22:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T22:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T22:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T22:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T22:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T22:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T22:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T22:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T22:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T22:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T22:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T22:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T22:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T22:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T22:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T22:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T22:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T22:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T22:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T22:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T22:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T23:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T23:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T23:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T23:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T23:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T23:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T23:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T23:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T23:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T23:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T23:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T23:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T23:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T23:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T23:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T23:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T23:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T23:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T23:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T23:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T23:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T23:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T23:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T23:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T23:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T23:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T23:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T23:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T23:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T23:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T23:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T23:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T23:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T23:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T23:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-25T23:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T23:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T23:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T23:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-25T23:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-25T23:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T00:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T00:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T00:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T00:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T00:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T00:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T00:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T00:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T00:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T00:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T00:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T00:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T00:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T00:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T00:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T00:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T00:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T00:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T00:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T00:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T00:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T00:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T00:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T00:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T00:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T00:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T00:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T00:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T00:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T00:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T00:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T00:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T00:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T00:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T00:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T00:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T00:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T00:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T00:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T00:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T00:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T01:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T01:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T01:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T01:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T01:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T01:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T01:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T01:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T01:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T01:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T01:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T01:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T01:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T01:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T01:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T01:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T01:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T01:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T01:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T01:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T01:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T01:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T01:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T01:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T01:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T01:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T01:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T02:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T02:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T02:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T02:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T02:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T02:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T02:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T02:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T02:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T02:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T02:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T02:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T02:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T02:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T02:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T02:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T02:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T02:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T02:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T02:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T02:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T02:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T02:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T02:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T02:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T02:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T02:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T02:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T02:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T02:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T02:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T02:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T02:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T02:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T02:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T03:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T03:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T03:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T03:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T03:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T03:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T03:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T03:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T03:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T03:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T03:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T03:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T03:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T03:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T03:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T03:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T03:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T03:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T03:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T03:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T03:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T03:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T03:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T03:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T03:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T03:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T04:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T04:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T04:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T04:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T04:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T04:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T04:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T04:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T04:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T04:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T04:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T04:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T04:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T04:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T04:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T04:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T04:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T04:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T04:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T04:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T04:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T04:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T04:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T04:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T04:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T04:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T04:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T04:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T04:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T04:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T04:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T04:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T04:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T04:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T04:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T04:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T05:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T05:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T05:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T05:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T05:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T05:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T05:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T05:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T05:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T05:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T05:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T05:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T05:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T05:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T05:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T05:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T05:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T05:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T05:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T05:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T05:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T05:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T05:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T05:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T05:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T05:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T05:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T05:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T05:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T05:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T05:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T05:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T06:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T06:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T06:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T06:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T06:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T06:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T06:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T06:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T06:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T06:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T06:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T06:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T06:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T06:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T06:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T06:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T06:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T06:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T06:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T06:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T06:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T06:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T06:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T06:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T06:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T06:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T06:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T06:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T06:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T06:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T06:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T06:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T06:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T07:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T07:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T07:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T07:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T07:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T07:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T07:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T07:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T07:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T07:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T07:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T07:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T07:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T07:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T07:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T07:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T07:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T07:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T07:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T07:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T07:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T07:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T07:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T07:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T07:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T07:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T07:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T07:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T07:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T07:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T07:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T07:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T07:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T08:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T08:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T08:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T08:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T08:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T08:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T08:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T08:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T08:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T08:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T08:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T08:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T08:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T08:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T08:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T08:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T08:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T08:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T08:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T08:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T08:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T08:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T08:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T08:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T08:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T08:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T08:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T08:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T08:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T08:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T08:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T08:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T08:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T09:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T09:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T09:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T09:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T09:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T09:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T09:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T09:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T09:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T09:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T09:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T09:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T09:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T09:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T09:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T09:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T09:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T09:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T09:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T09:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T09:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T09:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T09:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T09:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T09:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T09:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T09:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T09:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T09:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T09:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T09:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T09:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T09:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T09:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T09:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T10:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T10:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T10:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T10:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T10:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T10:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T10:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T10:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T10:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T10:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T10:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T10:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T10:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T10:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T10:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T10:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T10:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T10:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T10:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T10:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T10:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T10:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T10:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T10:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T10:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T10:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T10:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T10:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T10:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T10:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T10:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T10:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T11:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T11:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T11:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T11:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T11:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T11:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T11:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T11:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T11:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T11:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T11:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T11:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T11:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T11:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T11:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T11:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T11:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T11:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T11:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T11:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T11:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T11:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T11:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T11:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T11:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T11:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T11:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T11:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T11:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T11:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T11:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T11:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T12:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T12:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T12:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T12:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T12:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T12:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T12:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T12:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T12:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T12:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T12:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T12:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T12:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T12:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T12:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T12:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T12:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T12:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T12:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T12:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T12:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T12:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T12:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T12:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T12:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T12:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T12:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T12:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T13:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T13:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T13:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T13:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T13:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T13:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T13:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T13:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T13:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T13:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T13:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T13:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T13:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T13:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T13:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T13:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T13:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T13:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T13:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T13:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T13:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T13:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T13:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T13:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T13:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T13:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T13:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T13:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T13:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T13:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T13:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T13:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T13:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T13:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T14:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T14:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T14:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T14:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T14:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T14:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T14:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T14:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T14:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T14:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T14:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T14:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T14:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T14:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T14:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T14:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T14:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T14:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T14:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T14:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T14:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T14:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T14:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T14:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T14:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T14:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T14:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T14:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T14:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T14:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T14:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T14:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T14:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T15:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T15:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T15:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T15:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T15:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T15:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T15:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T15:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T15:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T15:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T15:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T15:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T15:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T15:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T15:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T15:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T15:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T15:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T15:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T15:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T15:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T15:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T15:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T15:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T15:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T15:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T15:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T15:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T15:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T15:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T15:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T15:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T15:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T15:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T15:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T15:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T15:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T15:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T15:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T16:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T16:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T16:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T16:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T16:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T16:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T16:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T16:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T16:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T16:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T16:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T16:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T16:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T16:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T16:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T16:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T16:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T16:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T16:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T16:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T16:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T16:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T16:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T16:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T16:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T16:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T16:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T16:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T16:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T16:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T16:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T16:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T16:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T16:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T16:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T16:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T16:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T17:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T17:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T17:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T17:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T17:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T17:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T17:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T17:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T17:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T17:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T17:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T17:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T17:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T17:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T17:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T17:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T17:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T17:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T17:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T17:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T17:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T17:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T17:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T18:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T18:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T18:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T18:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T18:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T18:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T18:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T18:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T18:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T18:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T18:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T18:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T18:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T18:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T18:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T18:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T18:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T18:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T18:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T18:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T18:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T18:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T18:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T18:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T18:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T18:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T18:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T18:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T18:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T18:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T19:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T19:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T19:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T19:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T19:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T19:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T19:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T19:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T19:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T19:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T19:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T19:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T19:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T19:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T19:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T19:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T19:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T19:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T19:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T19:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T19:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T19:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T19:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T19:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T19:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T19:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T19:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T19:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T19:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T19:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T19:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T19:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T20:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T20:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T20:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T20:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T20:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T20:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T20:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T20:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T20:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T20:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T20:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T20:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T20:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T20:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T20:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T20:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T20:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T20:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T20:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T20:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T20:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T20:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T20:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T20:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T20:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T20:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T20:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T20:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T20:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T20:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T20:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T20:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T20:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T20:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T21:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T21:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T21:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T21:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T21:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T21:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T21:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T21:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T21:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T21:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T21:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T21:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T21:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T21:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T21:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T21:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T21:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T21:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T21:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T21:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T21:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T21:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T21:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T21:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T21:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T21:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T21:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T21:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T21:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T21:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T21:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T21:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T21:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T22:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T22:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T22:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T22:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T22:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T22:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T22:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T22:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T22:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T22:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T22:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T22:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T22:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T22:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T22:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T22:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T22:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T22:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T22:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T22:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T22:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T22:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T22:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T22:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T22:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T22:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T22:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T22:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T22:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T22:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T22:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T22:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T23:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T23:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T23:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T23:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T23:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T23:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T23:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T23:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T23:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T23:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T23:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T23:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T23:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T23:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T23:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T23:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T23:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T23:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T23:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T23:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T23:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T23:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T23:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T23:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T23:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T23:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T23:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T23:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T23:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T23:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T23:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T23:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T23:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T23:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T23:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T23:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T23:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T23:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T23:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T23:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-26T23:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T23:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T23:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-26T23:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-26T23:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T00:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T00:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T00:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T00:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T00:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T00:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T00:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T00:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T00:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T00:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T00:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T00:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T00:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T00:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T00:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T00:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T00:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T00:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T00:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T00:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T00:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T00:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T00:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T00:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T00:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T01:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T01:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T01:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T01:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T01:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T01:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T01:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T01:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T01:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T01:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T01:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T01:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T01:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T01:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T01:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T01:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T01:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T01:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T01:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T01:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T01:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T01:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T01:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T01:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T01:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T01:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T01:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T01:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T01:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T02:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T02:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T02:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T02:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T02:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T02:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T02:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T02:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T02:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T02:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T02:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T02:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T02:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T02:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T02:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T02:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T02:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T02:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T02:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T02:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T02:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T02:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T02:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T02:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T02:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T02:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T02:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T02:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T02:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T02:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T02:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T02:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T02:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T03:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T03:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T03:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T03:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T03:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T03:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T03:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T03:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T03:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T03:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T03:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T03:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T03:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T03:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T03:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T03:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T03:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T03:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T03:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T03:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T03:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T03:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T03:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T03:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T03:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T03:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T03:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T03:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T03:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T03:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T03:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T03:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T03:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T03:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T04:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T04:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T04:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T04:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T04:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T04:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T04:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T04:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T04:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T04:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T04:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T04:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T04:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T04:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T04:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T04:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T04:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T04:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T04:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T04:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T04:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T04:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T04:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T04:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T04:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T04:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T04:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T04:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T04:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T04:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T04:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T04:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T04:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T04:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T04:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T04:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T04:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T04:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T04:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T04:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T05:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T05:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T05:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T05:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T05:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T05:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T05:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T05:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T05:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T05:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T05:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T05:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T05:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T05:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T05:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T05:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T05:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T05:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T05:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T05:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T05:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T05:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T05:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T05:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T05:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T05:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T05:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T05:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T05:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T05:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T05:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T05:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T05:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T05:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T06:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T06:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T06:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T06:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T06:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T06:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T06:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T06:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T06:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T06:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T06:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T06:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T06:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T06:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T06:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T06:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T06:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T06:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T06:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T06:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T06:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T06:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T06:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T06:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T06:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T06:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T06:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T06:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T06:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T06:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T06:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T06:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T06:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T06:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T06:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T06:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T06:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T07:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T07:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T07:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T07:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T07:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T07:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T07:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T07:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T07:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T07:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T07:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T07:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T07:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T07:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T07:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T07:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T07:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T07:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T07:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T07:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T07:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T07:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T07:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T07:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T07:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T07:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T07:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T07:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T07:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T07:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T08:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T08:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T08:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T08:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T08:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T08:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T08:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T08:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T08:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T08:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T08:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T08:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T08:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T08:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T08:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T08:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T08:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T08:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T08:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T08:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T08:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T08:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T08:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T08:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T08:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T09:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T09:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T09:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T09:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T09:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T09:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T09:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T09:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T09:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T09:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T09:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T09:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T09:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T09:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T09:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T09:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T09:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T09:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T09:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T09:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T09:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T09:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T09:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T09:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T09:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T09:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T09:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T09:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T09:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T09:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T10:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T10:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T10:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T10:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T10:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T10:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T10:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T10:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T10:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T10:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T10:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T10:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T10:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T10:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T10:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T10:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T10:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T10:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T10:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T10:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T10:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T10:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T10:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T10:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T10:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T10:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T10:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T10:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T10:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T10:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T10:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T11:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T11:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T11:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T11:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T11:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T11:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T11:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T11:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T11:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T11:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T11:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T11:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T11:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T11:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T11:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T11:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T11:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T11:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T11:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T11:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T11:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T11:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T11:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T11:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T11:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T11:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T11:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T12:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T12:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T12:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T12:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T12:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T12:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T12:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T12:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T12:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T12:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T12:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T12:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T12:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T12:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T12:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T12:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T12:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T12:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T12:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T12:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T12:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T12:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T12:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T12:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T12:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T12:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T12:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T12:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T12:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T12:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T12:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T12:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T12:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T13:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T13:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T13:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T13:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T13:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T13:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T13:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T13:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T13:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T13:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T13:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T13:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T13:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T13:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T13:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T13:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T13:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T13:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T13:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T13:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T13:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T13:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T13:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T13:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T13:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T13:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T13:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T13:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T13:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T13:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T13:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T13:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T13:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T13:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T14:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T14:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T14:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T14:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T14:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T14:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T14:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T14:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T14:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T14:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T14:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T14:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T14:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T14:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T14:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T14:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T14:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T14:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T14:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T14:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T14:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T14:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T14:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T14:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T14:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T14:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T14:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T14:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T14:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T14:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T14:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T14:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T14:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T14:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T14:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T14:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T14:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T14:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T15:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T15:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T15:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T15:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T15:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T15:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T15:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T15:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T15:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T15:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T15:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T15:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T15:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T15:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T15:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T15:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T15:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T15:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T15:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T15:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T15:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T15:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T15:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T15:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T15:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T15:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T15:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T15:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T15:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T15:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T15:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T15:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T15:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T15:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T15:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T15:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T15:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T15:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T15:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T15:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T15:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T15:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T16:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T16:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T16:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T16:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T16:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T16:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T16:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T16:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T16:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T16:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T16:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T16:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T16:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T16:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T16:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T16:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T16:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T16:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T16:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T16:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T17:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T17:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T17:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T17:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T17:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T17:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T17:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T17:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T17:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T17:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T17:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T17:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T17:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T17:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T17:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T17:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T17:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T17:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T17:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T17:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T17:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T17:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T17:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T17:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T17:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T18:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T18:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T18:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T18:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T18:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T18:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T18:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T18:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T18:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T18:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T18:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T18:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T18:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T18:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T18:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T18:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T18:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T18:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T18:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T18:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T18:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T18:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T18:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T18:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T18:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T18:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T18:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T18:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T18:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T18:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T19:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T19:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T19:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T19:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T19:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T19:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T19:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T19:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T19:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T19:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T19:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T19:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T19:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T19:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T19:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T19:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T19:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T19:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T19:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T19:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T19:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T19:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T19:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T19:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T19:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T19:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T19:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T19:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T19:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T19:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T19:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T19:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T19:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T19:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T19:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T19:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T19:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T20:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T20:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T20:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T20:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T20:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T20:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T20:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T20:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T20:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T20:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T20:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T20:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T20:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T20:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T20:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T20:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T20:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T20:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T20:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T20:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T20:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T20:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T20:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T20:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T20:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T20:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T20:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T20:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T20:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T20:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T20:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T20:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T20:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T20:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T21:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T21:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T21:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T21:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T21:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T21:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T21:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T21:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T21:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T21:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T21:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T21:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T21:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T21:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T21:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T21:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T21:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T21:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T21:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T21:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T21:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T21:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T21:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T21:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T21:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T21:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T21:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T21:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T21:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T21:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T22:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T22:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T22:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T22:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T22:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T22:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T22:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T22:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T22:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T22:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T22:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T22:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T22:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T22:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T22:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T22:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T22:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T22:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T22:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T22:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T22:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T22:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T22:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T22:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T22:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T22:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T22:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T22:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T22:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T22:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T22:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T22:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T22:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T23:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T23:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T23:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T23:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T23:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T23:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T23:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T23:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T23:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T23:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T23:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T23:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T23:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T23:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T23:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T23:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T23:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T23:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T23:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T23:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T23:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T23:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T23:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T23:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-27T23:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T23:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-27T23:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-27T23:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T00:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T00:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T00:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T00:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T00:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T00:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T00:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T00:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T00:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T00:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T00:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T00:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T00:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T00:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T00:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T00:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T00:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T00:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T00:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T00:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T00:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T00:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T00:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T00:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T00:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T00:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T01:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T01:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T01:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T01:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T01:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T01:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T01:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T01:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T01:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T01:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T01:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T01:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T01:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T01:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T01:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T01:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T01:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T01:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T01:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T01:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T01:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T01:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T01:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T01:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T01:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T01:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T01:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T01:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T01:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T01:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T01:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T01:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T01:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T01:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T01:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T01:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T01:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T01:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T02:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T02:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T02:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T02:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T02:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T02:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T02:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T02:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T02:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T02:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T02:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T02:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T02:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T02:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T02:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T02:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T02:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T02:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T02:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T02:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T02:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T02:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T02:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T02:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T02:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T02:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T02:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T02:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T02:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T02:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T02:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T02:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T02:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T02:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T03:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T03:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T03:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T03:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T03:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T03:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T03:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T03:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T03:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T03:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T03:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T03:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T03:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T03:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T03:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T03:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T03:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T03:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T03:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T03:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T03:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T03:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T03:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T04:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T04:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T04:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T04:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T04:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T04:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T04:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T04:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T04:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T04:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T04:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T04:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T04:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T04:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T04:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T04:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T04:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T04:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T04:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T04:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T04:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T04:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T04:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T04:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T05:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T05:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T05:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T05:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T05:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T05:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T05:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T05:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T05:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T05:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T05:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T05:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T05:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T05:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T05:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T05:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T05:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T05:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T05:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T05:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T05:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T05:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T05:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T05:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T05:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T05:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T05:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T05:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T05:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T05:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T05:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T05:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T05:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T05:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T05:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T06:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T06:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T06:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T06:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T06:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T06:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T06:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T06:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T06:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T06:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T06:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T06:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T06:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T06:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T06:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T06:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T06:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T06:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T06:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T06:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T06:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T06:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T06:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T06:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T06:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T06:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T06:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T06:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T06:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T06:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T06:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T06:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T07:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T07:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T07:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T07:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T07:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T07:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T07:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T07:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T07:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T07:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T07:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T07:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T07:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T07:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T07:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T07:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T07:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T07:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T07:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T07:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T07:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T07:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T07:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T07:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T07:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T07:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T07:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T07:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T07:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T07:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T07:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T07:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T07:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T07:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T07:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T07:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T07:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T07:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T08:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T08:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T08:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T08:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T08:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T08:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T08:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T08:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T08:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T08:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T08:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T08:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T08:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T08:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T08:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T08:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T08:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T08:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T08:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T08:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T08:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T08:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T08:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T08:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T08:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T08:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T08:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T08:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T08:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T08:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T08:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T08:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T08:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T09:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T09:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T09:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T09:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T09:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T09:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T09:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T09:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T09:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T09:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T09:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T09:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T09:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T09:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T09:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T09:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T09:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T09:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T09:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T09:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T09:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T09:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T09:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T09:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T09:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T09:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T09:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T09:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T09:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T09:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T09:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T09:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T09:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T09:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T09:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T09:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T09:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T09:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T09:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T09:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T09:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T10:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T10:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T10:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T10:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T10:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T10:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T10:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T10:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T10:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T10:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T10:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T10:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T10:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T10:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T10:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T10:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T10:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T10:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T10:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T10:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T10:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T10:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T10:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T10:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T10:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T10:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T10:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T10:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T10:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T10:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T10:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T10:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T10:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T10:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T10:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T11:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T11:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T11:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T11:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T11:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T11:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T11:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T11:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T11:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T11:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T11:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T11:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T11:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T11:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T11:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T11:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T11:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T11:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T11:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T11:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T11:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T11:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T11:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T11:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T11:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T11:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T11:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T11:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T11:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T11:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T11:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T11:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T11:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T11:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T11:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T11:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T11:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T12:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T12:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T12:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T12:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T12:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T12:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T12:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T12:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T12:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T12:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T12:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T12:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T12:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T12:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T12:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T12:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T12:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T12:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T12:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T12:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T12:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T12:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T12:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T12:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T12:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T12:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T12:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T12:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T12:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T12:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T12:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T12:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T12:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T12:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T12:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T12:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T12:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T12:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T12:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T13:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T13:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T13:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T13:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T13:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T13:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T13:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T13:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T13:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T13:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T13:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T13:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T13:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T13:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T13:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T13:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T13:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T13:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T13:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T13:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T13:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T13:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T13:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T14:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T14:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T14:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T14:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T14:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T14:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T14:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T14:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T14:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T14:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T14:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T14:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T14:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T14:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T14:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T14:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T14:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T14:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T14:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T14:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T14:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T14:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T14:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T14:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T14:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T14:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T14:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T14:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T15:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T15:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T15:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T15:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T15:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T15:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T15:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T15:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T15:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T15:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T15:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T15:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T15:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T15:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T15:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T15:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T15:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T15:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T15:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T15:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T15:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T15:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T15:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T15:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T15:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T15:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T15:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T15:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T15:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T16:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T16:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T16:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T16:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T16:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T16:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T16:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T16:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T16:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T16:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T16:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T16:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T16:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T16:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T16:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T16:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T16:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T16:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T16:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T16:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T16:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T16:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T16:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T16:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T16:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T16:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T16:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T16:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T16:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T16:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T16:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T16:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T16:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T17:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T17:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T17:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T17:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T17:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T17:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T17:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T17:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T17:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T17:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T17:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T17:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T17:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T17:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T17:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T17:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T17:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T17:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T17:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T17:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T17:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T17:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T17:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T17:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T17:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T17:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T17:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T17:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T17:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T17:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T17:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T17:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T17:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T17:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T17:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T17:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T18:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T18:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T18:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T18:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T18:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T18:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T18:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T18:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T18:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T18:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T18:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T18:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T18:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T18:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T18:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T18:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T18:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T18:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T18:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T18:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T18:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T18:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T18:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T18:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T18:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T18:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T18:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T18:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T18:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T19:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T19:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T19:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T19:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T19:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T19:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T19:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T19:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T19:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T19:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T19:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T19:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T19:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T19:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T19:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T19:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T19:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T19:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T19:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T19:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T19:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T19:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T19:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T19:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T19:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T19:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T19:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T19:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T19:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T19:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T20:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T20:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T20:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T20:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T20:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T20:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T20:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T20:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T20:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T20:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T20:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T20:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T20:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T20:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T20:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T20:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T20:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T20:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T20:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T20:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T20:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T20:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T20:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T20:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T20:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T20:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T20:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T20:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T21:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T21:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T21:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T21:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T21:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T21:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T21:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T21:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T21:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T21:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T21:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T21:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T21:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T21:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T21:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T21:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T21:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T21:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T21:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T21:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T21:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T21:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T21:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T21:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T21:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T21:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T21:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T21:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T21:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T21:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T21:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T22:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T22:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T22:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T22:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T22:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T22:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T22:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T22:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T22:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T22:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T22:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T22:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T22:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T22:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T22:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T22:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T22:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T22:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T22:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T22:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T22:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T22:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T22:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T22:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T22:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T22:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T22:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T22:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T22:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T22:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T22:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T22:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T22:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T22:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T22:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T22:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T22:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T23:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T23:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T23:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T23:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T23:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T23:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T23:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T23:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T23:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T23:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T23:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T23:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T23:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T23:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T23:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T23:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T23:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T23:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T23:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T23:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T23:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T23:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T23:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T23:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T23:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T23:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T23:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-28T23:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-28T23:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-28T23:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T00:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T00:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T00:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T00:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T00:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T00:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T00:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T00:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T00:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T00:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T00:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T00:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T00:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T00:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T00:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T00:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T00:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T00:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T00:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T00:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T00:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T00:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T00:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T00:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T00:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T00:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T00:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T00:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T00:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T01:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T01:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T01:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T01:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T01:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T01:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T01:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T01:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T01:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T01:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T01:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T01:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T01:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T01:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T01:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T01:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T01:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T01:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T01:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T01:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T01:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T01:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T01:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T01:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T01:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T01:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T01:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T01:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T01:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T01:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T01:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T01:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T01:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T02:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T02:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T02:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T02:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T02:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T02:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T02:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T02:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T02:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T02:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T02:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T02:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T02:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T02:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T02:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T02:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T02:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T02:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T02:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T02:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T02:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T02:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T02:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T02:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T02:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T02:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T03:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T03:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T03:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T03:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T03:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T03:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T03:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T03:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T03:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T03:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T03:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T03:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T03:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T03:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T03:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T03:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T03:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T03:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T03:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T03:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T03:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T03:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T03:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T03:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T03:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T03:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T03:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T03:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T03:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T03:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T03:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T03:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T03:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T03:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T03:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T03:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T03:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T03:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T03:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T03:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T04:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T04:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T04:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T04:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T04:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T04:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T04:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T04:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T04:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T04:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T04:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T04:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T04:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T04:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T04:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T04:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T04:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T04:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T04:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T04:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T04:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T04:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T04:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T04:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T04:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T04:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T04:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T04:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T04:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T04:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T04:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T05:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T05:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T05:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T05:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T05:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T05:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T05:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T05:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T05:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T05:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T05:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T05:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T05:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T05:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T05:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T05:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T05:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T05:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T05:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T05:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T05:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T05:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T05:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T05:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T05:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T05:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T05:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T05:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T05:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T05:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T05:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T05:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T05:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T05:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T05:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T05:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T05:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T05:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T05:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T05:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T05:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T05:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T05:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T06:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T06:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T06:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T06:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T06:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T06:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T06:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T06:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T06:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T06:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T06:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T06:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T06:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T06:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T06:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T06:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T06:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T06:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T06:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T06:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T06:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T06:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T06:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T06:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T06:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T06:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T06:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T06:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T06:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T06:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T06:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T06:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T06:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T07:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T07:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T07:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T07:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T07:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T07:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T07:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T07:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T07:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T07:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T07:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T07:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T07:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T07:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T07:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T07:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T07:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T07:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T07:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T07:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T07:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T07:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T07:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T07:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T07:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T07:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T07:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T07:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T07:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T08:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T08:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T08:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T08:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T08:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T08:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T08:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T08:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T08:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T08:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T08:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T08:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T08:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T08:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T08:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T08:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T08:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T08:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T08:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T08:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T08:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T08:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T08:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T08:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T08:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T08:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T08:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T08:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T08:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T08:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T09:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T09:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T09:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T09:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T09:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T09:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T09:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T09:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T09:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T09:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T09:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T09:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T09:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T09:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T09:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T09:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T09:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T09:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T09:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T09:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T09:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T09:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T09:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T09:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T09:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T09:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T09:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T09:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T09:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T09:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T09:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T09:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T09:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T09:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T09:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T09:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T09:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T09:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T09:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T09:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T09:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T09:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T09:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T09:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T10:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T10:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T10:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T10:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T10:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T10:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T10:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T10:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T10:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T10:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T10:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T10:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T10:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T10:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T10:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T10:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T10:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T10:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T10:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T10:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T10:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T10:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T10:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T10:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T10:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T10:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T10:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T10:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T10:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T10:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T10:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T10:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T10:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T11:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T11:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T11:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T11:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T11:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T11:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T11:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T11:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T11:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T11:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T11:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T11:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T11:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T11:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T11:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T11:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T11:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T11:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T11:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T11:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T11:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T11:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T11:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T11:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T11:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T11:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T11:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T11:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T11:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T12:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T12:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T12:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T12:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T12:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T12:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T12:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T12:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T12:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T12:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T12:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T12:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T12:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T12:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T12:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T12:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T12:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T12:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T12:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T12:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T12:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T12:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T12:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T12:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T12:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T12:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T12:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T12:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T12:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T12:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T12:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T12:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T12:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T12:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T13:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T13:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T13:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T13:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T13:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T13:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T13:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T13:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T13:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T13:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T13:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T13:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T13:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T13:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T13:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T13:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T13:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T13:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T13:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T13:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T13:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T13:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T13:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T13:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T13:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T13:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T13:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T13:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T13:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T13:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T14:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T14:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T14:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T14:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T14:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T14:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T14:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T14:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T14:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T14:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T14:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T14:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T14:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T14:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T14:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T14:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T14:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T14:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T14:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T14:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T14:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T14:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T14:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T14:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T14:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T14:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T14:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T14:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T14:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T14:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T14:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T14:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T14:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T14:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T14:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T14:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T14:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T15:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T15:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T15:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T15:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T15:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T15:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T15:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T15:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T15:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T15:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T15:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T15:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T15:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T15:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T15:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T15:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T15:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T15:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T15:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T15:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T15:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T15:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T15:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T15:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T15:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T15:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T15:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T15:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T15:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T15:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T15:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T15:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T15:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T15:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T16:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T16:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T16:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T16:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T16:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T16:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T16:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T16:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T16:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T16:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T16:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T16:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T16:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T16:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T16:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T16:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T16:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T16:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T16:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T16:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T16:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T16:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T16:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T16:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T16:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T16:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T16:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T16:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T16:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T16:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T16:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T16:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T16:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T17:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T17:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T17:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T17:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T17:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T17:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T17:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T17:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T17:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T17:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T17:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T17:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T17:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T17:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T17:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T17:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T17:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T17:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T17:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T17:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T17:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T17:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T17:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T17:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T17:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T17:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T17:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T18:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T18:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T18:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T18:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T18:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T18:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T18:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T18:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T18:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T18:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T18:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T18:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T18:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T18:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T18:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T18:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T18:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T18:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T18:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T18:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T18:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T18:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T18:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T18:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T18:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T18:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T18:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T18:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T18:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T18:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T18:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T19:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T19:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T19:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T19:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T19:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T19:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T19:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T19:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T19:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T19:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T19:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T19:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T19:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T19:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T19:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T19:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T19:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T19:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T19:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T19:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T19:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T19:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T19:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T19:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T19:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T19:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T19:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T19:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T19:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T19:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T19:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T20:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T20:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T20:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T20:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T20:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T20:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T20:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T20:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T20:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T20:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T20:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T20:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T20:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T20:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T20:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T20:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T20:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T20:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T20:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T20:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T20:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T20:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T20:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T20:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T20:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T20:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T20:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T20:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T20:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T20:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T20:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T20:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T20:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T20:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T20:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T20:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T20:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T20:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T20:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T21:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T21:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T21:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T21:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T21:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T21:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T21:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T21:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T21:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T21:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T21:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T21:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T21:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T21:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T21:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T21:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T21:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T21:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T21:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T21:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T21:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T21:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T21:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T21:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T21:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T21:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T21:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T21:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T21:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T21:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T21:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T21:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T22:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T22:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T22:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T22:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T22:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T22:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T22:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T22:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T22:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T22:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T22:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T22:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T22:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T22:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T22:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T22:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T22:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T22:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T22:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T22:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T22:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T22:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T22:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T22:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T22:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T22:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T22:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T22:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T22:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T22:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T22:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T22:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T22:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T22:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T22:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T22:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T22:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T22:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T22:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T22:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T23:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T23:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T23:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T23:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T23:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T23:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T23:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T23:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T23:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T23:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T23:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T23:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T23:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T23:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T23:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T23:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T23:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T23:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T23:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T23:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T23:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T23:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T23:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-29T23:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-29T23:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-29T23:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T00:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T00:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T00:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T00:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T00:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T00:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T00:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T00:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T00:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T00:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T00:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T00:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T00:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T00:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T00:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T00:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T00:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T00:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T00:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T00:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T00:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T00:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T00:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T00:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T00:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T00:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T00:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T00:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T00:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T00:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T00:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T00:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T00:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T00:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T00:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T00:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T00:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T00:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T01:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T01:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T01:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T01:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T01:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T01:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T01:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T01:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T01:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T01:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T01:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T01:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T01:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T01:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T01:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T01:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T01:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T01:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T01:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T01:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T01:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T01:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T01:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T01:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T01:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T01:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T01:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T02:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T02:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T02:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T02:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T02:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T02:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T02:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T02:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T02:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T02:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T02:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T02:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T02:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T02:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T02:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T02:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T02:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T02:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T02:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T02:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T02:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T02:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T02:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T02:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T02:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T02:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T02:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T02:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T02:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T03:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T03:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T03:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T03:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T03:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T03:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T03:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T03:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T03:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T03:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T03:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T03:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T03:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T03:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T03:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T03:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T03:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T03:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T03:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T03:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T03:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T03:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T03:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T03:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T03:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T03:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T03:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T03:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T03:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T03:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T03:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T03:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T03:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T04:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T04:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T04:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T04:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T04:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T04:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T04:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T04:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T04:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T04:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T04:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T04:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T04:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T04:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T04:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T04:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T04:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T04:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T04:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T04:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T04:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T04:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T04:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T04:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T04:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T04:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T04:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T04:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T04:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T04:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T05:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T05:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T05:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T05:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T05:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T05:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T05:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T05:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T05:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T05:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T05:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T05:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T05:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T05:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T05:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T05:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T05:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T05:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T05:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T05:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T05:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T05:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T05:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T05:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T05:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T05:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T05:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T05:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T05:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T05:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T05:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T05:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T05:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T05:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T05:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T06:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T06:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T06:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T06:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T06:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T06:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T06:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T06:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T06:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T06:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T06:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T06:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T06:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T06:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T06:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T06:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T06:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T06:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T06:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T06:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T06:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T06:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T06:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T06:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T06:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T06:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T06:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T06:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T06:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T06:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T06:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T06:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T06:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T06:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T06:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T06:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T06:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T06:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T06:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T07:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T07:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T07:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T07:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T07:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T07:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T07:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T07:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T07:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T07:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T07:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T07:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T07:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T07:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T07:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T07:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T07:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T07:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T07:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T07:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T07:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T07:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T07:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T07:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T07:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T07:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T07:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T07:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T07:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T07:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T08:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T08:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T08:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T08:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T08:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T08:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T08:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T08:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T08:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T08:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T08:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T08:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T08:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T08:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T08:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T08:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T08:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T08:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T08:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T08:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T08:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T08:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T08:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T08:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T08:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T08:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T08:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T08:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T08:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T08:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T08:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T08:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T08:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T08:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T08:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T08:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T08:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T08:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T08:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T08:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T09:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T09:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T09:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T09:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T09:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T09:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T09:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T09:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T09:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T09:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T09:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T09:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T09:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T09:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T09:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T09:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T09:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T09:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T09:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T09:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T09:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T09:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T09:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T09:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T09:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T09:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T09:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T09:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T09:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T09:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T09:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T09:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T09:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T09:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T10:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T10:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T10:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T10:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T10:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T10:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T10:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T10:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T10:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T10:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T10:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T10:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T10:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T10:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T10:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T10:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T10:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T10:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T10:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T10:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T10:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T10:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T10:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T10:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T10:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T10:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T10:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T10:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T10:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T10:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T10:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T10:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T10:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T10:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T11:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T11:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T11:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T11:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T11:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T11:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T11:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T11:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T11:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T11:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T11:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T11:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T11:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T11:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T11:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T11:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T11:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T11:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T11:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T11:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T11:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T11:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T11:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T11:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T11:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T11:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T11:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T11:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T11:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T11:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T12:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T12:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T12:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T12:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T12:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T12:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T12:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T12:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T12:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T12:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T12:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T12:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T12:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T12:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T12:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T12:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T12:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T12:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T12:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T12:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T12:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T12:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T12:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T12:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T12:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T12:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T12:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T12:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T12:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T12:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T12:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T12:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T12:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T12:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T12:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T12:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T12:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T12:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T12:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T12:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T13:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T13:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T13:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T13:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T13:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T13:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T13:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T13:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T13:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T13:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T13:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T13:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T13:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T13:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T13:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T13:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T13:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T13:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T13:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T13:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T13:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T13:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T13:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T13:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T13:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T13:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T13:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T13:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T13:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T13:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T13:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T13:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T13:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T13:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T13:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T14:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T14:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T14:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T14:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T14:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T14:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T14:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T14:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T14:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T14:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T14:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T14:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T14:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T14:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T14:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T14:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T14:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T14:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T14:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T14:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T14:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T14:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T14:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T14:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T14:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T15:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T15:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T15:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T15:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T15:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T15:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T15:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T15:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T15:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T15:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T15:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T15:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T15:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T15:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T15:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T15:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T15:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T15:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T15:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T15:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T15:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T15:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T15:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T15:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T15:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T15:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T15:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T15:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T15:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T15:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T15:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T15:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T15:46:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T15:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T15:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T15:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T15:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T15:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T15:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T15:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T15:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T16:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T16:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T16:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T16:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T16:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T16:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T16:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T16:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T16:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T16:22:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T16:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T16:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T16:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T16:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T16:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T16:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T16:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T16:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T16:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T16:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T16:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T16:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T16:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T16:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T16:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T16:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T16:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T16:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T16:58:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T16:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T17:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T17:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T17:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T17:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T17:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T17:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T17:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T17:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T17:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T17:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T17:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T17:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T17:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T17:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T17:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T17:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T17:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T17:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:36:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:38:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T17:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T17:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T17:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T17:52:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T17:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T17:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T17:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T18:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T18:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T18:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T18:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T18:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T18:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T18:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 2,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T18:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T18:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T18:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T18:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T18:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T18:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T18:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:22:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T18:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T18:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T18:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T18:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T18:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:32:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T18:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T18:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T18:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T18:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T18:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T18:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T18:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T18:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T18:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T18:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T18:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T18:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T18:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T18:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T19:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T19:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T19:04:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T19:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T19:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T19:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T19:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T19:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T19:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T19:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T19:18:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T19:20:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T19:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T19:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T19:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T19:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T19:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T19:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:28:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T19:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:30:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T19:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T19:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T19:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T19:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T19:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T19:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T19:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T19:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T19:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T19:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T19:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:48:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T19:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T19:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T19:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T19:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "pilotUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T19:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T19:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T19:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T19:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T19:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T20:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:02:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T20:02:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:04:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T20:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T20:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T20:12:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T20:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T20:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T20:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T20:14:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T20:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:18:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:20:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:22:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T20:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T20:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:30:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T20:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T20:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:36:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T20:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T20:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:38:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T20:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T20:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:40:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:42:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T20:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T20:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T20:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T20:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T20:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T20:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T20:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T21:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T21:06:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T21:08:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T21:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T21:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:10:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:12:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:14:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:14:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T21:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T21:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:18:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 3,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T21:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:20:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 0,
                "refData": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T21:22:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 0,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:26:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:26:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T21:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:28:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 0,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T21:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T21:32:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:32:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 2,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:36:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T21:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T21:36:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T21:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 3,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T21:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T21:38:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T21:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:42:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T21:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T21:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T21:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:48:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T21:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T21:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "refData": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 4,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T21:50:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T21:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T21:52:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T21:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T21:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T21:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T21:58:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 3,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T22:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "pilotUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "refData": 0,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:02:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T22:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T22:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T22:04:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:06:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:06:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:08:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:08:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 0,
                "pilotUpdates": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T22:10:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 3,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T22:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T22:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:12:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T22:14:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "terminalUpdates": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:16:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T22:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:18:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T22:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T22:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T22:24:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:24:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T22:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T22:26:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 4,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T22:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 1,
                "refData": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T22:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 4,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T22:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T22:28:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T22:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T22:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 0,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:32:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T22:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 2,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:34:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "pilotUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:34:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:34:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T22:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 3,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T22:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 0,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T22:38:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:40:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 2,
                "refData": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 4,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T22:42:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 4,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T22:44:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 0,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T22:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 4,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:46:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T22:46:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "terminalUpdates": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T22:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 3,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:52:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:54:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 4,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T22:54:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 3,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T22:56:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "terminalUpdates": 1,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 2,
                "pilotUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T22:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T22:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 1,
                "pilotUpdates": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T22:58:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T23:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:00:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T23:00:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T23:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T23:02:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:02:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 2,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 3,
                "refData": 1,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:04:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:04:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "terminalUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T23:06:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:06:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "refData": 4,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T23:08:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 3,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:08:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:10:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 3,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T23:10:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 3,
                "terminalUpdates": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:10:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:12:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 2,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T23:12:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:14:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:16:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 1,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T23:16:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T23:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 3,
                "refData": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T23:16:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 4,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:16:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T23:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 4,
                "terminalUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T23:18:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "refData": 2,
                "visit": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T23:20:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:20:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 4,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:22:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 1,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:24:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "refData": 2,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:24:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "terminalUpdates": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T23:24:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 0,
                "refData": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T23:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 0,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "refData": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:26:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "pilotUpdates": 0,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T23:26:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "commercialRelease": 3,
                "pilotUpdates": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T23:28:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:28:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T23:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 3,
                "terminalUpdates": 3,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T23:30:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:30:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 2,
                "visit": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T23:30:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 2
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T23:32:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "visit": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T23:34:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "refData": 3,
                "terminalUpdates": 3
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T23:34:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 2,
                "visit": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T23:36:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:38:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T23:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 4
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T23:40:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 0,
                "terminalUpdates": 2
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T23:40:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:40:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "pilotUpdates": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 4,
                "visit": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T23:42:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:42:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 1,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T23:44:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 4,
                "refData": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:44:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:44:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 2,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:44:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "terminalUpdates": 2,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:46:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 4,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:46:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 3,
                "refData": 1
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T23:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "refData": 2,
                "visit": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:48:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 4,
                "refData": 1
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T23:48:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 4,
                "pilotUpdates": 1,
                "refData": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T23:48:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 4,
                "terminalUpdates": 3,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:50:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 3,
                "refData": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:50:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 1,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T23:50:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 1,
                "refData": 4,
                "terminalUpdates": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:50:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 3,
                "refData": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:52:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 0,
                "terminalUpdates": 3,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:52:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 1,
                "pilotUpdates": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:54:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "commercialRelease": 4,
                "pilotUpdates": 0
            },
            "organisation": "PORTXCHANGE",
            "timestamp": "2023-05-30T23:54:00.000Z",
            "user": "test@PORTXCHANGE"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "terminalUpdates": 2,
                "visit": 2
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:54:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "commercialRelease": 2,
                "terminalUpdates": 4,
                "visit": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:56:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 1,
                "refData": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "pilotUpdates": 2,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:56:00.000Z",
            "user": "CARGOSYS@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "commercialRelease": 2,
                "terminalUpdates": 0
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:56:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "refData": 4,
                "terminalUpdates": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T23:56:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "refData": 1,
                "terminalUpdates": 1,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 4,
                "terminalUpdates": 0,
                "visit": 0
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T23:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "commercialRelease": 0,
                "visit": 1
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-30T23:58:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 2,
                "pilotUpdates": 2,
                "refData": 3
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-30T23:58:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 1,
                "pilotUpdates": 1,
                "terminalUpdates": 3
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-31T00:00:00.000Z",
            "user": "bezoekschip-service@PORTINFOLINK"
        },
        {
            "countPerUpdateType": {
                "accountManagement": 0,
                "refData": 3,
                "terminalUpdates": 4
            },
            "organisation": "HBRRTM",
            "timestamp": "2023-05-31T00:00:00.000Z",
            "user": "hamisprod@HBRRTM"
        },
        {
            "countPerUpdateType": {
                "pilotUpdates": 2,
                "refData": 0,
                "visit": 4
            },
            "organisation": "PORTINFOLINK",
            "timestamp": "2023-05-31T00:00:00.000Z",
            "user": "hinterland-service@PORTINFOLINK"
        }
    ],
    "lastMatch": {
        "timestamp": 1683896660501
    }
}